export const itLangDashboard = {
  headerSearch: {
    placeholder: 'Cerca prodotti',
    cancel: 'Annulla',
    empty: 'Nessun prodotto trovato',
    noShop: 'Ancora nessun prodotto da cercare',
  },
  common: {
    you: 'Tu',
    post: 'Post',
    article: 'Articolo',
    create: 'Crea',
    message: 'Messaggio',
    popular: 'Popolare',
    emptyIntegrations: 'Devi prima aggiungere le integrazioni',
    categories: 'Categorie',
    edit: 'Modifica',
    share: 'Condividi',
    plan: 'Piano',
    sort: 'Ordina',
    addArticle: 'Aggiungi articolo',
    articles: 'Articoli',
    users: 'utenti',
    scans: 'scansioni',
    clicks: 'clic',
    copy: 'Copia',
    customize: 'Personalizza',
    link: 'link',
    save: 'Salva',
    uploadFile: 'Carica file',
    customImage: 'Immagine personalizzata',
    customImageTooltip: 'Carica immagine personalizzata',
    size: 'Dimensione',
    sizeTooltip: 'Trascina il cursore per impostare la dimensione',
    auto: 'Auto',
    rectangle: 'Rettangolo',
    custom: 'Personalizzato',
    clean: 'Pulisci',
    cleaning: 'Pulizia in corso',
    download: 'Scarica',
    downloading: 'Download in corso',
    preview: 'ANTEPRIMA',
    cover: 'Copertina',
    coverTooltip: 'Carica una foto di copertina',
    title: 'Titolo',
    new: 'Nuovo',
    pro: 'Pro',
    free: 'Gratis',
    limit: 'Limite',
    websites: 'siti web',
    site: 'Sito',
    apiKey: 'API Key',
    name: 'Nome',
    passwordChange: 'Cambio password',
    draft: 'Bozza',
    page: 'Pagina',
    areYouSure: 'Sei sicuro?',
    drop: 'Rilascia',
    video: 'video',
    image: 'immagine',
    chooseFile: 'Scegli file',
    nothingFound: 'Nessun risultato',
    enterCorrectLink: 'Inserisci un link corretto',
    off: 'Off',
    disconnect: 'DISCONNETTI',
    connect: 'CONNETTI',
    copied: 'Copiato',
    saved: 'Salvato',
    lostConnection: 'Connessione persa',
    addedCategory: 'Categoria aggiunta',
    none: 'Nessuno',
    left: 'Sinistra',
    right: 'Destra',
    solid: 'Pieno',
    double: 'Doppio',
    welcome: 'Benvenuto',
    category: 'Categoria',
    product: 'Prodotto',
    website: 'Sito web',
    items: 'Elementi',
    square: 'Quadrato',
    round: 'Tondo',
    border: 'Bordo',
    shadow: 'Ombra',
    subtle: 'Sottile',
    soft: 'Morbido',
    hard: 'Duro',
    block: 'Blocco',
    primary: 'Primario',
    additional: 'Aggiuntivo',
    normal: 'Normale',
    bold: 'Grassetto',
    uploadVideo: 'Carica video',
    compact: 'Compatto',
    card: 'Scheda',
    top: 'Alto',
    center: 'Centro',
    bottom: 'Basso',
    button: 'Pulsante',
    addNewItem: 'Aggiungi nuovo elemento',
    price: 'Prezzo',
    priceCaption: 'Aggiungi il prezzo del tuo prodotto',
    oldPrice: 'Prezzo vecchio',
    oldPriceCaption: 'Il prezzo vecchio sarà barrato',
    areYouSureDeleteItem: 'Sei sicuro di voler rimuovere questo elemento?',
    add: 'Aggiungi',
    active: 'Attivo',
    isActive: 'è attivo',
    isDisabled: 'è disattivato',
    uploadImage: 'Carica immagine',
    design: 'Design',
    addAccount: 'Aggiungi account',
    hey: 'Ciao',
    activeBackground: 'Sfondo attivo',
    activeText: 'Testo attivo',
    connectDomain: 'Connetti dominio',
    shortLink: 'Link breve',
    appearanceSaved: 'Aspetto salvato!',
    blockAdded: 'Blocco aggiunto!',
    comingSoon: 'Prossimamente',
    easyMoney: 'Soldi facili',
    content: 'Contenuto',
    audience: 'Pubblico',
    view: 'Visualizza',
    delete: 'Elimina',
    file: 'File',
    type: 'Tipo',
    from: 'Da',
    to: 'A',
    fullName: 'Nome completo',
    lastTimeUsed: 'Ultimo utilizzo',
    noMediaFiles: 'Nessun file multimediale...',
    withdraw: 'Preleva',
    congrats: 'Congratulazioni!',
    makeMoneyOnline: 'Guadagna online!',
    thin: 'Sottile',
    blockEmptyTitle: 'Ancora niente qui',
    blockEmptyText: 'Questo blocco non ha ancora elementi. Aggiungine uno per vederlo sulla tua pagina.',
    noItemsTitle: 'Non hai ancora elementi',
    noItemsText: 'Aggiungi il tuo primo elemento per riempire questo blocco.',
  },
  sort: {
    title: 'Ordina',
    search: 'Cerca',
    default: 'Ordinamento predefinito',
    dateNew: 'Data: dal più recente al meno recente',
    dateOld: 'Data: dal meno recente al più recente',
    priceLow: 'Prezzo: dal più basso al più alto',
    priceHigh: 'Prezzo: dal più alto al più basso',
    nameA: 'Nome: dalla A alla Z',
    nameZ: 'Nome: dalla Z alla A',
    popular: 'Più popolari',
  },
  emailMenu: {
    broadcasts: 'Broadcast',
    automations: 'Automazioni',
    templates: 'Modelli',
    log: 'Registro',
    settings: 'Impostazioni',
    noEmails: 'Nessuna email',
    newBroadcast: 'Nuovi broadcast',
  },
  aiContent: {
    title: 'Crea il tuo primo contenuto AI!',
    text: 'Pianifica e pubblica contenuti su tutti i social media in una volta!',
    create: 'Crea contenuto AI',
  },
  pageDesign: {
    page: 'Design pagina',
    image: 'Immagine',
  },
  toolsMenu: {
    title: 'Strumenti',
    account: 'Account',
    instantPages: 'Instant Pages',
    instantPagesText: 'Pagine autonome a caricamento rapido',
    agents: 'Agenti',
    agentsText: 'Assistenti AI che gestiscono il tuo profilo',
    socialPlanner: 'Social Planner',
    socialPlannerText: 'Pianificazione contenuti e ispirazione',
    emailMarketing: 'Email Marketing',
    emailMarketingText: 'Fai crescere la tua lista di contatti',
    smartReply: 'Instagram Reply',
    smartReplyText: 'Invia commenti e messaggi automatici',
    linkShortener: 'Short Links',
    linkShortenerText: 'Accorcia URL lunghi',
    posts: 'Post',
    postsText: 'Crea e gestisci i post',
    blog: 'Blog',
    blogText: 'Crea e gestisci articoli del blog',
  },
  insideMenu: {
    planner: 'Planner',
    aiContent: 'Contenuti AI',
    aiPosts: 'Post AI',
    postIdeas: 'Idee per i post',
    contentPlanner: 'Content Planner',
    aiImages: 'Immagini AI',
    brandProjects: 'Brand Identity',
    aiVideo: 'Video AI',
    integrations: 'Integrazioni',
    products: 'Prodotti',
    orders: 'Ordini',
    payments: 'Pagamenti',
    links: 'Link',
    qrCodes: 'QR Code',
    adBuilder: 'Creatore di annunci',
  },
  orders: {
    title: 'Ordini',
    empty: 'Non hai ancora nessun ordine',
    all: 'Tutti gli ordini',
    shop: 'Negozio',
    digital: 'Prodotti digitali',
    appointments: 'Appuntamenti',
    services: 'Servizi',
    donations: 'Donazioni',
  },
  discounts: {
    title: 'Sconti',
    newDiscount: '+ Nuovo sconto',
    code: 'Codice',
    titleCol: 'Titolo',
    type: 'Tipo',
    value: 'Valore',
    status: 'Stato',
    used: 'Utilizzato',
    actions: 'Azioni',
    statusAll: 'Tutti gli stati',
    statusActive: 'Attivo',
    statusExpired: 'Scaduto',
    statusScheduled: 'Programmato',
    statusInactive: 'Inattivo',
    searchPlaceholder: 'Cerca per codice o titolo...',
    clearFilters: 'Cancella filtri',
    emptyTitle: 'Nessuno sconto',
    emptySubtitle: 'Crea il tuo primo codice promozionale per offrire sconti sui tuoi prodotti',
    createDiscount: 'Crea sconto',
    createTitle: 'Crea sconto',
    editTitle: 'Modifica sconto',
    fieldTitle: 'Titolo',
    fieldTitlePlaceholder: 'es. Saldi di primavera',
    fieldCode: 'Codice',
    fieldCodePlaceholder: 'es. SAVE20',
    generate: 'Genera',
    sectionDiscount: 'Sconto',
    fieldType: 'Tipo',
    typePercentage: 'Percentuale',
    typeFixed: 'Importo fisso',
    typeFreeShipping: 'Spedizione gratuita',
    fieldValue: 'Valore',
    sectionConditions: 'Condizioni (facoltative)',
    appliesTo: 'Si applica a',
    appliesToAll: 'Tutti i prodotti',
    appliesToShop: 'Negozio',
    appliesToDigital: 'Digitali',
    appliesToCourses: 'Corsi',
    appliesToServices: 'Servizi',
    appliesToEvents: 'Eventi',
    minOrderAmount: 'Importo minimo ordine ($)',
    maxDiscountAmount: 'Importo massimo sconto ($) — 0 = nessun limite',
    minItemCount: `Min. articoli nell'ordine — 0 = nessun requisito`,
    specificProducts: 'Prodotti specifici — vuoto = tutti',
    specificProductsPlaceholder: 'Cerca prodotti...',
    noProductsFound: 'Nessun prodotto trovato',
    sectionLimits: 'Limiti',
    usageLimit: 'Limite di utilizzo totale — 0 = illimitato',
    usageLimitPerUser: 'Limite per cliente — 0 = illimitato',
    sectionSchedule: 'Programmazione',
    startDate: 'Data di inizio — vuoto = inizia ora',
    endDate: 'Data di fine — vuoto = nessuna scadenza',
    active: 'Attivo',
    cancel: 'Annulla',
    save: 'Salva sconto',
    createdSuccess: 'Sconto creato',
    updatedSuccess: 'Sconto aggiornato',
    deletedSuccess: 'Sconto eliminato',
    loadError: 'Impossibile caricare gli sconti',
    saveError: 'Impossibile salvare lo sconto',
    deleteError: 'Impossibile eliminare lo sconto',
    fieldTrigger: 'Come si applica',
    triggerCode: 'Codice sconto',
    triggerAutomatic: 'Automatico (senza codice)',
    triggerAutomaticHint:
      'Applicato automaticamente al checkout quando le condizioni sono soddisfatte, senza bisogno di codice. Imposta sotto un importo minimo dell’ordine per uno sconto sul valore dell’ordine.',
    automaticBadge: 'Automatico',
  },
  donation: {
    chooseSmiles: 'Scegli le emoji',
    item: 'Articolo',
    itemTitle: `Titolo dell'articolo di donazione`,
    price: 'Prezzo',
    thanksMessagePlaceholder: 'Grazie mille',
    thanksMessage: 'Messaggio di ringraziamento',
    thanksMessageCaption: 'Il messaggio di ringraziamento verrà mostrato ai tuoi fan dopo la donazione',
    addDonation: 'Aggiungi donazione',
    addAmount: '+ Aggiungi importo',
    buttonTitle: 'Titolo del pulsante',
    buttonTitleCaption: 'Titolo del pulsante di donazione',
    acceptDonations: 'Accetta donazioni',
    donationsType: 'Donazioni',
    tips: 'Mance',
    type: 'Tipo',
    addAnotherAmount: '+ Aggiungi un altro importo',
  },
  blog: {
    empty: 'Non hai ancora un blog',
  },
  apps: {
    empty: 'Non hai ancora app',
  },
  payments: {
    title: 'Pagamenti',
    text: 'Non hai ancora alcuna transazione',
    single: 'Pagamenti singoli',
    subscriptions: 'Abbonamenti',
    wallet: 'Portafoglio',
    connectPromo: 'Collega un account Stripe o PayPal alla tua pagina UniLink e ricevi tutti i pagamenti nel tuo portafoglio.',
    connectSystem: 'Collega sistema di pagamento',
    manageCards: 'Gestisci le tue carte',
    addNewCard: 'Aggiungi nuova carta',
    editCard: 'Modifica dati carta',
    addCard: 'Aggiungi dati carta',
    cardHolder: 'Nome del titolare della carta',
    cardHolderNecessary: 'È necessario',
    withdrawalSuccess: 'Il tuo prelievo è stato inviato con successo!',
    withdrawalError: 'Qualcosa è andato storto, riprova più tardi.',
    change: 'Modifica',
  },
  store: {
    emptyTitle: 'Non hai ancora alcun prodotto',
    emptyText: 'Inizia aggiungendo il tuo primo prodotto',
    emptyButton: 'Aggiungi prodotto',
    createFirstProduct: 'Crea il tuo primo prodotto',
    startAdding: 'Inizia aggiungendo i tuoi prodotti preferiti, beni digitali o servizi. Uno spazio dove puoi vendere e promuovere tutto ciò che offri.',
    activate: 'Attiva Store',
    empty: 'Non hai ancora prodotti',
    products: 'Prodotti',
    addProducts: 'Aggiungi prodotti',
    whatDoYouWant: 'Cosa vuoi vendere?',
    externalProduct: 'URL prodotto esterno',
    createOwnProduct: 'Crea il tuo prodotto',
    shop: 'Negozio',
    shopText: 'Vendi prodotti fisici e digitali',
    digital: 'Prodotti digitali',
    digitalText: 'Vendi un download digitale',
    course: 'Corso o tutorial',
    courseText: 'Aggiungi corso o tutorial al sito',
    service: 'Servizi',
    serviceText: 'Aggiungi servizi dai tuoi clienti',
    appointment: 'Appuntamenti',
    appointmentText: 'Permetti ai visitatori di prenotare un orario sul tuo calendario',
    event: 'Eventi o biglietti',
    eventText: 'Crea un evento e invita il pubblico',
    tips: 'Mance',
    tipsText: 'Lascia una mancia ai tuoi creator preferiti',
    donation: 'Donazioni',
    donationText: 'Fai una donazione',
    membership: 'Abbonamento',
    membershipText: 'Aggiungi un abbonamento al sito',
    links: 'Link esterno',
    linksText: 'Aggiungi un link esterno a qualsiasi sito',
    coupon: 'Coupon',
    couponText: 'Aggiungi un coupon al tuo sito',
    singleProduct: 'Prodotto singolo',
    singleProductText: 'Vendi un singolo prodotto con un checkout semplice',
    booking: 'Prenotazione',
    bookingText: 'Permetti ai visitatori di prenotare i tuoi spazi o immobili',
    rental: 'Noleggio',
    rentalText: 'Elenca articoli a noleggio con disponibilità e prezzi',
    add: 'Aggiungi',
    manageStore: 'Gestisci negozio',
    displayLast: 'Mostra ultimo prodotto',
  },
  products: {
    info: 'Info',
    uploadCover: 'Carica una foto di copertina, poi inserisci titolo e descrizione',
    thumbnail: 'Miniatura',
    thumbnailTab: {
      intro:
        'La scheda che le persone vedono nel tuo negozio, prima di aprire il prodotto. Non ha un prezzo né una disponibilità propri: stanno in Details, e qui scegli solo quali di essi la scheda mostra.',
      cardImage: 'Immagine della scheda',
      crop: 'Ritaglio',
      cropSquare: 'Quadrato',
      cropPortrait: 'Verticale',
      cropWide: 'Largo',
      imageHint: 'Lascia vuoto e la scheda userà la prima immagine di Details. 1200×1200 o più rende meglio.',
      cardCopy: 'Testo della scheda',
      cardTitle: 'Titolo della scheda',
      sameAsTitle: 'Come il titolo del prodotto',
      shortDescription: 'Descrizione breve',
      shortDescriptionHint: 'Una riga che invogli a toccare. La descrizione lunga è in Details.',
      buttonLabel: 'Testo del pulsante',
      showOnCard: 'Mostra sulla scheda',
      showOnCardNote: 'i valori vengono da Details: qui decidi solo cosa si vede',
      editInDetails: 'Modifica in Details ↗',
      rowPrice: 'Prezzo',
      rowOldPrice: 'Prezzo precedente e sconto',
      rowAvailability: 'Disponibilità',
      rowLabel: 'Etichetta',
      inStock: 'Disponibile',
      notShown: 'Non mostrato',
    },
    thumbnailError: 'Aggiungi una miniatura',
    title: 'Titolo',
    titleTooltip: 'Inserisci il nome del tuo prodotto',
    shortDescription: 'Descrizione breve',
    shortDescriptionTooltip: 'Inserisci una breve descrizione del tuo prodotto',
    description: 'Descrizione',
    descriptionTooltip: 'Inserisci la descrizione del tuo prodotto',
    descriptionTooltipExtra: 'Descrizione opzionale di caratteristiche, tipologie, colori, taglie, ecc.',
    price: 'Prezzo',
    priceTooltip: 'Inserisci il prezzo del tuo prodotto',
    oldPrice: 'Prezzo vecchio',
    oldPriceTooltip: 'Il prezzo vecchio sarà barrato',
    category: 'Categoria',
    categoryTooltip: 'Scegli la categoria del tuo prodotto',
    image: 'Immagine',
    imageTooltip: `Carica un'immagine per il tuo prodotto`,
    groups: 'Gruppi',
    rate: 'Valutazione',
    rateTooltip: 'Inserisci la valutazione del tuo prodotto',
    buttonTitle: 'Titolo del pulsante',
    buttonTitleTooltip: 'Inserisci il titolo del pulsante del prodotto',
    limitQuantity: 'Limita quantità',
    itemsLeft: 'Articoli rimasti',
    itemsLeftTooltip: 'Articoli del tuo prodotto',
    trackStock: 'Traccia disponibilità',
    stockQuantity: 'Quantità in magazzino',
    stockQuantityTooltip: 'Unità attualmente disponibili. Diminuisce automaticamente a ogni ordine pagato; quando arriva a 0 il prodotto non può più essere acquistato.',
    lowStockThreshold: 'Avviso scorte basse',
    lowStockThresholdTooltip: 'Ricevi una notifica quando la disponibilità scende a questo numero o meno.',
    maxOrderQuantity: 'Quantità massima per ordine',
    maxOrderQuantityTooltip: 'Numero massimo di unità acquistabili in un singolo ordine. Lascia vuoto per nessun limite.',
    minOrderQuantity: 'Quantità minima per ordine',
    minOrderQuantityTooltip: 'Numero minimo di unità da acquistare in un singolo ordine. Lascia vuoto per nessun limite.',
    attachments: 'Allegati',
    addAttachments: 'Aggiungi allegati ai tuoi prodotti',
    addNewAttachment: 'Aggiungi nuovo elemento',
    file: 'File',
    uploadFile: 'Carica file',
    uploadCoverTitle: 'Carica copertina',
    optionalDescription: 'Descrizione opzionale di caratteristiche, tipologie, colori, taglie, ecc.',
    customReviews: 'Recensioni personalizzate',
    addCustomReviews: 'Aggiungi recensioni ai tuoi prodotti',
    name: 'Nome',
    nameTooltip: 'Inserisci il nome del tuo cliente',
    comment: 'Commento',
    commentTooltip: 'Inserisci il commento del tuo cliente',
    rateTooltipCustomer: 'Valutazione del cliente',
    imageTooltipCustomer: `Carica l'immagine del tuo cliente`,
    displayPriceOnPreview: 'Mostra prezzo in anteprima',
    displayDetailsOnPreview: 'Mostra dettagli in anteprima',
    postOnSocials: 'Pubblica sui social',
    sendAnEmail: `Invia un'email`,
    highlights: 'In evidenza',
    listProductSetup: 'Inserisci il prodotto e configura il blocco store',
    whereToSell: 'Dove vuoi vendere questo prodotto?',
    youHaveProducts: 'Hai {count} prodotti',
    shareThisProduct: 'Condividi questo prodotto',
    shareAProduct: 'Condividi un prodotto',
    monetizeWays: 'Diversi modi per monetizzare su UniLink',
    addProductToProfile: 'Aggiungi un {title} al tuo profilo',
    productPage: 'Pagina prodotto',
    setUpPayments: 'Configura i tuoi pagamenti',
    connectPaymentMethods: 'Collega i tuoi metodi di pagamento per iniziare a guadagnare su UniLink',
    addPaymentMethod: 'Aggiungi un metodo di pagamento {type} per ricevere i pagamenti dei follower',
    withdrawAttempt: 'Questo è un tentativo di riscuotere un debito e qualsiasi informazione sarà utilizzata per tale scopo.',
    withdrawSuccess: 'Il tuo prelievo è stato inviato con successo!',
    yourVisitorsPay: 'I tuoi visitatori pagheranno prima e poi saranno indirizzati al tuo {method}',
    emailAddress: 'indirizzo email',
    calendlyLink: 'Link Calendly',
    features: 'Caratteristiche',
    featuresTooltip: 'Elenco di vantaggi mostrato nel layout scheda Vetrina',
    featurePlaceholder: 'Vantaggio',
    addFeature: 'Aggiungi caratteristica',
    pendingReviews: {
      title: 'Recensioni in attesa',
      subtitle: 'Approva o nascondi le recensioni degli acquirenti prima che siano pubbliche',
      empty: 'Nessuna recensione in attesa di moderazione.',
      approve: 'Approva',
      hide: 'Nascondi',
    },
  },
  posts: {
    posts: 'Post',
    title: 'Crea il tuo primo post',
    description: 'I Post ti permettono di creare automazioni di chat in modo facile e visivo. Prova alcune automazioni che ti consigliamo in base ai tuoi obiettivi',
    activate: 'Attiva i post',
    managePosts: 'Gestisci i post',
    postsTab: 'Scheda Post',
    displayLast: 'Mostra ultimi post',
    tabNavigation: 'Impostazioni navigazione schede',
    createFirstPost: 'Crea il tuo primo post social!',
    autoPostsText: 'Pianifica e pubblica contenuti su tutti i social media in una volta sola!',
    createPost: 'Crea post',
  },
  messages: {
    title: 'Messaggi',
    empty: 'Nessun messaggio',
    addText: 'Aggiungi un pulsante messaggio al blocco Header, consentendo agli utenti di inviarti facilmente un messaggio.',
    addButton: 'Aggiungi pulsante messaggio',
  },
  smartReply: {
    title: 'Instagram Reply',
    clicks: 'clic',
    createTitle: 'Crea la tua prima Instagram Reply!',
    text: 'Usa gli Auto-DM di Instagram per condividere automaticamente link con il tuo pubblico!',
    createButton: 'Crea Auto DM',
    subtitleComment: 'DM automatico con un link in risposta a un commento',
    subtitleDm: 'DM automatico in risposta a un messaggio o una Story',
    ready: 'pronto',
    edit: 'Modifica',
    stepContentTitle: 'Contenuto IG',
    stepContentSub: 'Scegli un post o un Reel',
    storiesAndDmsSub: 'DM automatico quando qualcuno risponde a una Story o ti scrive',
    stepTriggerTitle: 'Trigger',
    stepTriggerSub: 'Parole chiave nei commenti',
    stepTriggerSubDm: 'Parole chiave nei messaggi',
    stepDmTitle: 'DM',
    stepDmSub: 'Il messaggio inviato automaticamente',
    dmSummary: 'Messaggio impostato',
    activatesNow: 'La risposta automatica si attiva subito',
    saveAutomation: 'Salva risposta automatica',
    savedToast: 'Risposta automatica creata',
    linkLabel: 'Scegli la destinazione del link',
    selectDestination: 'Scegli un link, un prodotto o un articolo',
    change: 'Cambia',
    choose: 'Scegli',
    remove: 'Rimuovi',
    optional: 'facoltativo',
    buttonText: 'Testo del pulsante',
    addLink: 'Aggiungi link',
    attachLink: 'Allega link',
    noLinks: 'Ancora nessun link — aggiungi prima un link nel tuo Link in Bio.',
    tabLinks: 'Link',
    tabProducts: 'Prodotti',
    noProducts: 'Ancora nessun prodotto — crea prima un prodotto nel tuo negozio.',
    tabArticles: 'Articoli',
    noArticles: 'Ancora nessun articolo — crea prima un articolo.',
    choosePost: 'Scegli un post o un Reel',
    searchPosts: 'Cerca nei tuoi post',
    loadingPosts: 'Caricamento dei tuoi post…',
    done: 'Fatto',
    oneSelected: '1 post selezionato',
    postSelected: 'Post selezionato',
    noPosts: 'Ancora nessun post — pubblica un post o un Reel su Instagram.',
    postsError: 'Impossibile caricare i post. Riprova.',
    reauthTitle: 'Alcuni DM potrebbero non essere recapitati.',
    reauthText: 'Instagram richiede di riautorizzare l’account.',
    reconnect: 'Riconnetti',
    statActive: 'Automazioni attive',
    statDmSent: 'DM inviati · 30 gg',
    statClicks: 'Clic sul link',
    activeReplies: 'Risposte automatiche attive',
    filterAll: 'Tutte',
    filterActive: 'Attive',
    filterOff: 'Disattivate',
  },
  businessCards: {
    title: 'Biglietti da visita',
    emptyTitle: 'Crea il tuo biglietto da visita digitale',
    emptySubtitle: 'Aggiungi i tuoi dati di contatto in modo che chiunque possa salvarli sul telefono con un solo tocco, poi condividilo con un codice QR o un file .vcf.',
    createButton: 'Crea biglietto da visita',
    sectionButton: 'Pulsante Salva contatto',
    sectionButtonSubtitle: 'Come appare il pulsante "Salva contatto" e dove compare sul tuo profilo.',
    showButton: 'Mostra sul mio profilo',
    showButtonSubtitle: 'Mostra il pulsante "Salva contatto" sulla tua pagina pubblica.',
    placement: 'Posizione del pulsante',
    placementSubtitle: 'Scegli dove compare il pulsante.',
    showInHeader: 'Mostra nell’intestazione',
    placementHeader: 'Intestazione del profilo',
    placementHeaderHint: 'Appare subito sotto il nome e l’avatar.',
    placementContact: 'Sezione contatti',
    placementContactHint: 'Appare nella finestra Contatti.',
    placementBottom: 'Pulsante fluttuante',
    placementBottomHint: 'Rimane in fondo alla pagina durante lo scorrimento.',
    none: 'Nessuna',
    buttonLabel: 'Etichetta del pulsante',
    buttonLabelSubtitle: 'Testo mostrato sul pulsante.',
    saveContact: 'Salva contatto',
    sectionDetails: 'Dati di contatto',
    sectionDetailsSubtitle: 'Questi dati vengono salvati nella scheda contatto.',
    delete: 'Elimina biglietto da visita',
    previewHint: 'Ecco come appare il tuo biglietto ai visitatori.',
    share: 'Condividi e QR',
    shareSubtitle: 'Scansiona il codice o condividi il link per aprire il tuo profilo.',
    download: 'Scarica .vcf',
    copyLink: 'Copia link',
    copied: 'Link copiato!',
    digitalCard: 'Biglietto digitale',
    physicalCard: 'Biglietto fisico',
    cardStyle: 'Stile del biglietto',
    cardStyleSubtitle: 'Imposta il tuo nome visualizzato, scegli un colore di sfondo e aggiungi il biglietto a un wallet.',
    displayName: 'Nome visualizzato',
    backgroundColour: 'Colore di sfondo',
    addAppleWallet: 'Aggiungi ad Apple Wallet',
    addGoogleWallet: 'Aggiungi a Google Wallet',
    nameLabel: 'Nome',
    urlLabel: 'URL',
    walletScanTitle: 'Scansiona il codice QR per salvarlo nel tuo wallet',
    walletScanSubtitle: 'Verrà salvato nel wallet digitale del tuo telefono.',
    walletUseLink: 'Oppure usa questo link',
    walletComingSoonTitle: 'Ci siamo quasi',
    walletComingSoon: 'I pass per il wallet saranno disponibili a breve.',
    done: 'Fatto',
    physicalTitle: 'Ordina un biglietto fisico',
    physicalSubtitle: 'I biglietti da visita NFC saranno disponibili a breve.',
    leadCapture: 'Raccogli contatti',
    leadCaptureSubtitle: 'Consenti a chi riceve la tua card di condividere i propri dati in cambio — direttamente nel tuo Pubblico.',
    leadCaptureToggle: 'Attiva «Condividi i tuoi dati»',
    leadCaptureToggleHint: 'Mostra un modulo di contatto sulla tua card pubblica.',
    leadTag: 'Tagga i nuovi lead',
    leadTagSubtitle: 'Ogni contatto raccolto viene taggato con questo (es. il nome di un evento o di una campagna).',
    leadTagPlaceholder: 'es. Conferenza 2026',
    renewLink: 'Rinnova link',
    renewing: 'Rinnovo in corso…',
    renewConfirm: 'Rinnovare il link della card? Il tuo QR code attuale e i link condivisi smetteranno di funzionare.',
    linkRenewed: 'Link della card rinnovato',
    scans: '{count} scansioni',
  },
  shortLinks: {
    title: 'Link brevi',
    addLink: 'Aggiungi link',
    name: 'Nome',
    slug: 'Slug',
    slugTooltip: 'Puoi modificare lo Slug cliccando sul pulsante di modifica',
    destinationUrl: 'URL di destinazione',
    metadata: 'Metadati',
    utmTags: 'Tag UTM',
    customizeMetadata: 'Personalizza i metadati del link',
    metaTitle: 'Titolo',
    metaDescription: 'Descrizione',
    favicon: 'Favicon',
    imagePreview: 'Anteprima immagine',
    addUtm: 'Aggiungi tag UTM al link (opzionale)',
    utmCampaign: 'UTM Campaign',
    utmMedium: 'UTM Medium',
    utmSource: 'UTM Source',
    utmTerm: 'UTM Term',
    utmContent: 'Contenuto UTM',
    utmId: 'ID UTM',
    utmPlacement: 'Posizionamento UTM',
    utmCreative: 'Creatività UTM',
    pasteLink: 'Incolla qui il tuo link lungo',
    shorten: 'Accorcia link',
    edit: 'Modifica dettagli elemento',
  },
  audience: {
    title: 'Pubblico',
    total: 'Totale',
    totalMembers: 'Membri totali del pubblico',
    totalContacts: 'Contatti totali',
    forms: 'Moduli',
    subscribers: 'Iscritti',
    customers: 'Clienti',
    noAudienceMembers: 'Nessun contatto',
    emptyAudienceMembers: 'Aggiungi nuovi contatti cliccando il pulsante',
    addAudienceMember: 'Aggiungi contatto',
    noSubscribers: 'Nessun iscritto',
    emptySubscribers: 'Aggiungi nuovi iscritti aggiungendo blocchi al tuo Link in Bio',
    addDataCollect: 'Aggiungi blocco Raccolta dati',
    noResponses: 'Nessuna risposta',
    emptyResponses: 'Aggiungi nuove risposte aggiungendo blocchi al tuo Link in Bio',
    addFormBlock: 'Aggiungi blocco Modulo',
    noCustomers: 'Nessun cliente',
    emptyCustomers: 'Aggiungi nuovi clienti aggiungendo un prodotto al tuo Link in Bio',
    addProduct: 'Aggiungi prodotto',
    addContactModal: {
      title: 'Aggiungi nuovo contatto',
      name: 'Nome',
      nameTooltip: 'Inserisci il nome per il tuo contatto',
      email: 'Email',
      emailTooltip: `Inserisci l'indirizzo email per il tuo contatto`,
      phone: 'Telefono',
      phoneTooltip: 'Inserisci il numero di telefono per il tuo contatto',
      telegram: 'Telegram',
      telegramTooltip: `Inserisci il nome utente o l'URL Telegram per il tuo contatto`,
      whatsapp: 'WhatsApp',
      whatsappTooltip: 'Inserisci il numero WhatsApp per il tuo contatto',
      instagram: 'Instagram',
      instagramTooltip: `Inserisci il nome utente o l'URL Instagram per il tuo contatto`,
      messenger: 'Messenger',
      messengerTooltip: `Inserisci il nome utente o l'URL Messenger per il tuo contatto`,
      viber: 'Viber',
      viberTooltip: 'Inserisci il numero Viber per il tuo contatto',
      address: 'Indirizzo',
      addressTooltip: `Inserisci l'indirizzo per il tuo contatto`,
      add: 'Aggiungi',
    },
    search: {
      search: 'Cerca',
      error: 'Carattere non valido inserito nel campo di ricerca',
      notFound: 'Nessun risultato trovato',
    },
  },
  auth: {
    logIn: 'Accedi',
    logInWith: 'Accedi con',
    signIn: 'Accedi',
    signInWith: 'Registrati con',
    email: 'Email',
    password: 'Password',
    notHaveAccount: 'Non hai un account?',
    createAccount: 'Crea un nuovo account',
    createYourAccount: 'Crea il tuo account',
    signUp: 'Registrati',
    haveAccount: 'Se hai già un account',
    or: 'o',
    reset: 'Reimposta',
    resetPassword: 'Reimposta password',
    resetTitle: 'Il link di recupero è stato inviato alla tua email',
    goToHome: 'Vai alla Home',
    byClicking: 'Cliccando',
    youAreAgree: 'accetti i',
    terms: 'Termini di Servizio',
    andConfirm: 'e la nostra',
    usagePolicy: 'Politica di Utilizzo',
    signInGoogle: 'Accedi con Google',
    forgotPassword: 'Password dimenticata?',
  },
  menu: {
    moreApps: 'Altre app',
    account: 'Account',
    more: 'Altro',
    storyWidget: 'Incorpora Storie',
    integrations: 'Integrazioni',
    socialAccounts: 'Account social',
    aiContent: 'Contenuti AI',
    aiPosts: 'Post AI',
    postIdeas: 'Idee per Post',
    contentPlanner: 'Pianificatore Contenuti',
    aiImages: 'Immagini AI',
    aiVideo: 'Video AI',
    planner: 'Pianificatore',
    customers: 'Clienti',
    subscribers: 'Iscritti',
    forms: 'Moduli',
    allAudience: 'Tutto il pubblico',
    payments: 'Pagamenti',
    orders: 'Ordini',
    products: 'Prodotti',
    events: 'Eventi',
    appointments: 'Appuntamenti',
    discounts: 'Sconti',
    affiliates: 'Affiliati',
    instantPages: 'Pagine Istantanee',
    openInNewTab: 'Apri in una nuova scheda',
    linkInBio: 'Link in Bio',
    linkInBioApps: 'Link in Bio',
    website: 'Sito web',
    store: 'Negozio',
    audience: 'Pubblico',
    emailMarketing: 'Email Marketing',
    postPlaner: 'Pianificatore Post',
    posts: 'Post',
    agents: 'Agenti',
    community: 'Community',
    profileHealth: 'Stato del Profilo',
    socialPlanner: 'Pianificatore Social',
    shortLinks: 'Link Brevi',
    businessCards: 'Biglietti da visita',
    views: 'Visualizzazioni',
    clicks: 'Clic',
    allWebsites: 'Tutti i siti web',
    createNewAccount: 'Crea nuovo account',
    createNewWebsite: 'Crea un nuovo profilo',
    tools: 'Strumenti',
    borderGenerator: 'Generatore di Bordi',
    yourPlan: 'Il tuo piano:',
    upgrade: 'Aggiorna',
    accountSettings: 'Impostazioni account',
    manageWebsites: 'Gestisci profili',
    updates: 'Aggiornamenti',
    autoUpdate: 'Aggiornamento automatico',
    logOut: 'Esci',
    myPages: 'Le mie pagine',
    design: 'Design',
    heading: 'Titolo',
    analytics: 'Analisi',
    settings: 'Impostazioni',
    open: 'Apri',
    language: 'Lingua',
    siteLanguage: 'Lingua del sito pubblico',
    dashboardLanguage: 'Lingua del pannello',
    movePage: 'Sposta pagina',
    editBlock: 'Modifica blocco',
    renameBlock: 'Rinomina blocco',
    rename: 'Rinomina',
    deleteBlock: 'Elimina blocco',
    archiveBlock: 'Archivia blocco',
    archive: 'Archivia',
    scheduleBlock: 'Pianifica blocco',
    copyBlock: 'Copia blocco',
    dublicateBlock: 'Duplica blocco',
    content: 'Contenuto',
    preview: 'Anteprima',
    copy: 'Copia',
    moveBlock: 'Sposta blocco',
    move: 'Sposta',
    edit: 'Modifica',
    delete: 'Elimina',
    schedule: 'Pianifica',
    dublicate: 'Duplica',
    smartReply: 'Instagram Reply',
    marketing: 'Marketing',
    selectBlocks: 'Seleziona blocchi',
    selectAll: 'Seleziona tutto',
    cancelSelection: 'Annulla',
    blocksSelected: 'selezionati',
    moveToPage: 'Sposta nella pagina',
    newPage: 'Nuova pagina',
    openPage: 'Apri pagina',
    pageSettings: 'Impostazioni pagina',
    deletePage: 'Elimina pagina',
    appInBio: 'App in Bio',
    blog: 'Blog',
    publish: 'Pubblica',
    creatorHub: 'Hub creator',
    qrCodes: 'Codici QR',
    apps: 'App',
    automations: 'Automazioni',
    messages: 'Inbox',
    form: 'Moduli incorporati',
    embedTools: 'Strumenti incorporati',
    adBuilder: 'Creatore di annunci',
    emailSignatures: 'Firme e-mail',
    virtualBackgrounds: 'Sfondi virtuali',
    adsCampaigns: 'Gestione annunci',
    thumbnail: 'Anteprima',
    buildFromReference: 'Crea da un riferimento',
  },
  modal: {
    addInstagram: 'Aggiungi Instagram',
    addYourInstagram: 'Aggiungi il tuo account Instagram',
    cropYourAvatar: 'Ritaglia il tuo avatar',
    removeSite: 'Sei sicuro di voler rimuovere il sito?',
    areYouSure: 'Sei sicuro di voler',
    areYouSureDelete: 'Sei sicuro di voler eliminare questa sezione?',
    areYouSureArchive: 'Sei sicuro di voler archiviare questo blocco?',
    areYouSurePermanentDelete: 'Sei sicuro di voler eliminare definitivamente questo blocco? Questa azione non può essere annullata.',
    remove: 'rimuovere',
    site: 'sito',
    removeAccountText: 'rimuovere il tuo account',
    moveBlock: `Sposta il blocco in un'altra pagina`,
    moveBlockText: `Questo sposterà il blocco in fondo a un'altra pagina. Potrai poi riorganizzarlo nella nuova pagina`,
    profileTitle: 'Cambia immagine profilo',
    profileText: `Scegli un'immagine o una GIF dal tuo dispositivo.`,
    profileAvatar: 'Avatar profilo',
    addProfilePicture: 'Aggiungi immagine profilo',
    storiesTitle: 'Storie',
    storiesText: 'Condividi i tuoi momenti quotidiani.',
    thoughtsTitle: 'Pensieri',
    thoughtsText: 'Condividi i tuoi pensieri.',
    accountPageDescription: `Questa è la pagina del tuo account, dove puoi personalizzare l'aspetto della tua pagina, aggiungere diversi blocchi di funzionalità e altro ancora.`,
  },
  modalSubscribe: {
    plan: 'Piano',
    usdMonth: 'USD/mese',
    sites: 'Siti',
    sitesMuch: 'Siti',
    notification: 'Notifiche',
    noNotification: 'Nessuna notifica',
    inCategory: 'Non ci sono elementi nella',
    categoryYet: 'categoria.',
    externalPixels: 'Pixel esterni',
    parameters: 'parametri',
    analyticsReports: 'Analisi e report',
    noUniLinkLogo: 'Nessun logo UniLink',
    inProfile: 'nel profilo',
    verifiedBadge: 'Badge verificato',
    your: 'Il tuo',
    customDomain: 'dominio personalizzato',
    emailMarketing: 'Email Marketing',
    liveSupport: 'Supporto live',
    dataSecured: 'I dati sono protetti in conformità con lo standard PCI DSS',
    thankYou: 'Grazie per il tuo interesse. Ti contatteremo presto.',
    socialMediaScheduler: 'Pianificatore social media',
    featureRequest: 'Richiesta funzionalità',
    markAllRead: 'Segna tutti come letti',
    currentPlan: 'Piano attuale',
    features: 'Funzionalità',
  },
  buttons: {
    upgrade: 'Aggiorna piano',
    buyProPlan: 'Acquista piano Pro',
    continue: 'Continua',
    skip: 'Salta',
    cancel: 'Annulla',
    confirm: 'Conferma',
    back: 'Indietro',
    save: 'Salva',
    add: 'Aggiungi',
    added: 'Aggiunto',
    done: 'Fatto',
    ok: 'OK',
    edit: 'Modifica',
    delete: 'Elimina',
    remove: 'Rimuovi',
    setAsDefault: 'Imposta come predefinito',
    subscribeNow: 'Abbonati ora',
    yes: 'Sì',
    preview: 'Anteprima',
    generate: 'Genera',
    changePassword: 'Cambia password',
    deleteAccount: 'Elimina account',
    removeAccount: 'Rimuovi account',
    deleteProfile: 'Elimina profilo',
    addBlock: 'Aggiungi blocco',
    copyLink: 'Copia link',
    active: 'Attivo',
    update: 'Aggiorna',
    updatePro: 'Aggiorna piano',
    prev: 'Prec',
    next: 'Avanti',
    uploadImage: 'Carica immagine',
    uploadVideo: 'Carica video',
    loadMore: 'Carica altro',
    uploadProductImage: 'Carica immagine prodotto',
    claim: 'Richiedi',
    removeSite: 'Rimuovi sito',
    move: 'Sposta',
    addButton: 'Aggiungi pulsante',
    actionButton: 'Pulsante azione',
    directMessage: 'Messaggio diretto',
    subscribe: 'Iscriviti',
    button: 'Pulsante',
    generateWithAI: 'Genera con AI',
    cta: 'CTA',
    cart: 'Carrello',
    direct: 'Diretto',
    follow: 'Segui',
    addNewItem: 'Aggiungi nuovo elemento',
  },
  support: {
    liveSupport: 'Supporto Live',
    response: `Di solito rispondiamo entro 1 minuto durante l'orario di lavoro (8:00 - 22:00) GMT+3`,
    founder: 'Denys Bilozor',
    ceo: 'Fondatore e CEO di UniLink',
  },
  wizard: {
    createNewProfile: 'Crea un nuovo profilo',
    createProfile: 'Crea profilo',
    continue: 'Continua',
    tellUs: 'Parlaci di te',
    addSocialLinks: 'Aggiungi tutti i social network e li mostreremo nel tuo database',
    addMoreLinks: 'Aggiungi altri link',
    addLink: 'Aggiungi link',
    selectCategory: 'Seleziona la categoria che ti descrive meglio:',
    chooseTemplate: 'Scegli un template',
    skip: 'Salta',
    step: 'Passaggio',
    of: 'di',
    yourName: 'Il tuo nome',
    search: 'Cerca',
    blog: 'Blog',
    creator: 'Creator',
    music: 'Musica',
    events: 'Eventi',
    esoteric: 'Esoterico',
    fashion: 'Moda',
    influencer: 'Influencer',
    food: 'Food',
    smallBusiness: 'Piccole imprese',
    marketing: 'Marketing',
    education: 'Educazione',
    socialMedia: 'Social Media',
    coaching: 'Coaching',
    ecommerce: 'Ecommerce',
    healthAndFitness: 'Salute e fitness',
    beautyWellness: 'Bellezza e benessere',
  },
  billing: {
    back: 'Indietro',
    findPlan: 'Trova il piano adatto a te',
    changeAnytime: 'Puoi cambiarlo in qualsiasi momento.',
    subtitle: 'Passa a un piano superiore o inferiore, o disdici quando vuoi.',
    currentPlan: 'Piano attuale',
    mostPopular: 'Più popolare',
    upgradeTo: 'Passa a {plan}',
    includes: 'Include:',
    everythingIn: 'Tutto ciò che c’è in {plan}, più:',
    secure: 'I pagamenti sono protetti in conformità allo standard PCI DSS.',
  },
  field: {
    fullName: 'Nome completo',
    username: 'username',
    addValue: 'Aggiungi valore',
    newValue: 'Nuovo valore',
    placeholderDefault: 'Testo, numeri, simboli ecc.',
    addInstagramUsername: 'Aggiungi nome utente Instagram',
    nameDefault: 'Jhon',
    enterYourLink: 'Inserisci il tuo link',
    searchImage: 'Cerca immagine',
    pasteLink: 'Incolla link',
    pasteLinkTip: 'Aggiungi un link a qualsiasi pagina web',
    searchGIFs: 'Cerca GIF',
    searchIcons: 'Cerca icone',
    searchVideo: 'Cerca video',
    search: 'Cerca',
    insertURL: 'Inserisci URL',
    writeYourDescription: 'Scrivi la tua descrizione',
    headerCTAbutton: 'Intestazione, pulsante CTA',
    enterTitle: 'Inserisci il titolo',
    enterDescription: 'Inserisci la descrizione',
    enterURL: 'Inserisci URL canonico',
  },
  tooltip: {
    addImage: 'Aggiungi immagine',
    labelModalTitle: 'Impostazioni etichetta',
    addLabel: '+ Aggiungi etichetta',
    label: 'Etichetta',
    labelCaption: 'Inserisci etichetta',
    labelText: 'Testo etichetta',
    labelTextCaption: `Inserisci il testo dell'etichetta`,
    labelTextPlaceholder: 'Etichetta',
    labelUrl: 'URL etichetta',
    labelUrlCaption: 'Inserisci URL etichetta',
    labelUrlPlaceholder: 'https://example.com',
    noLabel: 'Nessuna etichetta',
    colorFrom: 'Colore da',
    colorTo: 'Colore a',
    highlight: 'Evidenzia',
    firstName: 'Nome',
    firstNameCaption: 'Inserisci il tuo nome',
    lastName: 'Cognome',
    lastNameCaption: 'Inserisci il tuo cognome',
    jobTitle: 'Posizione lavorativa',
    jobTitleCaption: 'Inserisci la tua posizione lavorativa',
    organization: 'Organizzazione',
    organizationCaption: 'Inserisci la tua organizzazione',
    email: 'Email',
    emailCaption: 'Inserisci la tua email',
    workPhone: 'Telefono di lavoro',
    workPhoneCaption: 'Inserisci il tuo telefono di lavoro',
    mobilePhone: 'Cellulare',
    mobilePhoneCaption: 'Inserisci il tuo cellulare',
    website: 'Sito web',
    websiteCaption: 'Inserisci il tuo sito web',
    information: 'Informazioni',
    informationCaption: 'Inserisci le tue informazioni',
    streetAddress: 'Indirizzo',
    streetAddressCaption: 'Inserisci il tuo indirizzo',
    city: 'Città',
    cityCaption: 'Inserisci la tua città',
    state: 'Provincia',
    stateCaption: 'Inserisci la tua provincia',
    postalCode: 'Codice postale',
    postalCodeCaption: 'Inserisci il tuo codice postale',
    country: 'Paese',
    countryCaption: 'Inserisci il tuo paese',
    titleColor: 'Colore titolo',
    titleColorCaption: 'Puoi cambiare il colore del titolo',
    fontFamily: 'Famiglia di font',
    fontFamilyCaption: 'Puoi cambiare la famiglia di font',
    fontSize: 'Dimensione font',
    fontSizeLabel: 'Dimensione font etichetta',
    fontSizeCaption: 'Puoi cambiare la dimensione del font',
    fontSelect: 'Font',
    fontSelectCaption: 'Scegli un font',
    imageMargin: 'Margine immagine',
    profilePicture: 'Foto profilo',
    profilePictureCaption: 'Cambia la tua foto profilo',
    pictureSize: 'Dimensione immagine',
    pictureSizeCaption: `Puoi cambiare la dimensione dell'immagine`,
    title: 'Titolo',
    titleCaption: 'Inserisci un titolo',
    blockCaption: 'Inserisci un titolo per il tuo blocco',
    titlePageCaption: 'Inserisci un titolo per la tua pagina',
    templates: 'Modelli',
    templatesCaption: 'Scegli un modello per la tua pagina',
    background: 'Sfondo',
    backgroundColor: 'Colore di sfondo',
    textBackground: 'Sfondo testo',
    textBackgroundCaption: 'Scegli il colore di sfondo del testo',
    textColor: 'Colore testo',
    textColorCaption: 'Scegli il colore del testo',
    gradientBackground: 'Sfondo gradiente',
    gradientColor: 'Colore gradiente',
    BackgroundType: 'Tipo',
    backgroundSource: 'Origine sfondo',
    backgroundSourceCaption: `Scegli l'origine dello sfondo`,
    backgroundStyle: 'Stile sfondo',
    backgroundStyleCaption: 'Scegli lo stile dello sfondo',
    backgroundStylesNormal: 'Normale',
    backgroundStylesGlass: 'Vetro',
    backgroundStylesOutline: 'Contorno',
    backgroundTypeCaption: 'Scegli il tipo di sfondo',
    color: 'Colore',
    colorTooltip: 'Puoi cambiare il colore',
    backgroundOpacityTooltip: `Trascina il cursore per impostare l'opacità dello sfondo`,
    backgroundBlur: 'Sfocatura sfondo',
    backgroundBlurCaption: 'Trascina il cursore per sfocare lo sfondo',
    backgroundBrightness: 'Luminosità sfondo',
    backgroundBrightnessCaption: 'Trascina il cursore per cambiare la luminosità dello sfondo',
    backgroundContrast: 'Contrasto sfondo',
    backgroundContrastCaption: 'Trascina il cursore per cambiare il contrasto dello sfondo',
    color1: 'Colore 1',
    color2: 'Colore 2',
    colorCaption: 'Inserisci il colore della tua pagina',
    gradient: 'Gradiente',
    image: 'Immagine',
    photo: 'Foto',
    gif: 'GIF',
    animation: 'Animazione',
    video: 'Video',
    hexColor: 'Colore esadecimale',
    direction: 'Direzione',
    gradientDirection: 'Direzione gradiente',
    directionCaption: 'Trascina il cursore per impostare la direzione del gradiente',
    offset: 'Offset',
    gradientOffset: 'Offset gradiente',
    offsetCaption: `Trascina il cursore per impostare l'offset del gradiente`,
    backgroundDarkness: 'Oscurità sfondo',
    backgroundDarknessCaption: `Trascina il cursore per scurire l'immagine di sfondo`,
    uploadVideo: 'Carica video',
    uploadFile: 'Carica file',
    uploadVideoCaption: 'Video dello sfondo della pagina',
    linkToVideo: 'Link al video',
    linkToVideoCaption: 'Aggiungi link al video',
    videoWithSound: 'Video con audio',
    videoWithSoundCaption: 'Riproduci video con audio',
    fonts: 'Font',
    fontWeight: 'Spessore font',
    fontWeightCaption: 'Clicca per scegliere il tuo destino',
    preloader: 'Preloader',
    preview: 'Anteprima',
    hideLogo: 'Nascondi logo UniLink',
    cover: 'Copertina',
    coverCaption: 'Cambia copertina',
    coverCaptionHeader: 'Aggiungi immagine o video alla copertina',
    pageNavigation: 'Navigazione pagina',
    websiteNavigation: 'Navigazione a schede',
    backgroundOpacity: 'Opacità sfondo',
    backgroundOpacityCaption: `Trascina il cursore per l'opacità dello sfondo del pulsante`,
    borderRadius: 'Raggio bordo',
    borderRadiusCaption: 'Trascina il cursore per impostare il raggio del bordo',
    heightTabs: 'Altezza schede',
    heightTabsCaption: `Trascina il cursore per impostare l'altezza delle schede`,
    backgroundShadow: 'Ombra sfondo',
    backgroundShape: 'Forma sfondo',
    backgroundBorder: 'Bordo sfondo',
    opacity: 'Opacità',
    opacityCaption: `Trascina il cursore per impostare l'opacità`,
    shape: 'Forma',
    shapeCaption: 'Imposta forma',
    text: 'Testo',
    textCaption: 'Inserisci testo',
    textSize: 'Dimensione testo',
    textSizeCaption: 'Trascina il cursore per impostare la dimensione del testo',
    additionalText: 'Testo aggiuntivo',
    username: 'Nome utente',
    currency: 'Valuta',
    language: 'Lingua',
    timeZone: 'Fuso orario',
    websiteNiche: 'Nicchia del sito',
    websiteNicheCaption: 'Inserisci la nicchia del tuo sito',
    renameCaption: 'Rinomina titolo blocco',
    description: 'Descrizione',
    descriptionCaption: 'Inserisci una descrizione',
    actionButton: 'Pulsante azione',
    actionButtonCaption: 'Il pulsante Call To Action invita i visitatori ad agire',
    animationDirection: 'Direzione animazione',
    animationDirectionCaption: `Scegli la direzione dell'animazione`,
    buttonTitle: 'Titolo pulsante',
    buttonTitleCaption: 'Inserisci il titolo del pulsante',
    buttonUrl: 'URL pulsante',
    buttonUrlCaption: `L'URL si aprirà in una nuova finestra`,
    imageSize: 'Dimensione immagine',
    imageSizeCaption: `Trascina il cursore per impostare la dimensione dell'immagine`,
    view: 'Visualizzazione',
    viewCaption: 'Scegli una visualizzazione',
    margin: 'Margine',
    marginCaption: `Trascina il cursore per aggiungere margine sia sopra che sotto l'elemento`,
    separateTopBottom: 'Sopra / Sotto',
    padding: 'Spaziatura interna',
    paddingCaption: `Trascina il cursore per aggiungere spaziatura interna sopra e sotto l'elemento`,
    fullWidth: 'Larghezza intera',
    lineHeight: 'Altezza riga',
    lineHeightCaption: `Puoi modificare l'altezza della riga`,
    button: 'Pulsante',
    titleSize: 'Dimensione titolo',
    titleSizeCaption: 'Puoi modificare la dimensione del titolo',
    titleLineHeight: 'Altezza riga titolo',
    titleLineHeightCaption: `Personalizza l'altezza della riga del titolo per offrire più soluzioni di design al testo`,
    layout: 'Layout',
    layoutCaption: `Crea il layout dell'intestazione che desideri`,
    layoutAlign: 'Allineamento layout',
    alignText: 'Allinea testo',
    align: 'Allinea',
    alignCaption: 'Scegli allineamento',
    position: 'Posizione',
    positionCaption: 'Scegli posizione',
    width: 'Larghezza',
    widthCaption: 'Scegli la larghezza del tuo banner',
    nameHeader: 'Nome',
    nameCaption: 'Inserisci il nome del tuo account',
    shortBio: 'Bio breve',
    shortBioCaption: 'Inserisci una bio breve del tuo account',
    externalLink: 'Link esterno',
    externalLinkCaption: 'Inserisci un link esterno al tuo account',
    location: 'Località',
    locationCaption: 'Inserisci la tua località',
    locationMap: 'Mappa località',
    locationMapCaption: `Inserisci l'URL della tua località`,
    rightIcon: 'Icona destra',
    rightIconCaption: 'Questa icona apparirà sul lato destro del pulsante',
    buttons: 'Pulsanti',
    buttonsCaption: 'Aggiungi pulsanti azione',
    nameLogo: 'Logo del nome',
    nameLogoCaption: 'Carica un logo per il tuo nome',
    buttonText: 'Testo pulsante',
    buttonTextCaption: 'Inserisci il nome del tuo pulsante',
    buttonColor: 'Colore pulsante',
    buttonColorCaption: 'Scegli i colori per il pulsante',
    buttonColorCTACaption: 'Scegli il colore di sfondo per il pulsante CTA',
    cartColor: 'Colore carrello',
    cartColorCaption: 'Scegli il colore di sfondo per il carrello',
    ctaButton: 'Pulsante CTA',
    ctaButtonCaption: 'Questa icona apparirà sul lato destro del pulsante',
    style: 'Stile',
    socialIconsStyleCaption: 'Puoi scegliere lo stile delle tue icone social',
    socialIconsShape: 'Forma icone social',
    socialIconsShapeCaption: 'Puoi scegliere la forma delle icone social',
    headerTextColorCaption: `Puoi scegliere il colore del testo dell'intestazione`,
    pictureShape: 'Forma immagine',
    pictureShapeCaption: `Puoi scegliere la forma dell'immagine del profilo`,
    socialLinks: 'Link social',
    socialLinksCaption: 'Aggiungi pulsanti dei link social per una connessione rapida tra te e i tuoi clienti con un solo clic',
    URL: 'URL',
    URLCaption: 'Inserisci indirizzo URL',
    heading: 'Titolo',
    headingTitle: 'Titolo intestazione',
    headingTitleCaption: `Inserisci il titolo dell'intestazione`,
    headingDescription: 'Descrizione intestazione',
    headingDescriptionCaption: `Inserisci la descrizione dell'intestazione`,
    headingImage: 'Immagine intestazione',
    headingImageCaption: `Carica un'immagine per l'intestazione`,
    headingPosition: 'Posizione intestazione',
    headingInsideBlock: 'Dentro il blocco',
    headingOutsideBlock: 'Fuori dal blocco',
    headingDivider: 'Divisore intestazione',
    canonicalURL: 'URL canonico',
    seo: 'SEO',
    seoCaption: 'Personalizza il tuo prodotto con i meta tag SEO',
    themes: 'Temi',
    brandColors: 'Brand Kit',
    applyBrandColors: 'Applica al profilo',
    syncBlocks: 'Sincronizza tutti i blocchi',
    brandColorsApplied: 'Colori del brand applicati',
    generatedPalette: 'Palette generata',
    applying: 'Applicazione in corso...',
    syncing: 'Sincronizzazione in corso...',
    backgroundType: 'Tipo di sfondo',
    palettes: 'Palette',
    previewTitle: 'Titolo',
    previewTitleCaption: `Inserisci il titolo dell'anteprima`,
    previewDescription: 'Descrizione',
    previewDescriptionCaption: `Inserisci la descrizione dell'anteprima`,
    previewButton: 'Testo del pulsante',
    previewButtonCaption: 'Inserisci il testo del pulsante di anteprima',
    previewLabel: 'Testo etichetta',
    previewLabelCaption: `Inserisci il testo dell'etichetta di anteprima`,
    previewThumbnail: 'Miniatura',
    previewThumbnailCaption: 'Carica la miniatura di anteprima',
    myTemplates: 'I miei template',
    myTemplatesEmpty: 'Nessun template ancora. Salva il design della pagina corrente per riutilizzarlo in seguito.',
    saveAsTemplate: 'Salva come template',
    saveCurrentAsTemplate: 'Salva la pagina corrente come template',
    templateSaved: 'Template salvato',
    templateApplied: 'Template applicato',
    buildFromReference: 'Crea da riferimento',
    templateAppliedCount: 'Template applicato — {n} blocchi aggiunti',
    searchTemplates: 'Cerca template…',
    favorites: 'Preferiti',
    previewLive: 'Anteprima live',
    previewingTemplate: 'Anteprima',
    exitPreview: 'Esci',
    templateKind: 'Cosa includere',
    publish: 'Pubblica',
    unpublish: 'Annulla pubblicazione',
    templatePublished: 'Template pubblicato',
    templateUnpublished: 'Pubblicazione del template annullata',
    discoverTemplates: 'Scopri la community',
    discoverSubtitle: 'Template gratuiti pubblicati da altri creator su UniLink.',
    discoverEmpty: 'Nessun template pubblico ancora — sii il primo a pubblicarne uno.',
    pricing: 'Prezzi',
    fontRoles: {
      heading: 'Titolo',
      subtitle: 'Sottotitolo',
      body: 'Globale',
    },
  },
  table: {
    clicks: 'Clic',
    signups: 'Iscrizioni',
    views: 'Impression',
    orderNumber: 'Numero ordine',
    amount: 'Importo',
    credits: 'Crediti',
    invoice: 'Fattura',
    email: 'Email',
    card: 'Carta',
    currency: 'Valuta',
    name: 'Nome',
    contact: 'Contatto',
    optIn: 'Opt-in',
    notes: 'Note',
    address: 'Indirizzo',
    date: 'Data',
    action: 'Azione',
    custom: 'Personalizzato',
    status: 'Stato',
    tags: 'Tag',
    view: 'Visualizza',
    remove: 'Rimuovi',
    sendEmail: 'Invia email',
    details: 'Dettagli',
    purchases: 'Acquisti',
    order: 'Ordine',
    money: 'Denaro',
    type: 'Tipo',
    orderCode: 'Codice ordine',
  },
  settings: {
    title: 'Impostazioni',
    settings: 'impostazioni',
    accountSettings: 'Impostazioni account',
    email: 'Email',
    subscription: 'Abbonamento',
    billingHistory: 'Cronologia fatturazione',
    dueTo: 'Scadenza',
    subscriptionDueTo: 'Abbonamento in scadenza',
    cancelSubscription: 'Annulla abbonamento',
    cancelSubscriptionConfirm: 'Sei sicuro di voler annullare il tuo abbonamento?',
    subscriptionCancelled: 'Il tuo abbonamento è stato annullato. Il tuo piano rimane attivo fino alla fine del periodo di fatturazione.',
    subscriptionCancelError: `Annullamento dell'abbonamento non riuscito. Contatta l'assistenza.`,
    deleteFirst: 'Elimina definitivamente il tuo',
    deleteSecond: 'e tutti i suoi dati. Questa azione non può essere annullata.',
    account: {
      title: 'Account',
      usernameNotAvailable: 'Nome utente non disponibile',
      setupCustomDomain: 'Configura dominio personalizzato',
      subtitle: 'Email account, fatturazione, password e chiave API',
    },
    profile: {
      title: 'Profilo',
      usernameNotAvailable: 'Nome utente non disponibile',
      setupCustomDomain: 'Configura dominio personalizzato',
      subtitle: 'Gestisci nome utente, lingua, valuta, fuso orario',
      category: 'Categoria',
      categoryCaption: 'Inserisci la categoria del tuo profilo',
      usernameDesc: 'Il tuo handle pubblico',
      currencyDesc: 'Usata per guadagni e pagamenti',
      languageDesc: 'Lingua mostrata ai tuoi visitatori',
      timeZoneDesc: 'Per programmazione e analisi',
      categoryDesc: 'Descrive meglio il tuo profilo',
      privateProfile: 'Profilo privato',
      privateProfileDesc: 'Solo i follower approvati possono vedere il tuo profilo',
    },
    aiassistant: {
      title: 'Assistente AI',
      subtitle: 'Personalizza il tuo assistente AI per risposte migliori e più personalizzate',
      titleText: `Aiuta l'AI a capire chi sei per risposte più pertinenti`,
      customAiTitle: 'Istruzioni personalizzate',
      customAiPlaceholder: `Aggiungi istruzioni specifiche per l'AI...`,
      customAiDescription: `Queste istruzioni verranno applicate a ogni conversazione con l'AI`,
      nicknameTitle: `Come deve chiamarti l'AI?`,
      nicknamePlaceholder: 'Soprannome',
      titleBio: 'Bio/ Descrizione',
      bioPlaceholder: 'Raccontaci qualcosa di te...',
      occupation: 'Cosa fai?',
      occupationPlaceholder: `es. Studente di Ingegneria all'Università di Waterloo`,
      aboutYouTitle: 'Su di te',
      aboutYouTooltip: 'Racconta al tuo assistente AI qualcosa su di te',
      locationTitle: 'Posizione',
      locationPlaceholder: 'es. Kyiv, Ucraina',
      categoryTitle: 'Categoria',
    },
    notifications: {
      title: 'Notifiche',
      subtitle: 'Configura le notifiche su nuove email dei visitatori e ordini',
      text: 'Collega le app di messaggistica per ricevere notifiche su nuove email e ordini dei clienti',
      setUpWebhooks: 'Configura i webhook nella sezione Webhooks',
      save: 'Salva',
      connect: 'COLLEGA',
      disconnect: 'SCOLLEGA',
      webhook: 'Webhook',
      emailSubmit: 'Invio raccolta dati',
      formSubmit: 'Invio modulo',
      showSubmit: 'Invio negozio',
      digitalSubmit: 'Invio digitale',
      appointmentSubmit: 'Invio appuntamento',
      requestSubmit: 'Invio servizio',
      donationSubmit: 'Invio donazione',
      email: 'Email',
      settings: 'impostazioni',
      cartSubmit: 'Invio carrello',
      linkClick: 'Clic sul link',
      contactClick: 'Clic sul contatto',
      all: 'Tutti',
      updates: 'Aggiornamenti',
      messages: 'Messaggi',
      opportunities: 'Opportunità',
      insights: 'Approfondimenti',
      activity: 'Attività',
      system: 'Sistema',
      news: 'Novità',
      more: 'Mostra di più',
      less: 'Mostra di meno',
      connectedAccounts: 'Account collegati',
      addEmailAccount: 'Aggiungi account email',
    },
    paymentSystem: {
      title: 'Sistema di pagamento',
      subtitle: 'Configura i pagamenti tramite Stripe o PayPal',
      text: 'Visualizza commissioni',
      connected: 'Collegato',
      active: 'Accetta pagamenti sul sito',
      pending: 'In sospeso',
      disconnect: 'Disconnetti',
      connect: 'Collega',
      add: 'Aggiungi',
      ofYourAccount: 'del tuo account',
      save: 'Salva',
    },
    shop: {
      title: 'Negozio',
      subtitle: 'Impostazione categoria e proprietà',
      label: {
        title: 'Etichette',
        subtitle: 'Aggiungi etichette alle schede prodotto',
        addValue: 'Aggiungi valore',
        save: 'Salva',
        value: 'Valore',
        enterTitle: 'Inserisci il titolo',
        maximum: 'Il numero massimo di valori è 5',
        add: 'Aggiungi',
        edit: 'Modifica',
        labels: 'Etichette',
      },
      category: {
        title: 'Categorie',
        subtitle: 'Aggiungi una categoria ai tuoi prodotti',
        addCategory: 'Aggiungi categoria',
        save: 'Salva',
        maximum: 'Il numero massimo può essere',
        editTitle: 'Categoria',
        name: 'Nome',
        namePlaceholder: 'Inserisci la categoria',
        visibility: 'Visibilità',
        visible: 'Visibile',
        hidden: 'Nascosta',
        description: 'Descrizione',
        descriptionHint: 'La descrizione deve essere inferiore a 100 caratteri',
        descriptionPlaceholder: 'Aggiungi una breve descrizione',
        cover: 'Copertina',
        view: 'Visualizza',
        share: 'Condividi',
        linkCopied: 'Link copiato',
        saveFirst: 'Salva prima la categoria',
        moveOut: 'Sposta fuori',
      },
      property: {
        title: 'Proprietà',
        subtitle: 'Aggiungi una proprietà ai tuoi prodotti',
        addProperties: 'Aggiungi proprietà',
        properties: 'Proprietà',
        type: 'Tipo',
        typeTooltip: 'Tipo delle tue proprietà',
        titleModal: 'Titolo',
        titleModalTooltip: 'Nome delle tue proprietà',
        enterTitle: 'Inserisci il titolo',
        value: 'Valore',
        addValue: 'Aggiungi valore',
        maximum: 'Il numero massimo di valori può essere',
        save: 'Salva',
        cancel: 'Annulla',
        remove: 'Rimuovi',
        addPropertyToItem: `Aggiungi proprietà all'elemento`,
        add: 'Aggiungi',
        edit: 'Modifica',
        propertiesSmall: 'proprietà',
        required: 'Obbligatorio',
        requiredTooltip: `Imposta le proprietà obbligatorie per l'acquisto`,
        selectAll: 'Seleziona tutto',
      },
      actionButtons: {
        contentTab: 'Contenuto',
        designTab: 'Design',
        buttonTitle: 'Titolo del pulsante',
        buttonColor: 'Colore del pulsante',
        cancel: 'Annulla',
        save: 'Salva',
        maxChars: 'Massimo {count} caratteri',
        minChars: 'Minimo {count} caratteri',
        enterTitle: 'Inserisci un titolo per il pulsante',
        contactTooltip: 'Un modo per farsi contattare dai clienti: email, messaggio o modulo',
        contactNotConfigured: 'Imposta come i clienti ti contattano',
        methodEmail: 'Lettera via email',
        methodMessenger: 'Messenger',
        methodForm: 'Modulo di richiesta',
        enterAddress: 'Inserisci un indirizzo',
        invalidAddress: 'Indirizzo non valido',
        enterContact: 'Inserisci un numero o un nome utente',
        summaryFields: '{count} campi',
        dragToReorder: 'Trascina per riordinare',
        fieldName: 'Nome del campo',
        fieldRequired: 'Obbligatorio',
        deleteField: 'Elimina campo',
        enterFieldName: 'Inserisci il nome del campo',
        addAtLeastOneField: 'Aggiungi almeno un campo',
        maxFields: 'Massimo {count} campi',
        typeText: 'Testo',
        typeEmail: 'Email',
        typePhone: 'Telefono',
        preorderTooltip: 'Modulo di preordine per questo prodotto',
        preorderRowHint: 'Campi che compila l’acquirente: apri per modificare',
        saveFailed: 'Salvataggio non riuscito. Riprova.',
        preorderNotConfigured: 'Configura il modulo di preordine',
        enableAtLeastOneField: 'Attiva almeno un campo',
        enterSubmitTitle: 'Inserisci il titolo del pulsante di invio',
        invalidUrl: 'Link non valido',
        redirectHelper: 'Se lo lasci vuoto, il cliente resta sulla pagina e vede il testo qui sotto.',
        discardTitle: 'Chiudere senza salvare?',
        discardText: 'Le modifiche alle impostazioni del pulsante andranno perse.',
        discardContinue: 'Continua a modificare',
        discardClose: 'Chiudi',
        contactModalTitle: 'Pulsante Contact',
        preorderModalTitle: 'Pulsante di preordine',
        contactModalSubtitle: 'Un’azione per pulsante. Dove arriva il risultato lo imposti dopo',
        actionTab: 'Azione',
        methodFormDesc: 'Il cliente compila i campi',
        methodChat: 'Chat dal vivo',
        methodChatDesc: 'Una conversazione in tempo reale qui',
        methodMessengerDesc: 'WhatsApp, Telegram, Viber…',
        methodEmailDesc: 'Apre la posta del cliente',
        inboxDefaultNote: 'Per impostazione predefinita tutto resta nel tuo Unilink Inbox — potrai cambiarlo più tardi.',
        readyToSave: 'Pronto da salvare',
        apply: 'Applica',
        back: 'Indietro',
        pickAction: 'Scegli cosa fa il pulsante',
        buttonText: 'Testo sul pulsante',
        buttonBackground: 'Sfondo del pulsante',
        buttonTextColor: 'Colore del testo',
        lowContrastWarning: 'Il testo si confonde con lo sfondo: il cliente non riuscirà a leggere la scritta.',
        colorsSharedNote: 'I colori si applicano al pulsante sulla pagina del prodotto.',
        chatNoSetup: "Non c'è nulla da impostare: la chat si apre sulla pagina e la conversazione arriva nel tuo Inbox.",
        yourEmail: 'La tua email',
        yourEmailHelper: 'Al cliente si apre la posta con una lettera a questo indirizzo.',
        channelAndContact: 'Canale e contatto',
        singleChannelNote: "Il pulsante apre la chat nell'app scelta subito.",
        addContact: 'Aggiungi un contatto',
        deleteContact: 'Elimina contatto',
        contactsCount: '{count} contatti',
        maxContacts: 'Massimo {count} contatti',
        duplicateContact: "Questa app è già nell'elenco",
        multiChannelNote: "Il pulsante apre un elenco e il cliente sceglie l'app.",
        recapMessengers: 'Il cliente sceglie: {apps}',
        whatToAsk: 'Cosa chiedere',
        fieldsOfMax: '{count} di {max} campi',
        fieldOptional: 'Facoltativo',
        typeLongText: 'Testo lungo',
        duplicateField: 'Un campo con questo nome è già sopra',
        addReplyableField: 'Aggiungi una email o un telefono: altrimenti non ci sarà modo di rispondere',
        presetName: 'Nome',
        presetEmail: 'Email',
        presetPhone: 'Telefono',
        presetComment: 'Commento',
        presetOwnField: 'campo personale',
        thanksText: "Testo dopo l'invio",
        thanksPlaceholder: 'Grazie! Risponderemo nel corso della giornata.',
        recapForm: 'La richiesta arriva {targets}',
        recapChat: 'La conversazione arriva nel tuo Unilink Inbox',
        recapMessenger: 'Il cliente passa a {app}',
        recapEmail: 'Al cliente si apre la posta con una lettera a {address}',
        recapEmailFallback: 'il tuo indirizzo',
        recapTargetInbox: 'nel tuo Unilink Inbox',
        actionsLabel: 'Modi per contattarti',
        actionsOfMax: '{count} di {max}',
        actionsCount: '{count} azioni',
        addAction: 'Aggiungi azione',
        addFirstAction: 'Aggiungi il primo modo per farsi contattare',
        deleteAction: 'Elimina azione',
        actionNeedsAttention: 'Da completare',
        severalActionsNote: 'Ogni azione è un pulsante a sé sulla pagina del prodotto, in questo ordine.',
        methodAlreadyAdded: "Già nell'elenco",
        duplicateChannel: "Questo canale con questo contatto è già nell'elenco",
        duplicateTitle: 'Un altro pulsante usa già questo testo',
        defaultTitleForm: 'Contattaci',
        defaultTitleChat: 'Chatta con noi',
        defaultTitleEmail: 'Scrivici una email',
        buyModalTitle: 'Pulsante Buy',
        buyModalSubtitle: 'Porta l’acquirente direttamente al pagamento',
        buyTooltip: 'Il pulsante porta l’acquirente direttamente al pagamento',
        buyNoPrice: 'Solo testo, senza prezzo',
        priceOnButton: 'Prezzo sul pulsante',
        priceOnButtonHelper: 'Se lo lasci vuoto, il pulsante mostra solo il testo',
        invalidPrice: 'Il prezzo è solo un numero, es. 990',
        redirectModalTitle: 'Pulsante Redirect',
        redirectModalSubtitle: 'Porta a qualsiasi pagina tramite un link',
        redirectTooltip: 'Il pulsante apre qualsiasi pagina tramite un link',
        linkLabel: 'Link',
        linkPlaceholder: 'https://example.com/pagina',
        opensHost: 'Si aprirà: {host}',
        openInNewTab: 'Aprire in una nuova scheda',
        enterLink: 'Indica il link che apre questo pulsante',
        noLinkSet: 'Nessun link',
        preorderModalSubtitle: 'Raccoglie preordini prima dell’avvio delle vendite — senza pagamento',
        shipEta: 'Quando spedisci',
        shipEtaPlaceholder: 'es. entro il 15 settembre',
        shipEtaHelper: 'Lo mostriamo nel modulo — l’acquirente vede i tempi e lo chiede meno spesso',
        fieldsInForm: 'Campi nel modulo: {count}',
        enableFieldFirst: 'Attiva prima il campo',
        submitInForm: 'Testo del pulsante nel modulo',
        afterSubmit: 'Dopo l’invio',
        afterSubmitText: 'Mostrare un testo',
        afterSubmitUrl: 'Portare a una pagina',
        afterSubmitTextHelper: 'L’acquirente resta sulla pagina e legge questo testo',
        preorderThanksPlaceholder: 'Grazie! Ti scriveremo quando il prodotto sarà pronto.',
        enterRedirectUrl: 'Indica l’URL della pagina o torna a mostrare un testo',
      },
      preorderForm: {
        title: 'Modulo di preordine',
        subtitle: 'Configura i campi del modulo di preordine',
        fields: 'Campi',
        fieldsTooltip: 'Aggiungi campi al modulo',
        required: 'Obbligatorio',
        submitButton: 'Titolo del pulsante di invio',
        redirectUrl: 'URL di reindirizzamento (opzionale)',
        resultText: 'Testo del risultato',
        save: 'Salva',
        name: 'Nome',
        emailAddress: 'Indirizzo email',
        phone: 'Telefono',
        address: 'Indirizzo',
        comment: 'Commento',
      },
      shipping: {
        title: 'Modulo di checkout',
        subtitle: 'Campi che l’acquirente compila al momento dell’ordine',
        fields: 'Campi',
        fieldsTooltip: 'Aggiungi campi al modulo di spedizione',
        required: 'Obbligatorio',
        save: 'Salva',
        name: 'Nome',
        emailAddress: 'Indirizzo email',
        phone: 'Telefono',
        address: 'Indirizzo',
        comment: 'Commento',
        askDetails: 'Chiedere i dati dell’acquirente',
        askDetailsHint: 'Disattivato: il checkout accetta l’ordine senza modulo',
        askDetailsPaymentWarning:
          'Il checkout incassa online. Senza email la ricevuta non ha destinatario: lascia attiva almeno Email, oppure passa a «Prendi l’ordine, nessun pagamento».',
        askDetailsRedirectNote: 'Il checkout avviene su un altro sito: questi campi non vengono mai mostrati agli acquirenti.',
        askDetailsNoContactNote: 'L’ordine arriverà senza contatti. Lascia attivo Telefono se pensi di richiamare l’acquirente.',
        promoCode: 'Codice promozionale',
        addCustomField: 'Aggiungi campo personalizzato',
        addFormInfo: 'Aggiungi info modulo',
        editFormInfo: 'Modifica info modulo',
        type: 'Tipo',
        typeTooltip: 'Tipo di campo personalizzato',
        fieldName: 'Nome del campo',
        fieldNameTooltip: 'Nome per il campo personalizzato',
        placeholder: 'Segnaposto',
        placeholderTooltip: 'Segnaposto per il campo personalizzato',
        delete: 'Elimina',
        update: 'Aggiorna',
        add: 'Aggiungi',
      },
      delivery: {
        title: 'Metodi di consegna',
        subtitle: 'Spedizione, consegna e ritiro',
        loading: 'Caricamento…',
        inactive: 'inattivo',
        confirmDelete: 'Eliminare questo metodo di consegna?',
        category: {
          shipping: 'Spedizione',
          localDelivery: 'Consegna locale',
          selfPickup: 'Ritiro in sede',
        },
        rateType: {
          free: 'Gratuita',
          conditionalFree: 'Gratuita condizionata',
          flatRate: 'Tariffa fissa',
          customRates: 'Tariffe personalizzate',
          carrierApi: 'API corriere',
        },
        carrier: {
          custom: 'Corriere personalizzato',
        },
        add: {
          shipping: 'Aggiungi spedizione',
          localDelivery: 'Aggiungi consegna locale',
          selfPickup: 'Aggiungi ritiro in sede',
        },
        actions: {
          edit: 'Modifica',
          delete: 'Elimina',
          save: 'Salva',
          cancel: 'Annulla',
        },
        fields: {
          name: 'Nome',
          namePh: 'es. Spedizione standard',
          description: 'Descrizione',
          isActive: 'Attivo',
          estimatedDays: 'Giorni stimati',
          currency: 'Valuta',
          countryCodes: 'Codici paese (CSV)',
          carrier: 'Corriere',
          rateType: 'Tipo di tariffa',
          flatPrice: 'Prezzo fisso',
          freeThreshold: 'Gratuita oltre (subtotale)',
          fallbackPrice: 'Prezzo di riserva',
          customRates: 'Righe tariffe personalizzate',
          senderCity: 'Nome città del mittente',
          senderCityRef: 'Rif. città del mittente',
          pickupInstructions: 'Istruzioni per il ritiro',
          pickupCharge: 'Costo del ritiro',
          askPickupDateTime: 'Chiedi data/ora del ritiro al checkout',
        },
        rateRow: {
          subtotal: 'Per subtotale',
          weight: 'Per peso (g)',
          min: 'Min',
          max: 'Max',
          price: 'Prezzo',
          add: 'Aggiungi riga',
        },
      },
      legal: {
        title: 'Documenti legali',
        subtitle: 'Termini, privacy, resi',
        loading: 'Caricamento…',
        empty: 'Nessun documento legale ancora.',
        inactive: 'inattivo',
        required: 'obbligatorio',
        confirmDelete: 'Eliminare questo documento?',
        addNew: '+ Aggiungi documento',
        types: {
          terms: 'Termini di servizio',
          privacy: 'Informativa sulla privacy',
          returns: 'Politica di reso / rimborso',
          shipping: 'Politica di spedizione',
          cookies: 'Politica sui cookie',
          custom: 'Personalizzato',
        },
        fields: {
          title: 'Titolo',
          titlePh: 'es. Termini di servizio',
          type: 'Tipo di documento',
          content: 'Contenuto',
          contentPh: 'Scrivi qui il tuo testo legale…',
          isActive: 'Attivo',
          requireAcceptance: 'Richiedi accettazione al checkout',
        },
        actions: {
          edit: 'Modifica',
          delete: 'Elimina',
          save: 'Salva',
          cancel: 'Annulla',
        },
      },
      checkoutGroup: 'Checkout',
      serviceCharge: {
        title: 'Costo di servizio',
        subtitle: 'Aggiungi una commissione di servizio o una mancia a ogni ordine.',
        label: 'Descrizione',
        labelPh: 'es. Commissione di servizio 5% e mancia di consegna $3',
        rate: 'Percentuale',
        rateHint: `Percentuale del subtotale dell'ordine.`,
        amount: 'Importo',
        amountHint: 'Importo fisso aggiunto in cima.',
      },
      tip: {
        title: 'Mance',
        subtitle: 'Permetti ai clienti di aggiungere una mancia al loro ordine al checkout.',
        enable: 'Abilita mance',
        presets: 'Preset mancia (%)',
        noPresets: 'Nessun preset ancora — aggiungine uno qui sotto.',
        presetPh: 'es. 10',
        addPreset: '+ Aggiungi preset',
        presetsHint: 'Mostrati come pulsanti rapidi al checkout. Fino a 6.',
        remove: 'Rimuovi',
        allowCustom: 'Consenti importo personalizzato',
        label: 'Etichetta del messaggio',
        labelPh: 'es. Aggiungi una mancia per un ottimo servizio',
        save: 'Salva',
        saving: 'Salvataggio…',
      },
      orderNumber: {
        title: `Numero d'ordine`,
        subtitle: `Personalizza l'aspetto dei numeri d'ordine.`,
        next: `Prossimo numero d'ordine`,
        prefix: 'Prefisso',
        suffix: 'Suffisso',
        showInMessage: `Mostra nella fattura e nel messaggio d'ordine`,
        reset: `Reimposta numero d'ordine`,
      },
      orderMessage: {
        title: `Messaggio d'ordine`,
        subtitle: `Personalizza la conferma d'ordine inviata ai clienti.`,
        footer: 'Piè di pagina del messaggio',
        footerPh: 'es. Grazie per il tuo ordine! Seguici @yourbrand',
        footerHint: `Aggiunto a ogni messaggio di conferma d'ordine.`,
        plain: 'Messaggio semplice',
        plainHint: `Rimuovi tutta la formattazione dal messaggio d'ordine.`,
      },
      invoice: {
        title: 'Fattura',
        subtitle: 'Fattura personalizzata allegata agli ordini pagati.',
        upgrade: 'Passa a un piano superiore',
        showLogo: 'Mostra logo',
        header: 'Intestazione',
        footer: 'Piè di pagina',
        companyName: 'Nome azienda',
        companyEmail: 'Email azienda',
        companyPhone: 'Telefono azienda',
        companyAddress: 'Indirizzo azienda',
        companyAddressPh: 'Inserisci indirizzo',
      },
    },
    seo: {
      title: 'SEO',
      subtitle: 'Personalizza la tua pagina con meta tag SEO',
      titleText: 'Titolo',
      titlePlaceholder: 'Inserisci il titolo della pagina',
      description: 'Descrizione',
      descriptionPlaceholder: 'Inserisci la descrizione della pagina',
      favicon: 'Favicon',
      uploadFavicon: 'Carica favicon',
      imagePreview: 'Anteprima immagine',
      useCustom: 'Usa immagine personalizzata',
      save: 'Salva',
      visualise: `Visualizza come apparirà l'anteprima del tuo sito web su Google`,
      inMessengers: 'Nelle app di messaggistica',
      inSocial: 'Sui social media',
      searchEngine: 'Motore di ricerca',
      googleIndexable: 'Indicizzabile da Google',
      sitemap: {
        title: 'Sitemap',
        entryHint: 'Gestisci quali pagine e prodotti i motori di ricerca possono indicizzare.',
        setupLink: 'personalizza',
        mainEntry: 'Indicizza sito web',
        subtitle: 'Scegli quali pagine i motori di ricerca devono indicizzare. Le pagine disabilitate ricevono un tag noindex e vengono rimosse dalla tua sitemap.',
        mainPage: 'Pagina profilo principale',
        pagesSection: 'Pagine',
        pagesHint: `Attiva/disattiva l'indicizzazione per ogni pagina aggiuntiva del tuo sito.`,
        noPages: 'Nessuna pagina aggiuntiva ancora.',
        productsSection: 'Prodotti',
        productsHint: `Attiva/disattiva l'indicizzazione per le singole pagine prodotto.`,
        noProducts: 'Nessun prodotto ancora.',
        postsSection: 'Post',
        postsHint: `Attiva/disattiva l'indicizzazione per i singoli post.`,
        noPosts: 'Nessun post ancora.',
        blogSection: 'Articoli del blog',
        blogHint: `Attiva/disattiva l'indicizzazione per i singoli articoli del blog.`,
        noArticles: 'Nessun articolo del blog ancora.',
        loadMore: 'Carica altro',
        loading: 'Caricamento…',
      },
    },
    analytics: {
      title: 'Analytics',
      subtitle: 'Integra Facebook Pixel, Google Analytics e parametri UTM',
      facebookTooltip: 'Collega Facebook per visualizzare le analisi',
      googleAnalyticsTooltip: 'Google Analytics ti permette di misurare il ROI pubblicitario e di monitorare tutti i tuoi link.',
      googleTagManagerTooltip: 'Google Tag Manager ti permette di configurare e implementare istantaneamente i tag sul tuo sito web',
      tikTokPixelTooltip: `Il TikTok Pixel è un potente strumento di misurazione che traccia l'impatto dei tuoi annunci TikTok sul tuo sito web`,
      pinterestTag: 'Tag Pinterest',
      pinterestTagTooltip:
        'Il tag Pinterest è una porzione di codice che aggiungi al tuo sito web e che permette a Pinterest di tracciare i visitatori e le azioni che compiono sul tuo sito dopo aver visto il tuo annuncio Pinterest.',
      tag: 'tag',
      headerTagTooltip: `Incolla il tag che appare nell'head del tuo sito web`,
      bodyTagTooltip: 'Incolla il tag che appare nel body del tuo sito web',
      utmParameters: 'Parametri UTM',
      utmParametersTooltip: 'Raccogli i dati delle campagne con URL personalizzati. Aggiungi parametri agli URL per identificare le campagne che generano traffico.',
      makeAnalytics: 'Fai in modo che Google Analytics mostri il traffico UniLink come Social',
      the: 'Il',
      campaign: 'campaign',
      parameter: 'parametro viene impostato dinamicamente dal titolo di ogni post o link',
      save: 'Salva',
    },
    customDomain: {
      title: 'Dominio personalizzato',
      subtitle: 'Personalizza la tua pagina con un dominio personalizzato',
      titleTooltip: 'Aggiungi dominio personalizzato',
      save: 'Salva',
      connect: 'Connetti',
      connecting: 'Connessione in corso',
      instructions: 'Istruzioni',
      submit: 'Invia',
      submitting: 'Invio in corso...',
      enterDomain: 'Inserisci il tuo dominio',
      domainPlaceholder: 'tuo-dominio.com',
      steps: {
        submitting: 'Invio richiesta in corso',
        validation: 'Validazione del dominio',
        certificate: 'Provisioning del certificato',
        complete: 'Completato',
      },
      txtRecord: {
        title: 'Record TXT',
        description: 'Aggiungi il seguente record TXT alle impostazioni DNS:',
        verifyButton: 'Verifica record TXT',
        verifying: 'Verifica in corso...',
        verified: 'Record TXT verificato',
      },
      cnameRecord: {
        title: 'Record CNAME',
        description: 'Aggiungi il seguente record CNAME alle impostazioni DNS:',
        verifyButton: 'Verifica record CNAME',
        verifying: 'Verifica in corso...',
        verified: 'Record CNAME verificato',
      },
      dnsTable: {
        type: 'Tipo',
        host: 'Host',
        value: 'Valore',
        ttl: 'TTL',
        copy: 'Copia',
        copied: 'Copiato!',
      },
      provisioning: {
        title: 'Provisioning del certificato SSL in corso...',
        description: 'Potrebbe richiedere alcuni minuti. Attendi.',
        timeout: 'Il provisioning del certificato sta richiedendo più tempo del previsto. Riprova più tardi.',
      },
      complete: {
        title: 'HTTPS è stato attivato con successo sul tuo dominio.',
        connected: 'Connesso',
      },
      failed: {
        title: 'Connessione del dominio non riuscita',
        tryAgain: 'Riprova',
      },
      rootDomainWarning: 'I domini root richiedono che il tuo provider DNS supporti il CNAME flattening (es. Cloudflare, Route53).',
      deleteConfirm: {
        title: 'Disconnetti dominio',
        message: 'Sei sicuro di voler disconnettere questo dominio? Il tuo sito web non sarà più accessibile tramite questo dominio.',
        confirm: 'Disconnetti',
        cancel: 'Annulla',
      },
    },
    webhooks: {
      title: 'Webhook',
      subtitle: 'Invia notifiche di eventi in tempo reale a servizi esterni',
      webhook: 'Webhook',
      webhookTooltip: 'Aggiungi webhook',
      send: 'Invia eventi a siti di terze parti',
      webhookUrl: 'URL webhook (richiesta POST)',
      error: 'Inserisci un link corretto',
      save: 'Salva modifiche',
      enableWebhooks: 'Abilita webhook',
      enableDescription: 'Richieste POST sugli eventi selezionati',
      endpointUrl: 'URL endpoint',
      endpointTooltip: `L'URL che riceverà le richieste POST al verificarsi degli eventi selezionati`,
      endpointPlaceholder: 'https://example.com/api/webhook',
      events: 'Eventi',
      selectAll: 'Seleziona tutto',
      deselectAll: 'Deseleziona tutto',
      filterPlaceholder: 'Filtra eventi...',
      all: 'Tutti',
      none: 'Nessuno',
      active: 'Attivo',
      inactive: 'Inattivo',
      categories: {
        submissions: 'Invii',
        engagement: 'Coinvolgimento',
      },
      eventLabels: {
        SubmitHeaderSubscribe: 'Iscrizione header',
        SubmitHeaderMessage: 'Messaggio header',
        SubmitDataCollect: 'Raccolta dati',
        SubmitForm: 'Invio modulo',
        SubmitShop: 'Ordine shop',
        SubmitShopPreorder: 'Preordine shop',
        SubmitDigital: 'Prodotto digitale',
        SubmitAppointment: 'Appuntamento',
        SubmitService: 'Ordine servizio',
        SubmitEvent: 'Registrazione evento',
        SubmitCourse: 'Iscrizione corso',
        SubmitDonation: 'Donazione',
        SubmitMembership: 'Abbonamento',
        SubmitBlog: 'Acquisto blog',
        SubmitCoupon: 'Coupon utilizzato',
        SubmitTip: 'Mancia',
        SubmitLink: 'Acquisto link',
        SubmitProductMessage: 'Domanda sul prodotto',
        SubmitPodcast: 'Acquisto podcast',
        SubmitBooking: 'Prenotazione',
        SubmitRental: 'Noleggio',
        SubmitSingleProduct: 'Prodotto singolo',
        SubmitDiscount: 'Ordine con sconto',
        SubmitListing: 'Richiesta annuncio',
        SubmitUnlock: 'Sblocco contenuto',
        SubmitChatAi: 'Messaggio chat AI',
        ClickLink: 'Clic sul link',
        ClickContact: 'Clic sul contatto',
        AddToCart: 'Aggiungi al carrello',
        AddToCartSingleProduct: 'Prodotto singolo nel carrello',
        AddToWishlist: 'Aggiungi alla lista desideri',
        InitiateCheckout: 'Avvia checkout',
        DownloadFile: 'Download file',
        DownloadMusic: 'Download musica',
        CopyCoupon: 'Copia coupon',
        CopyDiscount: 'Copia sconto',
        QR_ScanQrCode: 'Scansione QR code',
        VisitPage: 'Visita pagina',
      },
    },
    sensitive: {
      title: 'Materiale sensibile',
      subtitle: 'Mostra un avviso di contenuto sensibile prima di visualizzare il tuo sito',
    },
    socialIntegration: {
      title: 'Integrazioni social',
      subtitle: 'Gestisci le tue integrazioni Instagram e TikTok',
      connectInstagram: 'Collega Instagram',
    },
    emailIntegration: {
      title: 'Integrazioni audience',
      subtitle: 'Trasferisci gli indirizzi email dei tuoi visitatori a MailChimp, Reply',
      emailCaption: `Aggiungi un'integrazione per trasferire gli indirizzi email dei tuoi follower a MailChimp`,
      mailChimp: 'Integrazioni MailChimp',
      selzy: 'Integrazioni Selzy',
      selzyCaption: 'Aggiungi una chiave API per trasferire gli indirizzi email dei tuoi follower a Selzy',
      sendPulse: 'Integrazioni SendPulse',
      sendPulseCaption: 'Aggiungi una chiave API per trasferire gli indirizzi email dei tuoi follower a SendPulse',
      reply: 'Integrazioni Reply',
      replyCaption: 'Aggiungi una chiave API per trasferire gli indirizzi email dei tuoi follower a',
      integrations: 'integrazioni',
    },
    calendarIntegration: {
      title: 'Integrazioni calendario',
      subtitle: 'Collega i tuoi servizi di calendario',
      calendly: 'Calendly',
      calendlyDescription: 'Collega Calendly per sincronizzare i tipi di evento e la disponibilità',
      googleCalendar: 'Google Calendar',
      googleCalendarDescription: 'Collega Google Calendar per sincronizzare gli eventi e creare link Google Meet',
      zoom: 'Zoom',
      zoomDescription: 'Collega Zoom per creare automaticamente i link delle riunioni',
      googleMeet: 'Google Meet',
      googleMeetDescription: 'Crea automaticamente link Google Meet (richiede Google Calendar)',
    },
    storage: {
      title: 'Archiviazione',
      subtitle: 'Salva gli ordini dei visitatori su Google Spreadsheet',
      storageCaption: `Aggiungi un'integrazione per salvare tutti gli ordini dei clienti su Google Spreadsheet`,
      emailSignup: 'Iscrizione email',
      emailSignupsCaption: 'Scegli la tabella per salvare le iscrizioni email',
      formSignups: 'Iscrizione modulo',
      forSignupsCaption: 'Scegli la tabella per salvare le iscrizioni dal modulo',
      shopOrders: 'Ordini negozio',
      shopOrderCaption: 'Scegli la tabella per salvare gli ordini del negozio',
      disconnect: 'Scollega spreadsheet',
      storageUsage: 'Utilizzo archiviazione',
      of: 'di',
      uses: 'Questa app utilizza',
      space: 'del tuo spazio su disco gratuito',
      view: 'visualizza dettagli',
      noItems: 'Non ci sono elementi',
      files: 'File',
      images: 'Immagini',
      videos: 'Video',
      audio: 'Audio',
      settings: 'impostazioni',
      free: 'libero',
      needMoreSpace: 'Ti serve più spazio?',
      unlockStorage: 'Sblocca spazio illimitato, video 4K',
      upgradePlan: 'Aggiorna piano',
      addFile: 'Aggiungi file',
      uploading: 'Caricamento...',
      dragDrop: 'o trascina qui',
      noFilesYet: 'Nessun file ancora',
      noImagesYet: 'Nessuna immagine ancora',
      noVideosYet: 'Nessun video ancora',
      noAudioYet: 'Nessun audio ancora',
      filesHint: 'Carica PDF, documenti e altri download per allegarli ai link della tua pagina bio.',
      imagesHint: 'Carica immagini da usare in tutta la tua pagina bio.',
      videosHint: 'Carica video da incorporare nella tua pagina bio.',
      audioHint: 'Carica tracce audio da condividere sulla tua pagina bio.',
    },
    accountLabel: 'Account',
    profileLabel: 'Profilo',
    switchProfile: 'Cambia profilo',
    createNewProfile: 'Crea nuovo profilo',
    active: 'Attivo',
    currentPlan: 'Piano attuale',
    freePlanHint: 'Passa a Pro per sbloccare le funzioni Pro e rimuovere i limiti.',
    to: 'a',
    renews: 'Si rinnova',
    passwordChangeDesc: 'Cambia la password del tuo account',
    apiKeyDesc: 'Usa questa chiave per autenticare le richieste API',
    apiDocumentation: 'Documentazione API',
    dashboardLanguageDesc: `Lingua dell'interfaccia per il tuo account`,
    manualPayments: {
      title: 'Pagamenti manuali / offline',
      hint: `I clienti pagano offline (bonifico, contanti, QR). Confermi l'ordine manualmente.`,
      save: 'Salva',
      iban: 'IBAN',
      accountHolder: `Nome dell'intestatario del conto`,
      bankName: 'Nome della banca',
      phone: 'Telefono',
      payeeName: 'Nome del beneficiario',
      instruction: 'Istruzione',
      instructionHint: 'Decora con **grassetto** ~barrato~ _corsivo_',
      requireProof: 'Richiedi prova di pagamento',
      requireProofHint: 'Per completare il checkout, i clienti devono caricare uno screenshot (ricevuta, conferma del bonifico o qualsiasi prova di pagamento).',
      markPaidOnConfirm: 'Segna come pagato alla conferma del cliente',
      markPaidOnConfirmHint: `Aggiorna automaticamente lo stato del pagamento a 'Pagato' quando il cliente conferma il pagamento.`,
      contactBeforePay: 'Abilita contatto con il venditore prima del pagamento',
      contactBeforePayHint: 'Consente ai clienti di saltare il pagamento per scrivere al venditore, aumentando le richieste ma creando fiducia e riducendo le cancellazioni.',
    },
    developerApi: {
      title: 'API per sviluppatori',
      subtitle: 'Crea chiavi API per accedere ai tuoi ordini, prodotti e clienti tramite gli endpoint /api/v2.',
      keyName: 'Nome della chiave',
      keyNamePh: 'es. Sincronizzazione magazzino',
      scopes: 'Permessi',
      scopeLabels: {
        'orders:read': 'Leggi ordini',
        'products:read': 'Leggi prodotti',
        'products:write': 'Aggiorna scorte prodotti',
        'customers:read': 'Leggi clienti',
      },
      create: 'Crea chiave',
      creating: 'Creazione…',
      created: 'Chiave API creata',
      copyWarning: 'Copia questa chiave ora — non verrà più mostrata.',
      done: 'Fatto',
      revoke: 'Revoca',
      revoked: 'Revocata',
      confirmRevoke: 'Revocare questa chiave API? Le app che la usano smetteranno di funzionare.',
      empty: 'Nessuna chiave API ancora.',
    },
    whatsapp: {
      title: 'WhatsApp Business',
      subtitle: 'Connetti il tuo numero WhatsApp Business per ricevere e rispondere ai messaggi dei clienti.',
      phoneNumberId: 'ID numero di telefono',
      accessToken: 'Token di accesso',
      displayPhone: 'Telefono visualizzato (facoltativo)',
      connect: 'Connetti',
      connecting: 'Connessione…',
      connected: 'Connesso',
      disconnect: 'Disconnetti',
      confirmDisconnect: 'Disconnettere WhatsApp?',
      webhookHelp: 'Imposta questo Callback URL e Verify token nella tua Meta App → WhatsApp → Configurazione:',
      webhookUrl: 'Callback URL',
      verifyToken: 'Verify token',
      inbox: 'Posta in arrivo',
      noMessages: 'Nessun messaggio ancora.',
      selectThread: 'Seleziona una conversazione.',
      replyPlaceholder: 'Scrivi un messaggio…',
      send: 'Invia',
      broadcast: {
        title: 'Broadcast',
        audienceInbox: 'Contatti in posta in arrivo',
        audienceCrm: 'Pubblico CRM (template)',
        message: 'Messaggio',
        inboxHint: 'Testo libero — consegnato solo ai contatti entro la finestra di assistenza clienti di 24h.',
        templateName: 'Nome del template',
        templateLang: 'Lingua del template',
        crmHint: 'Usa un template WhatsApp approvato — necessario per raggiungere i contatti fuori dalla finestra di 24h.',
        send: 'Invia broadcast',
        sending: 'Invio…',
        empty: 'Nessun broadcast ancora.',
        sent: 'inviati',
        failed: 'falliti',
      },
      autoReply: {
        title: 'Risposte automatiche',
        type: 'Tipo',
        typeKeyword: 'Parola chiave',
        typeGreeting: 'Saluto (primo messaggio)',
        typeAway: 'Assenza (fuori orario)',
        keyword: 'Parola chiave',
        from: 'Dalle ore',
        to: 'Alle ore',
        reply: 'Testo della risposta',
        add: 'Aggiungi regola',
        empty: 'Nessuna regola di risposta automatica ancora.',
        delete: 'Elimina',
      },
    },
  },
  productStore: {
    title: 'Mostra la scheda Negozio sul tuo link-in-bio',
    subtitle: 'Il tuo Negozio è attualmente nascosto.',
  },
  sections: {
    splashScreen: {
      title: 'Splash Screen',
      subtitle: 'Appare durante il caricamento della pagina',
    },
    promo: {
      title: 'Barra promo',
      subtitle: 'Evidenzia per mostrare le tue promozioni',
      masterPromoMessage: 'La Master Promobar è attualmente attiva. Se desideri creare una promobar personalizzata per questa pagina, devi prima disattivare la Master Promobar.',
      titlePlaceholder: 'Benvenuto sul mio sito!',
      switcherIsMasterPromobar: 'Mostra su tutte le pagine',
    },
    contact: {
      title: 'Contatti',
      subtitle: 'Offri un modo per comunicare con te',
      caption: 'Aggiungi pulsanti messenger per una connessione rapida tra te e i tuoi clienti in un clic',
      tooltip: 'I Contatti permettono agli utenti di comunicare direttamente con te. Aggiungi il tuo telefono, email, messenger o posizione',
      addNewContact: 'Aggiungi nuovo contatto',
      addContact: 'Aggiungi contatto',
      chooseContact: 'Scegli contatto',
      enterLink: 'Inserisci il link del tuo contatto',
      showDetails: 'Mostra dettagli',
      enterAnyContact: 'Inserisci almeno un contatto',
      enterAnyContactCaption: '(WhatsApp, Telegram, Viber, Messenger)',
    },
    membership: {
      title: 'Abbonamento',
      subtitle: 'Crea un abbonamento gratuito o a pagamento ai tuoi contenuti',
      addNewTier: 'Aggiungi nuovo livello',
      editTier: 'Modifica livello',
      name: 'Nome',
      nameCaption: 'Inserisci il nome del tuo livello',
      price: 'Prezzo mensile',
      priceCaption: 'Inserisci il prezzo del tuo livello',
      month: 'mese',
      image: 'Immagine',
      imageCaption: `Carica un'immagine per il tuo livello`,
    },
    pricing: {
      title: 'Listino prezzi',
      subtitle: 'Crea un menu con i prezzi',
      add: 'Aggiungi nuovo elemento',
      edit: 'Modifica elemento',
      name: 'Nome',
      nameCaption: 'Inserisci il nome del tuo elemento',
      duration: 'Attributo',
      durationCaption: 'Inserisci tempo, quantità o durata del tuo elemento',
      category: 'Categoria',
      categoryCaption: 'Inserisci la categoria del tuo elemento',
      price: 'Prezzo',
      priceCaption: 'Inserisci il prezzo del tuo elemento',
      month: 'mese',
      image: 'Immagine',
      imageCaption: `Carica un'immagine per il tuo elemento`,
    },
    subscribe: {
      dataCollectTitle: 'Raccolta dati',
      title: 'Iscriviti',
      subtitle: 'Raccogli email o numeri di telefono dai tuoi visitatori',
      instructionsMessage: 'Aggiungi un campo di iscrizione email alla tua pagina così i visitatori potranno iscriversi facilmente!',
      instructionsLink: 'Invia le email a MailChimp per gestire campagne di marketing.',
      sectionHeaderCaption: 'Iscriviti alla nostra newsletter',
      collecting: 'Raccolta',
      collectingCaption: 'Scegli il tipo di campo',
      addDataToCollect: 'Aggiungi dati da raccogliere',
      email: 'Email',
      enterEmail: `Inserisci l'email`,
      thanksForEmail: 'Grazie per la tua email',
      phone: 'Telefono',
      telegram: 'Telegram',
      facebook: 'Facebook',
      instagram: 'Instagram',
      twitter: 'X (Twitter)',
      youtube: 'Youtube',
      whatsapp: 'Whatsapp',
      viber: 'Viber',
      messenger: 'Messenger',
      modalTitle: 'Aggiungi link aggiornati',
      placeholder: 'Segnaposto',
      placeholderCaption: 'Inserisci il testo segnaposto',
      button: 'Pulsante',
      buttonCaption: `Testo che motiverà il visitatore a inserire l'email (sconto del 10%, iscriviti ora, scarica il file ecc.)`,
      submitButton: 'Pulsante di invio',
      enterButton: 'Pulsante Invio',
      thanksMessage: 'Messaggio di ringraziamento',
      thanksMessageCaption: 'Messaggio di ringraziamento per i tuoi iscritti',
      resultAction: `Azione (dopo l'invio)`,
      resultActionCaption: 'Azione dopo la compilazione del modulo',
      sendAnEmail: `Invia un'email`,
      downloadFile: 'Scarica file',
      redirect: 'Reindirizza',
      messageBody: 'Corpo del messaggio',
      messageBodyCaption: `Questi dati saranno inviati all'email dell'utente come regalo per la sua email (coupon, link per il download del file, ecc.)`,
      integration: 'Integrazione',
      integrationCaption: 'Trasferisci gli indirizzi email dei tuoi visitatori a MailChimp, Reply',
      storage: 'Archiviazione',
      storageCaption: `Salva l'ordine dei visitatori in un foglio di calcolo di Google`,
      maxSize: 'Puoi aggiungere al massimo 3 canali',
    },
    text: {
      title: 'Testo',
      subtitle: 'Scrivi qualcosa su di te/la tua azienda',
      trimBio: 'Pulsante Mostra altro',
    },
    header: {
      title: 'Intestazione',
      subtitle: 'Immagine o video in primo piano ingrandito sulla tua pagina',
      verifiedBadge: 'Badge verificato',
      showProfilePic: 'Mostra immagine del profilo',
      profilePicRatio: 'Proporzioni',
      profilePicRatioSquare: 'Quadrato',
      profilePicRatioLandscape: 'Orizzontale',
      profilePicRatioPortrait: 'Verticale',
      namePlaceholder: 'Il tuo nome',
      shortBioPlaceholder: 'Le mie informazioni brevi',
      externalLinkPlaceholder: 'URL',
      locationPlaceholder: 'Città',
      addSocial: '+ Aggiungi social',
      addCover: '+ Aggiungi copertina',
      addButton: '+ Aggiungi pulsante',
      addText: '+ Aggiungi testo',
      addLabel: '+ Aggiungi etichetta',
      subtitleName: `Personalizza l'aspetto del tuo nome`,
      subtitleShortBio: `Personalizza l'aspetto della tua biografia breve`,
      shortBioSize: 'Dimensione bio breve',
      subtitleShortBioSize: 'Puoi modificare la dimensione della bio breve',
      subtitleLocation: 'Imposta la città/paese per indirizzare i visitatori a un luogo specifico',
      headerCoverWarningMessage: 'Il tuo browser non supporta il tag video.',
      headerCoverTitle: `Imposta la copertina sopra l'intestazione`,
      coverHeight: 'Altezza copertina',
      subtitleCoverHeight: `Puoi modificare l'altezza della copertina`,
      coverDarkness: 'Oscurità copertina',
      subtitleCoverDarkness: `Trascina il cursore per scurire l'immagine di copertina`,
      nameSize: 'Dimensione nome',
      subtitleNameSize: 'Puoi modificare la dimensione del nome',
      positionText: 'Posizione nome',
      subtitlePositionName: 'Trascina il cursore per impostare la posizione del nome',
      positionContent: 'Posizione contenuto',
      subtitlePositionContent: 'Imposta la posizione per bio, link, posizione',
      coverText: 'Testo sulla copertina',
      subtitleCoverText: 'Aggiungi testo alla tua copertina',
      position: 'Posizione',
      subtitlePosition: 'Trascina il cursore per impostare la posizione del pulsante',
      buttonCover: 'Pulsante sulla copertina',
      subtitleButtonCover: `Aggiungi un pulsante alla tua copertina scegliendo un'azione`,
      subtitleFollow: 'Il pulsante Segui consente agli utenti di seguire le tue novità',
      buttonOpacity: `Trascina il cursore per modificare l'opacità del pulsante`,
      subtitleCart: `Icona del carrello per offrire un'esperienza di acquisto`,
      subtitleDirect: 'Pulsante rapido per indirizzare i visitatori alle app di messaggistica',
      subtitleCTAButton: `Pulsante (call to action) che invoglia l'utente a cliccare`,
      subtitleSocialLinks: 'Dai un aspetto visivo ai tuoi social network',
      chooseSocialLink: 'Scegli il link social',
      alignSocialLink: 'Allineamento dei link social',
      enterYourSocialLink: 'Inserisci il tuo link social',
      blockShadow: 'Ombra del blocco',
      activeButtonPosition: 'Posizione del pulsante attivo',
      gradientColor: 'Colore gradiente',
      bottomGradient: 'Gradiente inferiore',
      autoGradient: 'Auto',
      customGradient: 'Personalizzato',
      transparentGradient: 'Trasparente',
      uploadLogo: 'Carica logo',
      customBackground: 'Sfondo personalizzato',
      headingLabel: 'Etichetta intestazione',
      customizeLabel: `Personalizza l'aspetto dell'etichetta dell'intestazione`,
      labelText: `Testo dell'etichetta`,
      enterLabelText: `Inserisci il testo per l'etichetta dell'intestazione`,
      verticalCropStep: 'foto verticale',
      squareCropStep: 'avatar quadrato',
      topButtons: 'Pulsanti superiori',
      bottomButtons: 'Pulsanti inferiori',
      buttonSubtitleLanguage: 'Selettore lingua',
      buttonSubtitleContact: 'Chiama / messaggio',
      buttonSubtitleCart: 'Carrello',
      buttonSubtitleCta: 'Call to action',
      buttonSubtitleMessage: 'Messaggio',
      buttonSubtitleSubscribe: 'Iscriviti',
      buttonSubtitleQrcode: 'Codice QR',
      buttonSubtitleSearch: 'Ricerca prodotti',
      buttonDisabledHint: 'Nascosto · disabilitato',
      gradientPositionLabel: 'Posizione ombra',
      gradientPositionPhoto: 'Sotto la foto',
      gradientPositionHeader: `Più in basso nell'header`,
      bottomBadge: 'Sfumatura inferiore',
      addTint: 'Aggiungi sfumatura',
      bottomBadgeText: 'Testo (facoltativo)',
      bottomBadgePreset: 'Preset',
      bottomBadgeShape: 'Forma',
      bottomBadgeSize: 'Altezza',
      bottomBadgeAction: 'Azione',
      bottomBadgeBgColor: 'Colore di sfondo',
      bottomBadgeTextColor: 'Colore del testo',
      bottomBadgeGradientFrom: 'Gradiente da',
      bottomBadgeGradientTo: 'Gradiente a',
      bottomBadgeGradientAngle: 'Angolo del gradiente',
    },
  },
  billingHistory: {
    title: 'Cronologia fatturazione',
    invoices: 'Fatture',
    messageText: 'Non hai ancora una cronologia dei pagamenti.',
  },
  migrate: {
    title: 'Hai LinkTree o Taplink?',
    text: 'Incolla il link e migra a UniLink con un solo click!',
    button: 'Migra',
  },
  pages: {
    title: 'Pagine',
    addPage: 'Aggiungi pagina',
    addNewPage: 'Aggiungi nuova pagina',
    deleteTitle: 'Sei sicuro di voler eliminare questa pagina?',
    managePage: 'Gestisci schede',
    empty: 'Questa pagina non ha ancora nessun blocco.',
    dragAndDrop: 'Trascina e rilascia le altre schede per riordinarle',
    pageNavigation: 'Impostazioni di navigazione della pagina',
    goToDesign: 'Vai alle impostazioni di design',
    viewArchive: 'Visualizza archivio',
    archivedBlocks: 'Blocchi archiviati',
    noArchivedBlocks: 'Mantieni la tua pagina pulita e ordinata archiviando i blocchi che non stai utilizzando.',
    archiveAllUnpublished: 'Archivia tutti i blocchi non pubblicati',
    restore: 'Ripristina',
    permanentDelete: 'Elimina definitivamente',
  },
  analytics: {
    lifeTimeAnalytics: 'Analisi a vita',
    impressions: 'Impression',
    impressionsText: 'Andamento delle statistiche delle impression per il periodo scelto',
    clicks: 'Click',
    clicksText: 'Andamento degli eventi "click" per il periodo scelto',
    signUps: 'Iscrizioni',
    signUpsText: 'Andamento degli eventi "close" per il periodo scelto',
    totalInteractions: 'Interazioni',
    totalInteractionsText: 'Click e iscrizioni tramite modulo per il periodo scelto',
    engagementRate: 'Tasso di coinvolgimento',
    engagementRateText: 'Percentuale di visualizzazioni del profilo che hanno portato a un’interazione',
    visitor: 'Sorgenti dei visitatori',
    country: 'Paese',
    countries: 'Paesi',
    linkClicks: 'Click sui link',
    content: 'Contenuto',
    views: 'Visualizzazioni',
    links: 'Link',
    products: 'Prodotti',
    blocks: 'Blocchi',
    pages: 'Pagine',
    clicksLower: 'clic',
    of: 'di',
    noContentData: 'Ancora nessun dato per il periodo selezionato',
  },
  aiInsights: {
    title: 'AI Insights',
    generate: 'Analizza il mio profilo',
    description: `Ottieni raccomandazioni basate sull'AI per migliorare le performance del tuo profilo.`,
    analyzing: 'Analisi del profilo in corso...',
    refresh: 'Aggiorna',
    action: 'Azione',
  },
  post: {
    subscriptionTypePlaceholder: `Disponibile per l'abbonamento 'type' e superiori`,
    postButtonText: 'Post',
    newPostPlaceholder: 'A cosa stai pensando',
    free: 'Free',
    pro: 'Pro',
    premium: 'Premium',
    noPost: 'Non hai ancora post',
    editPost: 'Modifica post',
  },
  preview: {
    buy: 'Acquista',
    connect: 'Connetti',
  },
  activeButton: {
    initialText: 'Sito web',
    inputPlaceholder: 'Cerca azioni...',
    existing: 'Esistente',
    redirect: 'Reindirizza',
    scroll: 'Scorri',
    title: 'Pulsante attivo',
    modalTitle: 'Azione del pulsante attivo',
    subtitle: `Pulsante che invita l'utente a compiere un'azione`,
    next: 'Avanti',
    save: 'Salva',
    opensALinkFromLinksBlock: 'Apre un link dal blocco Link',
    url: 'URL',
    opensAWebsite: 'Apre un sito web',
    openInApp: `Apri nell'app`,
    addAction: 'Aggiungi azione',
    actionTitle: 'Azione',
    actionCaption: 'Modifica tipo di azione',
    chooseOption: `Scegli un'opzione`,
    tellPeople: 'Indica agli utenti come interagire con il pulsante azione',
    urlRedirect: 'Reindirizzamento URL',
    customUrl: 'URL personalizzato',
    customUrlText: 'Apre un sito web',
    links: 'Link',
    linksText: 'Apre un link dal blocco Link',
    downloadDocument: 'Scarica documento',
    sendEmail: 'Invia email',
    opensEmailClient: 'Apre il client email',
    phoneCall: 'Chiamata',
    initiatesPhoneCall: 'Avvia una chiamata',
    navigation: 'Navigazione',
    openPage: 'Apri pagina',
    opensInternalPage: 'Apre pagina interna',
    openPageText: 'Apre pagina interna',
    openProduct: 'Apri prodotto',
    openProductText: 'Apre la pagina prodotto dallo Store',
    openBlog: 'Apri blog',
    opensBlogPageFromStore: 'Apre la pagina blog dallo Store',
    openBlock: 'Apri blocco',
    opensContentBlock: 'Apre il blocco contenuto',
    openItem: 'Apri elemento',
    opensItemPageFromStore: `Apre la pagina dell'elemento dallo Store`,
    showNewModal: 'Mostra nuova finestra',
    displayContentInModalWindow: 'Mostra contenuto in una finestra modale',
    showProduct: 'Mostra prodotto',
    displayProductInModalWindow: 'Mostra prodotto in una finestra modale',
    showBlog: 'Mostra blog',
    scrollToBlock: 'Scorri al blocco',
    scrollToBlockText: 'Scorri al blocco di pagina specificato',
    scrollToItem: `Scorri all'elemento`,
    action: 'Azione',
    showBlock: 'Mostra blocco',
    showBlockText: 'Blocco di contenuto dallo Store',
    showItem: 'Mostra elemento',
    showItemText: `Apre la pagina dell'elemento dallo Store`,
    linksCaption: 'Link',
    linksTooltip: 'Scegli un link dal blocco link',
    pagesCaption: 'Pagine',
    pagesTooltip: 'Scegli una pagina dalle pagine',
    productsCaption: 'Prodotti',
    productsTooltip: `Scegli un prodotto dall'elenco`,
    blocksCaption: 'Blocchi',
    blocksTooltip: `Scegli un blocco dall'elenco`,
    itemsCaption: 'Elementi',
    itemsTooltip: `Scegli un elemento dall'elenco`,
    showProductText: 'Mostra il prodotto in una finestra modale sulla pagina',
    more: 'Mostra di più',
    less: 'Mostra di meno',
    showNewModalTitle: 'Dati nuova modale',
    uploadDocumentTitle: 'Clicca per caricare o trascina qui',
    uploadProgressTitle: 'Caricamento in corso...',
    haveNoModal: 'Non hai alcuna modale',
    haveModal: 'Hai selezionato la modale',
    openNewModalHandler: 'Crea nuova modale',
    linkGroupSubTitle: 'Seleziona un blocco',
    linkItemSubTitle: 'Seleziona un link',
    urlItemSubTitle: 'URL del sito web',
    openInAppItemSubTitle: `URL dell'app`,
    sendEmailItemSubTitle: 'Indirizzo email',
    phoneCallItemSubTitle: 'Numero di telefono',
    openPageGroupSubTitle: 'Seleziona pagina',
    openPageItemSubTitle: 'Seleziona pagina',
    openProductGroupSubTitle: 'Seleziona tipo di prodotto',
    openProductItemSubTitle: 'Seleziona prodotto',
    openBlogGroupSubTitle: 'Seleziona canale blog',
    openBlogItemSubTitle: 'Seleziona articolo del blog',
    openBlockGroupSubTitle: 'Seleziona pagina',
    openBlockItemSubTitle: 'Seleziona blocco',
    openItemGroupSubTitle: 'Seleziona blocco',
    openItemItemSubTitle: 'Seleziona elemento',
    showProductGroupSubTitle: 'Seleziona tipo di prodotto',
    showProductItemSubTitle: 'Seleziona prodotto',
    showBlogGroupSubTitle: 'Seleziona canale blog',
    showBlogItemSubTitle: 'Seleziona articolo del blog',
    showBlockGroupSubTitle: 'Seleziona pagina',
    showBlockItemSubTitle: 'Seleziona blocco',
    showItemGroupSubTitle: 'Seleziona blocco',
    showItemItemSubTitle: 'Seleziona elemento',
    scrollToBlockGroupSubTitle: 'Seleziona pagina',
    scrollToBlockItemSubTitle: 'Seleziona blocco',
    scrollToItemGroupSubTitle: 'Seleziona blocco',
    scrollToItemItemSubTitle: 'Seleziona elemento',
    linkGroupPlaceholder: 'Scegli un blocco...',
    linkItemPlaceholder: 'Scegli un link...',
    openPageItemPlaceholder: 'Scegli una pagina...',
    openProductGroupPlaceholder: 'Scegli un tipo di prodotto...',
    openProductItemPlaceholder: 'Scegli un prodotto...',
    showProductGroupPlaceholder: 'Scegli un gruppo di prodotti...',
    showProductItemPlaceholder: 'Scegli un prodotto...',
    openBlogGroupPlaceholder: 'Scegli un canale blog...',
    openBlogItemPlaceholder: 'Scegli un articolo del blog...',
    openBlockGroupPlaceholder: 'Scegli una pagina...',
    openBlockItemPlaceholder: 'Scegli un blocco...',
    openItemGroupPlaceholder: 'Scegli una pagina e un blocco...',
    openItemItemPlaceholder: 'Scegli un elemento...',
    showBlogGroupPlaceholder: 'Scegli un gruppo di blog...',
    showBlogItemPlaceholder: 'Scegli un articolo...',
    showBlockGroupPlaceholder: 'Scegli una pagina...',
    showBlockItemPlaceholder: 'Scegli un blocco...',
    showItemGroupPlaceholder: 'Scegli una pagina e un blocco...',
    showItemItemPlaceholder: 'Scegli un elemento...',
    scrollToBlockGroupPlaceholder: 'Scegli una pagina...',
    scrollToBlockItemPlaceholder: 'Scegli un blocco...',
    scrollToItemGroupPlaceholder: 'Scegli una pagina e un blocco...',
    scrollToItemItemPlaceholder: 'Scegli un elemento...',
    linkReadable: 'Link',
    urlReadable: 'URL',
    openInAppReadable: `Apri nell'app`,
    downloadDocumentReadable: 'Scarica documento',
    sendEmailReadable: 'Invia email',
    phoneCallReadable: 'Chiamata',
    openPageReadable: 'Apri pagina',
    openProductReadable: 'Apri prodotto',
    showNewModalReadable: 'Mostra nuovo modale',
    showProductReadable: 'Mostra prodotto',
    openBlogReadable: 'Apri blog',
    openBlockReadable: 'Apri blocco',
    openItemReadable: 'Apri elemento',
    showBlogReadable: 'Mostra blog',
    showBlockReadable: 'Mostra blocco',
    showItemReadable: 'Mostra elemento',
    scrollToBlockReadable: 'Scorri al blocco',
    scrollToItemReadable: `Scorri all'elemento`,
  },
  design: {
    textColorHint: 'Il colore del contenuto di questo blocco. L’intestazione ha un colore proprio.',
    tabs: 'Schede',
    imageView: 'Vista immagine',
    preview: 'Anteprima',
    buttonOpacity: 'Opacità pulsante',
    buttonBorder: 'Bordo pulsante',
    buttonShadow: 'Ombra pulsante',
    itemView: 'Vista elemento',
    itemViewTooltip: 'Scegli vista elemento',
    itemLayout: 'Layout elemento',
    itemLayoutTooltip: 'Scegli layout elemento',
    top: 'Alto',
    center: 'Centro',
    bottom: 'Basso',
    bottomLeft: 'In basso a sinistra',
    bottomHorizontal: 'In basso orizzontale',
    under: 'Sotto',
    title: 'Titolo',
    titleButton: 'Titolo e pulsante',
    displayOptions: 'Opzioni di visualizzazione',
    displayOptionsTooltip: 'Scegli opzioni di visualizzazione',
    landscape: 'Orizzontale',
    square: 'Quadrato',
    portrait: 'Verticale',
    desktopMode: 'Modalità desktop',
    mobile: 'Compatto',
    desktop: 'Largo',
    responsive: 'Responsive',
    custom: 'Personalizzato',
    templates: 'Template',
    chooseTemplates: 'Scegli i tuoi template',
    viewAll: 'Vedi tutti',
    previousTheme: 'Nota che il tema precedente verrà eliminato definitivamente.',
    useThisTemplate: 'Usa questo template',
    notSupportedVideo: 'Il tuo browser non supporta il tag video.',
    photosBy: 'Foto di',
    animationBy: 'Animazione di',
    searchTheSame: 'Cerca lo stesso termine di nuovo per risultati diversi.',
    addImage: `Aggiungi un'immagine`,
    addVideo: 'Aggiungi un video',
    orSelectFrom: 'oppure seleziona da',
    noImagesYet: 'Ancora nessuna immagine',
    noVideosYet: 'Ancora nessun video',
    videoBy: 'Video di',
    hamburgerMenu: 'Menu hamburger',
    menuContent: 'Contenuto del menu',
    menuShowContacts: 'Mostra contatti',
    menuShowAddress: 'Mostra indirizzo',
    menuAddress: 'Indirizzo',
    menuAddressCaption: 'Se vuoto, viene preso dal blocco Contatti',
    menuShowCta: 'Mostra pulsante',
    menuCtaText: 'Testo del pulsante',
    menuCtaCaption: 'Se vuoto, viene usato il pulsante dell’intestazione',
    menuCtaUrl: 'Link del pulsante',
    menuShowSocials: 'Mostra social',
    tabsOnTop: 'Schede in alto',
    tabsOnBottom: 'Schede in basso',
    borderType: 'Tipo di bordo',
    subTitle: 'Scegli forma, tipo di bordo, ombra ecc.',
    icon: 'Icona',
    iconTooltip: `Scegli l'icona giusta per il tuo pulsante`,
    background: 'Sfondo',
    color: 'Colore',
    backgroundOpacity: 'Opacità sfondo',
    backgroundOpacityTooltip: `Trascina il cursore per impostare l'opacità dello sfondo`,
    gradient: 'Gradiente',
    color1: 'Colore 1',
    color2: 'Colore 2',
    direction: 'Direzione',
    directionTooltip: 'Trascina il cursore per impostare la direzione di un gradiente',
    offset: 'Offset',
    offsetTooltip: `Trascina il cursore per impostare l'offset di un gradiente`,
    minHeight: 'Altezza minima',
    minHeightTooltip: `Trascina il cursore per cambiare l'altezza minima del pulsante`,
    align: 'Allinea',
    alignTooltip: 'Cambia la posizione del pulsante',
    insert: 'Inserisci URL',
    upload: 'Carica video',
    search: 'Cerca video',
    layout: 'Layout',
    layoutTooltip: 'Scegli il layout che desideri',
    view: 'Vista',
    viewTooltip: 'Scegli la vista che desideri',
    media: 'Media',
    mediaTooltip: 'Scegli il media che desideri',
    none: 'Nessuno',
    small: 'Piccolo',
    medium: 'Medio',
    large: 'Grande',
    round: 'Arrotondato',
    feed: 'Feed',
    slider: 'Slider',
    text: 'Testo',
    colorTooltip: 'Scegli i colori',
    button: 'Pulsante',
    buttonTooltip: 'Scegli i colori del pulsante',
    chooseEmoji: 'Scegli emoji',
    changeEmoji: 'Cambia la tua emoji',
    quantum: 'Quantum',
    emoji: 'Emoji',
    warp: 'Warp',
  },
  components: {
    quickAdd: {
      addLink: 'Aggiungi link',
      addVideo: 'Aggiungi video',
      addProduct: 'Aggiungi prodotto',
      addPost: 'Aggiungi post',
      addArticle: 'Aggiungi articolo',
      addPhoto: 'Aggiungi foto',
      addMusic: 'Aggiungi musica',
      addFiles: 'Aggiungi file',
      addStory: 'Aggiungi storia',
    },
    emoji: {
      search: 'Cerca',
      clear: 'Cancella',
      notfound: 'Nessuna emoji trovata',
      skintext: 'Scegli il tono della pelle predefinito',
      categories: {
        search: 'Risultati della ricerca',
        recent: 'Usate di frequente',
        smileys: 'Faccine ed emozioni',
        people: 'Persone e corpo',
        nature: 'Animali e natura',
        foods: 'Cibo e bevande',
        activity: 'Attività',
        places: 'Viaggi e luoghi',
        objects: 'Oggetti',
        symbols: 'Simboli',
        flags: 'Bandiere',
        custom: 'Personalizzate',
      },
      categorieslabel: 'Categorie emoji',
      skintones: {
        1: 'Tono della pelle predefinito',
        2: 'Tono della pelle chiaro',
        3: 'Tono della pelle medio-chiaro',
        4: 'Tono della pelle medio',
        5: 'Tono della pelle medio-scuro',
        6: 'Tono della pelle scuro',
      },
    },
    blogPreviewModal: {
      title: 'Anteprima blog',
      notify: 'Notifica iscritti',
    },
    standAloneModal: {
      title: 'Anteprima link',
      save: 'Salva',
      chooseLayout: 'Scegli un layout per il tuo link',
      linkSettings: 'Impostazioni link',
      linkSettingsSubtitle: 'Reindirizzamento, aspetto',
      whenVisitorsClicks: 'Quando un visitatore clicca su questo link:',
      redirect: 'Reindirizza',
      redirectText: `Invia i visitatori direttamente all'URL`,
      highlight: 'Evidenzia',
      highlightText: 'Invia i visitatori al tuo UniLink ed evidenzia',
      standalone: 'Autonomo',
      standaloneText: 'Fai risaltare il tuo link YouTube e riproduci il contenuto direttamente sul tuo',
      cover: 'Copertina',
      imageTab: 'Immagine',
      videoTab: 'Video',
      uploadImage: 'Carica immagine',
      whenVisitors: 'Quando un visitatore seleziona il link condiviso:',
      compact: 'Vista compatta',
      fullView: 'Vista completa',
      videoSound: 'Riproduci video con audio',
    },
    instagramModal: {
      title: 'Invia DM automatici su Instagram',
      subtitle: 'Invia questo link tramite messaggio diretto quando qualcuno commenta il tuo post o Reel su IG',
      promo: 'Scegli da quale IG inviare',
      connect: 'Collega account Instagram',
      added: 'Account Instagram aggiunto',
      addNew: 'Aggiungi nuova automazione',
      igContent: 'Contenuto IG',
      trigger: 'Trigger',
      dmContent: 'DM',
      linkDestination: 'Destinazione del link',
      buttonTitle: 'Titolo del pulsante',
      buttonTitleTooltip: 'Inserisci il titolo del pulsante',
      directMessage: 'Messaggio diretto',
      directMessageTooltip: 'Inserisci il messaggio diretto',
      selectPosts: 'Seleziona il post o il Reel che attiverà il DM automatico.',
      onePost: 'Un post o Reel specifico',
      allPosts: 'Tutti i post o i Reel',
      triggerText: 'Quando i commenti includono questo, verrà inviato il tuo DM.',
      addMessage: 'Aggiungi un messaggio da inviare automaticamente con il tuo link.',
      clickLink: 'Quando qualcuno clicca sul link nel tuo DM:',
      anyComment: 'Qualsiasi commento',
      storiesAndDms: 'Stories & DMs',
      anyMessage: 'Qualsiasi messaggio',
      specificKeywords: 'Commenti con parole chiave specifiche',
      sendLink: 'Inviali al tuo UniLink ed evidenzia ',
      skipLink: 'Salta UniLink e inviali direttamente',
      keywordsTitle: 'Commenti con parole chiave specifiche',
      keywordsText: 'I tuoi DM verranno inviati quando i commenti includono o escludono\nparole chiave specifiche (non sensibile a maiuscole/minuscole):',
      keywordsPlaceholder: 'Digita una parola chiave',
      keywordsExclude: 'Escludi parole chiave',
      keywordsExcludeText: 'Deve escludere una di queste',
      replyComment: 'Rispondi al commento',
      replyCommentTooltip: 'Inserisci la risposta al commento',
    },
    blockEditProduct: {
      productPreview: 'Anteprima',
      productDetails: 'Dettagli',
      settings: 'Impostazioni',
      design: 'Design',
    },
    editMenuItems: {
      overview: 'Panoramica',
      analytics: 'Analytics',
    },
    botToken: {
      bot: 'Bot',
      botTooltip: 'Inserisci il token del tuo bot',
      connect: 'Connetti',
      token: 'Token',
    },
    rewards: {
      title: 'Titolo',
      titleTooltip: 'Inserisci il titolo per la risposta',
      text: 'Testo',
      textTooltip: 'Inserisci il testo per la risposta',
      link: 'Link',
      linkTooltip: 'Inserisci il link per la risposta',
      code: 'Codice',
      codeTooltip: 'Inserisci il codice per la risposta',
      files: 'File',
      filesTooltip: 'Inserisci i file per la risposta',
      removeReward: 'Sei sicuro di voler rimuovere questa risposta?',
    },
    addRewardModal: {
      addReward: 'Aggiungi risposta',
      textTitle: 'Testo',
      textText: 'Dai accesso a istruzioni o qualsiasi testo con Rich Editor',
      fileTitle: 'File',
      fileText: 'Dai accesso ai file e raccogli i dati di contatto',
      linkTitle: 'Link',
      linkText: 'Dai accesso a contenuti esclusivi e raccogli i dati di contatto',
      codeTitle: 'Codice',
      codeText: 'Dai accesso a promozioni esclusive e raccogli i dati di contatto',
    },
    blockEmpty: {
      isNotAdded: 'non è stato aggiunto',
      itSeems: 'Sembra che il tuo',
      itemsNot: 'gli elementi non sono ancora stati aggiunti. Aggiungi i tuoi video ora',
      add: 'Aggiungi',
    },
    blockList: {
      add: 'Aggiungi',
      item: 'elemento',
    },
    submitAction: {
      action: `Azione (dopo l'invio)`,
      actionTooltip: `Scegli un'azione dopo l'invio`,
      upload: 'Carica allegati',
      none: 'Nessuna',
      page: 'Mostra pagina di conferma',
      email: 'Invia email di conferma',
      redirect: 'Reindirizza a URL',
    },
    blockEditItem: {
      content: 'Contenuto',
      preview: 'Anteprima',
      settings: 'Impostazioni',
    },
    domainButton: {
      customizeDomain: 'Personalizza il tuo dominio.',
      upgradeToLink: 'Passa a Link in Bio Pro e usa un dominio personalizzato.',
    },
    coverText: {
      text: 'Testo',
      textTooltip: 'Inserisci il testo della copertina',
      description: 'Descrizione',
      descriptionTooltip: 'Inserisci la descrizione della copertina',
      textColor: 'Colore del testo',
    },
    itemModal: {
      edit: 'Modifica',
      addNew: 'Aggiungi nuovo',
      item: 'elemento',
      update: 'Aggiorna',
      add: 'Aggiungi',
    },
    productSheet: {
      openFullEditor: `Apri l'editor completo`,
      copyLink: 'Copia link',
      active: 'Attivo',
      notActive: 'Non attivo',
      statistics: 'Statistiche',
      clicks: 'Clic',
      sales: 'Vendite',
      revenue: 'Ricavi',
      onlyName: 'Solo il nome è obbligatorio',
      name: 'Nome',
      required: 'Obbligatorio',
      price: 'Prezzo',
      optional: 'Facoltativo',
      free: 'Gratis',
      appearance: 'Aspetto',
      cover: 'Copertina',
      coverNote: 'Quadrata, da 600×600. Puoi aggiungerla più tardi.',
      description: 'Descrizione',
      descriptionPlaceholder: 'Una riga su cosa contiene',
      remove: 'Rimuovi',
      photo: 'Foto',
      enterName: 'Inserisci un nome',
      adding: 'Aggiunta…',
    },
    viewDesign: {
      compact: 'Compatto',
      card: 'Card',
      button: 'Pulsante',
      list: 'Elenco',
      hero: 'Hero',
      featured: 'In evidenza',
    },
    moveItemModal: {
      title: `Sposta elemento in un'altra pagina`,
      cancel: 'Annulla',
      move: 'Sposta',
      page: 'Pagina',
      pageTooltip: `Scegli una pagina in cui spostare l'elemento`,
      blocks: 'Blocchi',
      blocksTooltip: `Scegli un blocco in cui spostare l'elemento`,
      emptyBlocks: 'Non ci sono blocchi richiesti in questa pagina.',
    },
    limitModal: {
      title: 'Limite raggiunto',
      text1: 'Hai raggiunto il limite del tuo sito.',
      text2: 'Contattaci per aggiornare il tuo piano.',
      close: 'Chiudi',
    },
    cropPicture: {
      title: 'Ritaglia la tua immagine',
      cancel: 'Annulla',
      save: 'Salva',
    },
    uploadFile: {
      uploadProductImage: 'Carica immagine prodotto',
      coverImage: 'Immagine di copertina',
      uploadImages: 'Qui puoi caricare solo immagini',
    },
    userMediaLibrary: {
      addImage: `Aggiungi un'immagine`,
      uploadImage: 'Carica immagine',
      orSelectFrom: 'o carica',
      orSelectLink: 'o incolla link',
      myMedia: 'I miei media',
      stockImages: 'Immagini stock',
      gifs: 'GIF',
      icons: 'Icone',
      noImagesYet: 'Nessuna immagine',
      loadMore: 'Carica altri',
    },
    itemMenu: {
      active: 'Attivo',
      willBeAvailable: `L'elemento sarà disponibile su:`,
      save: 'Salva',
      copied: 'Copiato',
      copyLink: 'Copia link',
      delete: 'Elimina',
    },
    itemDesign: {
      linkColor: 'Colore link',
      gradient: 'Gradiente',
      background: 'Sfondo',
      backgroundOpacity: 'Opacità sfondo',
      backgroundOpacityTooltip: `Trascina il cursore per impostare l'opacità dello sfondo`,
      backgroundDarkness: 'Oscurità sfondo',
      backgroundDarknessTooltip: `Trascina il cursore per impostare l'oscurità dello sfondo`,
      text: 'Testo',
      color1: 'Colore 1',
      color2: 'Colore 2',
      direction: 'Direzione',
      directionTooltip: 'Trascina il cursore per impostare la direzione del gradiente',
      offset: 'Offset',
      offsetTooltip: `Trascina il cursore per impostare l'offset del gradiente`,
      linkHeight: 'Altezza link',
      linkHeightTooltip: `Trascina il cursore per modificare l'altezza del pulsante`,
      icon: 'Icona',
      iconTooltip: `Scegli l'icona per il tuo pulsante`,
      imageShape: 'Forma immagine',
      imageShapeTooltip: `Scegli la forma dell'immagine per il tuo link`,
    },
    menu: {
      linkInBio: 'Link in bio',
      linkInBioApps: 'Link in Bio',
      posts: 'Post',
      audience: 'Pubblico',
      orders: 'Ordini',
      marketing: 'Marketing',
      emailMarketing: 'Email Marketing',
      socialPlanner: 'Pianificatore Social',
      shortLinks: 'Link brevi',
      businessCards: 'Biglietti da visita',
      recentProfiles: 'Profili recenti',
      standalonePage: 'Pagina autonoma',
      soloApps: 'App in Bio',
      bots: 'Bot',
      smartReply: 'Instagram Reply',
      analytics: 'Analitiche',
      settings: 'Impostazioni',
      shop: 'Guadagna',
      publish: 'Pubblica',
      studio: 'Studio',
      blog: 'Blog',
      qrCodes: 'Codici QR',
      singlePages: 'App',
      forms: 'Moduli',
      form: 'Moduli',
      automations: 'Automazioni',
      community: 'Community',
      messages: 'Posta in arrivo',
      agents: 'Agenti',
      apps: 'App',
      emailSignatures: 'Firme e-mail',
      virtualBackgrounds: 'Sfondi virtuali',
    },
    notificationsBlockSetting: {
      title: 'Notifiche',
      setUp: 'Configura',
      notifications: 'notifiche',
      connect: 'Connetti',
      telegramText: 'Ricevi una notifica Telegram quando qualcuno effettua',
      change: 'modifica',
      email: 'Email',
      emailText: `Ricevi un'email quando qualcuno effettua`,
      webhook: 'Webhook',
      webhookTooltip: 'Aggiungi webhook',
      activate: 'Attiva',
      webhookText: 'Invia un evento a un sito di terze parti quando qualcuno effettua',
      webhookURL: 'URL del webhook (richiesta POST)',
      error: 'Inserisci un link corretto',
      save: 'Salva',
    },
    navigation: {
      content: 'Contenuti',
      pages: 'Pagine',
      posts: 'Post',
      shop: 'Negozio',
      blog: 'Blog',
      design: 'Design',
      analytics: 'Analytics',
      settings: 'Impostazioni',
      apps: 'App',
      store: 'Negozio',
    },
    headerSettings: {
      design: 'Design',
      analytics: 'Analytics',
      settings: 'Impostazioni',
      editTabs: 'Modifica schede',
    },
    unlockModal: {
      title: 'Sblocca le funzionalità Pro',
      text: 'Ottieni di più dal tuo link-in-bio. Solo 5 $/mese — sblocca tutto ciò che Pro ha da offrire:',
      checkBoxTitle1: 'Più blocchi:',
      checkBoxText1: 'Aggiungi moduli, negozi, conti alla rovescia e lettori multimediali',
      checkBoxTitle2: 'Analytics avanzate:',
      checkBoxText2: 'Monitora clic, visualizzazioni e dati sul pubblico',
      checkBoxTitle3: 'Dominio personalizzato:',
      checkBoxText3: 'Usa il tuo dominio per un aspetto professionale',
      checkBoxTitle4: 'Negozio integrato:',
      checkBoxText4: 'Vendi prodotti e gestisci gli ordini con facilità',
      checkBoxTitle5: 'Strumenti SEO:',
      checkBoxText5: 'Posizionati più in alto con meta tag, UTM e slug personalizzati',
      checkBoxTitle6: 'Integrazioni:',
      checkBoxText6: 'Sincronizza con Mailchimp, Zapier e altri strumenti',
      checkBoxTitle7: 'Email Marketing:',
      checkBoxText7: 'Raccogli lead e invia campagne automatizzate',
      checkBoxTitle8: 'Supporto prioritario:',
      checkBoxText8: 'Ricevi assistenza più rapida ogni volta che ne hai bisogno',
      upgradeToPro: 'Passa a Pro',
      viewAllPlans: 'Vedi tutti i piani',
    },
    profileSwitcher: {
      title: 'Tutti i profili',
      button: 'Aggiungi un nuovo profilo',
    },
    account: {
      signOut: 'Esci',
      createNew: 'Crea un nuovo Link in Bio',
      tryPro: 'Prova Pro ora!',
      tryProText: 'Ottieni personalizzazioni avanzate e analisi più approfondite del pubblico per avere più visitatori!',
    },
    accountSettings: {
      title: 'Impostazioni account',
    },
    billingHistory: {
      title: 'Cronologia fatturazione',
    },
    pages: {
      home: 'Home',
      newPage: 'Nuova pagina',
      managePages: 'Gestisci pagine',
    },
    blockItem: {
      actionRequired: 'azione richiesta',
      hidden: 'Nascosto · nessuno lo vede',
    },
    blockContent: {
      untitled: 'Senza titolo',
      clickToRename: 'Clicca per rinominare il sottotitolo',
      saving: 'salvataggio',
      saved: 'salvato',
      deleteTitle: 'Sei sicuro di voler eliminare questo blocco?',
      cancel: 'Annulla',
      yes: 'Sì',
    },
    addButtonModal: {
      title: `Aggiungi un pulsante d'azione`,
      close: 'Chiudi',
      added: 'Aggiunto',
      add: 'Aggiungi',
      messageTitle: 'Messaggio',
      messageText: 'Il pulsante Messaggio permette agli utenti di contattarti tramite messenger',
      subscribeTitle: 'Iscriviti',
      subscribeText: 'Il pulsante Iscriviti permette agli utenti di iscriversi alla tua lista email o messenger',
      ctaTitle: 'Pulsante CTA',
      ctaText: `La CTA è un invito sul sito che indica all'utente di compiere un'azione specifica`,
      cartTitle: 'Carrello',
      cartText: `Mostra un'icona del carrello per indicare che i visitatori possono effettuare acquisti sul tuo sito`,
      contactTitle: 'Contatto',
      contactText: 'Consenti ai visitatori di accedere rapidamente alle tue informazioni di contatto',
      qrcodeTitle: 'Codice QR',
      qrcodeText: 'Mostra un codice QR così i visitatori possono scansionarlo e condividere la tua pagina',
      languageTitle: 'Lingua',
      languageText: 'Consenti ai visitatori di cambiare la lingua della tua pagina',
      searchTitle: 'Cerca',
      searchText: 'Consenti ai visitatori di cercare i prodotti del tuo negozio direttamente dall’intestazione',
    },
    inputMask: {
      copyLink: 'Copia link',
    },
    videoLibrary: {
      addVideo: 'Aggiungi video',
      myVideos: 'I miei video',
      stockVideos: 'Video stock',
      pasteUrl: 'Incolla URL',
      uploadVideo: 'Carica video',
    },
    createBlockModal: {
      searchTitle: 'Scegli un blocco per la tua pagina',
      title: 'Aggiungi a UniLink',
      contentTitle: 'Contenuti',
      contentText: 'Crea e gestisci la tua pagina',
      growTitle: 'Lead',
      growText: 'Raccogli lead e aumenta il coinvolgimento',
      monetizeTitle: 'Monetizza',
      monetizeText: 'Vendi prodotti, contenuti e servizi',
      monetizationTitle: 'Guadagna e ricevi pagamenti',
      monetizationText: 'Vendi prodotti, servizi e raccogli mance',
      socialTitle: 'Contenuti social',
      socialText: 'Condividi contenuti dei social media sul tuo UniLink',
      toolsTitle: 'Strumenti di crescita',
      toolsText: 'Cresci, gestisci e connettiti con il tuo pubblico',
      search: 'Cerca',
      all: 'Tutto',
      allCategories: 'Tutte le categorie',
      content: 'Contenuti',
      monetization: 'Monetizzazione',
      social: 'Social',
      tools: 'Strumenti',
      header: 'Intestazione',
      headerText: 'Aggiungi una foto profilo e una bio',
      link: 'Link',
      linkText: 'Scegli il layout dei link',
      text: 'Testo',
      textText: 'Scegli il layout del testo',
      videos: 'Video',
      videosText: 'Scegli il tipo di video',
      image: 'Immagine',
      imageText: 'Aggiungi blocchi immagine',
      music: 'Musica',
      musicText: 'Scegli il tipo di musica',
      socialFeeds: 'Feed social',
      socialFeedsText: 'Scegli il tipo di feed social',
      moreContent: 'Altro',
      moreContentText: 'Aggiungi altri blocchi di contenuto',
      dataCollect: 'Raccolta dati',
      dataCollectText: 'Seleziona tipo di raccolta dati',
      form: 'Modulo',
      formText: 'Seleziona tipo di modulo',
      conversionTools: 'Strumenti di coinvolgimento',
      conversionToolsText: 'Aggiungi blocchi di conversione',
      products: 'Prodotti',
      productsText: 'Aggiungi blocchi prodotto',
      donation: 'Mance e donazioni',
      tipsAndDonations: 'Mance e donazioni',
      tipsDonationsText: 'Blocchi di mance e donazioni',
      event: 'Evento',
      eventText: 'Seleziona tipo di evento',
      quickAdd: 'Tutti i blocchi',
      quickAddText: 'Aggiungi qualsiasi blocco',
    },
    addBlockModal: {
      title: 'Aggiungi a UniLink',
      dragToAdd: 'Trascina per aggiungere',
      contentTitle: 'Condividi contenuti di base',
      contentText: 'Condividi contenuti direttamente sul tuo UniLink',
      monetizationTitle: 'Guadagna e raccogli denaro',
      monetizationText: 'Vendi prodotti, servizi e raccogli mance',
      socialTitle: 'Contenuti social',
      socialText: 'Condividi contenuti social sul tuo UniLink',
      toolsTitle: 'Strumenti di crescita',
      toolsText: 'Cresci, gestisci e connettiti con il tuo pubblico',
      search: 'Cerca',
      searchPlaceholder: 'Cerca contenuti...',
      all: 'Tutti',
      allCategories: 'Tutte le categorie',
      content: 'Contenuto',
      monetization: 'Monetizzazione',
      social: 'Social',
      tools: 'Strumenti',
      suggestTitle: 'Proponi il tuo blocco',
      suggestText: 'Manca un blocco? Dicci cosa vorresti vedere',
      suggestModalTitle: 'Proponi un blocco',
      suggestModalSubtitle: 'Descrivi il blocco che vorresti in UniLink. Leggiamo ogni idea.',
      suggestPlaceholder: 'es. Un blocco prenotazioni con sincronizzazione Google Calendar…',
      suggestSubmit: 'Invia proposta',
      suggestSending: 'Invio…',
      suggestSuccessTitle: 'Proposta inviata!',
      suggestSuccess: 'Grazie! Leggiamo ogni idea e la usiamo per definire la roadmap.',
      suggestError: 'Invio non riuscito. Riprova.',
    },
    tabNavigation: {
      tabView: 'Vista a schede',
      tabViewTooltip: 'Seleziona la vista a schede per la navigazione',
      colors: 'Colori',
      colorsTooltip: 'Scegli i colori di post e pulsanti',
      tabs: 'Schede',
      tabsTooltip: 'Scegli le schede mostrate nella navigazione del sito',
      content: 'Contenuto',
      posts: 'Post',
      store: 'Negozio',
      shop: 'Negozio',
      tabsSettings: 'Impostazioni navigazione schede',
    },
    hideLogo: {
      text: 'Mostra il logo UniLink nel footer della tua pagina.',
      text2: 'Mostra il logo UniLink nel footer della tua pagina.',
    },
    palettePreview: {
      custom: 'Colore di sfondo personalizzato',
      hexColor: 'Colore hex',
      hexColorTooltip: 'Inserisci il colore hex della tua anteprima',
    },
    backgroundVideo: {
      insert: 'Inserisci URL',
      upload: 'Carica video',
      search: 'Cerca video',
    },
    periodDropdown: {
      today: 'Oggi',
      yesterday: 'Ieri',
      last7days: 'Ultimi 7 giorni',
      last30days: 'Ultimi 30 giorni',
      allTime: 'Sempre',
      custom: 'Personalizzato',
    },
    subsections: {
      content: 'Contenuto',
      design: 'Design',
      settings: 'Impostazioni',
    },
    wrapperSettings: {
      lock: 'Passa al piano PRO',
    },
    shareModal: {
      addSocials: 'Aggiungi ai social',
      shareTo: 'Condividi su',
      qrCode: 'Codice QR',
      customizeUrl: 'Personalizza URL',
      goToMy: 'Vai al mio',
      print: 'Puoi stampare il tuo codice QR unico su',
      cards: 'biglietti da visita e volantini',
      download: 'Scarica',
      copy: 'Copia',
      previewMobile: 'Anteprima su mobile',
      scanMobilePreview: `Scansiona il codice QR con il tuo dispositivo mobile per visualizzare l'anteprima del tuo sito`,
      types: {
        socials: 'social',
        shareTo: 'condividi',
        qrCode: 'QR',
        title: 'Condividi il tuo UniLink',
        titleSocials: 'Aggiungi UniLink ai tuoi social',
        titleShareTo: 'Condividi su...',
        titleQRCode: 'Codice QR',
        titlePreviewMobile: 'Anteprima su mobile',
      },
      socialList: {
        instagramText: `Aggiungi il tuo UniLink al tuo profilo Instagram. Copia semplicemente l'URL del tuo UniLink, vai su Modifica profilo e incollalo nel campo Sito web.`,
        facebookText: `Aggiungi il tuo UniLink al tuo profilo Facebook. Copia semplicemente l'URL del tuo UniLink, vai alla pagina Informazioni del tuo profilo, clicca su Contatti e informazioni di base, poi su + Aggiungi un sito web, incolla l'URL del tuo UniLink nel campo Indirizzo del sito web e clicca Salva.`,
        tikTokText: `Aggiungi il tuo UniLink al tuo profilo Facebook. Copia semplicemente l'URL del tuo UniLink, vai alla pagina Informazioni del tuo profilo, clicca su Contatti e informazioni di base, poi su + Aggiungi un sito web, incolla l'URL del tuo UniLink nel campo Indirizzo del sito web e clicca Salva.`,
        twitchText: `Aggiungi il tuo UniLink al tuo canale Twitch. Copia semplicemente l'URL del tuo UniLink, vai sul tuo canale Twitch, clicca su Informazioni, poi su Modifica impostazioni informazioni e link, scorri fino a Link social, aggiungi UniLink nel primo campo di testo e incolla l'URL del tuo UniLink nel secondo campo di testo, poi clicca Aggiungi.`,
        youTubeText: `Aggiungi il tuo UniLink al tuo canale YouTube. Copia semplicemente l'URL del tuo UniLink, vai sul tuo canale YouTube, clicca su Personalizza canale, poi su Informazioni di base e sotto Link aggiungi un titolo per il link e incolla l'URL del tuo UniLink nel campo URL, poi clicca Pubblica.`,
        linkedInText: `Aggiungi il tuo UniLink al tuo profilo LinkedIn. Copia semplicemente l'URL del tuo UniLink, vai sul tuo profilo LinkedIn, clicca sull'icona della matita, scorri fino a Informazioni di contatto, incolla l'URL del tuo UniLink nel campo URL del sito web, poi clicca Applica.`,
        pinterestText: `Aggiungi il tuo UniLink al tuo profilo Pinterest. Copia semplicemente l'URL del tuo UniLink, vai nelle impostazioni di Pinterest, incolla l'URL del tuo UniLink nel campo URL del sito web, poi clicca Salva.`,
        twitterText: `Aggiungi il tuo UniLink al tuo profilo Twitter. Copia semplicemente l'URL del tuo UniLink, vai sul tuo profilo, clicca su Modifica profilo e incolla l'URL del tuo UniLink nel campo Sito web.`,
      },
      share: {
        shareFacebook: 'Condividi su Facebook',
        shareLinkedIn: 'Condividi su LinkedIn',
        shareTwitter: 'Condividi su Twitter',
        shareWhatsApp: 'Condividi tramite WhatsApp',
        shareMessenger: 'Condividi tramite Messenger',
        shareEmail: 'Condividi tramite email',
      },
    },
  },
  popupMenu: {
    edit: 'Modifica pagina',
    openInNewTab: 'Apri in una nuova scheda',
    copyLink: 'Copia URL',
    delete: 'Elimina',
    showThumbnail: 'Mostra le miniature delle pagine nella dashboard',
    manageTabs: 'Gestisci schede',
  },
  tabsDashboard: {
    labelAddNewTab: 'Nuova scheda',
  },
  blocks: {
    header: {
      blockTitle: 'Intestazione',
      blockText: 'Personalizza la tua immagine del profilo, aggiungi una breve bio e aggiorna le tue icone social',
      blockShortText: 'Personalizza il tuo profilo',
      layout: 'Layout',
      layoutTooltip: `Crea il layout dell'intestazione che desideri`,
      layoutAlign: 'Allineamento layout',
      layoutAlignTooltip: 'Allinea testo',
      profilePicture: 'Immagine del profilo',
      profilePictureTooltip: 'Cambia la tua immagine del profilo',
      pictureSize: 'Dimensione immagine',
      pictureSizeTooltip: `Puoi modificare la dimensione dell'immagine`,
      pictureHeight: 'Altezza immagine',
      pictureHeightCaption: `Puoi modificare l'altezza dell'immagine`,
      preview: 'Anteprima',
      badge: 'Badge',
      badgeTooltip: `Aggiungi un badge verificato all'intestazione`,
      tags: 'Tag',
      tagsTooltip: 'Mostra i tag di categoria sotto il tuo nome (fino a 5)',
      tagsAdd: 'Aggiungi tag',
      addTags: '+ Aggiungi tag',
      tagsEdit: 'Modifica tag',
      tagsCustomPlaceholder: 'Aggiungi tag personalizzato',
      tagsCustomAdd: 'Aggiungi',
      tagsSuggested: 'Categorie suggerite',
      tagsSelected: 'Selezionati',
      tagsEmpty: 'Nessun tag ancora — scegli dai suggerimenti o aggiungi i tuoi',
      tagsLimit: 'Max 5 tag',
      visibility: 'Visibilità',
      visibilityTooltip: 'Mostra o nascondi immagine del profilo',
      cover: 'Copertina',
      coverTooltip: 'Aggiungi immagine o video alla copertina',
      addCover: 'Aggiungi copertina',
      image: 'Immagine',
      video: 'Video',
      positionCover: 'Posizione di testo e pulsante',
      positionCoverTooltip: 'Trascina il cursore per cambiare posizione',
      buttons: 'Pulsanti',
      block: 'Blocco',
      videoProcessing: 'Elaborazione video',
      vibe: 'Vibe',
      vibeTooltip: 'Aggiungi la tua vibe',
      stories: 'Storie',
      storiesTooltip: 'Aggiungi le tue storie',
      addStory: 'Aggiungi storia',
      storiesSubtitle: 'Aggiungi immagine o video alle tue storie',
      subscribeMethod: 'Metodo di iscrizione',
      subscribeMethodTooltip: 'Scegli il tuo metodo di iscrizione',
      subscribeLink: 'Link di iscrizione',
      subscribeLinkTooltip: 'Copia il tuo link di iscrizione',
      minWidth: 'Larghezza minima',
      addVCard: 'Aggiungi vCard',
      vCard: 'vCard',
      vCardTooltip: 'Puoi aggiungere informazioni su di te',
      buttonInline: `Pulsante in linea con l'intestazione`,
      buttonInsideContact: 'Pulsante dentro il pulsante Contatto',
      showSaveContact: 'Mostra salva contatto',
      options: 'Opzioni',
      showBusinessCard: 'Mostra biglietto da visita',
      showBusinessCardCaption: 'Aggiunge qui un pulsante «Salva contatto».',
      editBusinessCard: 'Modifica biglietto',
      editContactDetails: 'Modifica i dati di contatto su Business cards',
      needAddContact: 'Devi aggiungere il pulsante Contatto',
      socialGap: 'Spaziatura',
      socialGapCaption: 'Puoi modificare la spaziatura',
      socialSize: 'Dimensione',
      socialSizeCaption: 'Puoi modificare la dimensione',
      icons: 'Icone',
      iconsTooltip: 'Aggiungi icona al pulsante',
      bottomButtonsSettings: 'Pulsanti inferiori',
      bottomButtonsLayout: 'Layout',
      bottomButtonsRow: 'Affiancati',
      bottomButtonsColumn: 'Impilati',
      cropMismatch: 'Questa foto è ritagliata per un layout diverso.',
      adjustCrop: 'Regola ritaglio',
      photoShapeLabel: 'Forma della foto',
      photoShapeTooltip: 'Scegli se questo layout mostra la foto quadrata o un ritaglio verticale.',
      photoShapeSquare: 'Quadrata',
      photoShapeVertical: 'Verticale',
      coverShape: 'Forma della copertina',
      coverShapeTooltip: 'Scegli il bordo inferiore della copertina: retto, curvato in basso o in alto.',
      coverShapeStraight: 'Retto',
      coverShapeArcDown: 'Arco verso il basso',
      coverShapeArcUp: 'Arco verso l’alto',
      avatarOffsetLabel: 'Posizione dell’avatar',
      avatarOffsetTooltip: 'Sposta l’avatar in alto o in basso rispetto al bordo della copertina.',
      photoStyleProTitle: 'Sblocca stili foto avanzati',
      photoStyleProDesc: 'Nessuno sfondo e Testo dietro sono funzioni PRO.',
      photoShapeCustom: 'Personalizzata',
      sliderStyleLabel: 'Stile slider',
      sliderStyleTooltip: 'Swipe mostra una foto alla volta; Galleria mostra una riga di miniature — tocca una miniatura per cambiare la foto principale.',
      sliderStyleSwipe: 'Swipe',
      sliderStyleGallery: 'Galleria',
      photoPositionLabel: 'Posizione foto',
      photoPositionHint: 'Inquadratura verticale',
      verticalCropHint: `Questo layout mostra una foto originale. Scegli l'area verticale che vuoi visualizzare.`,
      verticalCropReady: `Regola con precisione l'area verticale mostrata in questo layout.`,
      pickVerticalArea: 'Scegli area verticale',
      photoStyle: 'Stile foto',
      photoStyleTooltip: `Mostra la foto così com'è, con lo sfondo rimosso, o metti il testo dietro il soggetto.`,
      avatarModeOriginal: 'Originale',
      avatarModeCutout: 'Nessuno sfondo',
      avatarModeLayered: 'Testo dietro',
      overlayText: 'Testo',
      overlayTextPlaceholder: 'Il tuo nome (predefinito)',
      overlayColor: 'Colore del testo',
      overlaySize: 'Dimensione',
      overlayY: 'Posizione verticale',
      overlayEffect: 'Animazione',
      overlayEffectNone: 'Nessuna',
      overlayEffectShimmer: 'Luccichio',
      overlayEffectGlow: 'Bagliore',
      overlayEffectGradient: 'Gradiente',
      overlayEffectSparkle: 'Scintillio',
      overlayUsesName: 'In questo layout il testo è il nome del tuo profilo — appare dietro di te. Modificalo nella sezione “Nome”.',
      cutoutGenerate: 'Genera ritaglio',
      cutoutRegenerate: 'Rigenera',
      cutoutUpload: 'Carica',
      cutoutOr: 'oppure',
      cutoutGenerating: 'Generazione...',
      cutoutUploading: 'Caricamento...',
      cutoutVideoHint: 'La rimozione dello sfondo funziona solo con foto immagine, non con video.',
      cutoutTimeout: 'La rimozione dello sfondo sta impiegando troppo tempo. Riprova.',
      profileBadges: 'Badge',
      profileBadgesTooltip: 'Scegli fino a 3 badge da mostrare accanto al tuo nome',
      profileBadgesProLockHint: 'Passa a PRO per usare questo badge',
      profileBadgesAdd: 'Aggiungi badge',
      profileBadgesManage: 'Gestisci badge',
      profileBadgesModalTitle: 'Aggiungi badge al tuo profilo',
      profileBadgesModalSubtitle: 'Metti in mostra i tuoi risultati e riconoscimenti.',
      profileBadgesCustomCta: 'Carica il tuo badge',
      profileBadgesCustomDesc: 'Il tuo badge personalizzato',
      profileBadgesCustomName: 'Nome del badge',
      profileBadgesCustomChoose: 'Scegli immagine',
      profileBadgesCustomChange: 'Cambia immagine',
      profileBadgesCustomUploading: 'Caricamento…',
      profileBadgesCustomAdd: 'Aggiungi badge',
      ribbonLabel: 'Nastro decorativo',
      ribbonLabelTooltip: `Aggiungi una barra colorata sotto l'hero dell'header`,
      addTint: 'Aggiungi nastro',
      ribbonTitle: 'Nastro',
      ribbonText: 'Testo del nastro',
      ribbonTextPlaceholder: 'es. 20% di sconto fino a fine mese',
      ribbonColor: 'Colore del nastro',
      ribbonTheme: 'Stile',
      ribbonThemes: {
        none: 'Nessun decoro',
        birthday: 'Compleanno',
        newyear: 'Capodanno',
        valentine: 'San Valentino',
        halloween: 'Halloween',
        summer: 'Estate',
      },
      ribbonEffect: 'Effetto',
      ribbonEffects: {
        none: 'Nessuno',
        gradient: 'Gradiente animato',
        shimmer: 'Luccichio',
        lights: 'Lucine',
      },
      ribbonPosition: 'Posizione',
      ribbonPositions: {
        bottom: `Sotto l'header`,
        underPhoto: 'Sotto la foto',
      },
      ribbonRemove: 'Rimuovi nastro',
      statusBadges: 'Attività',
      statusBadgesTooltip: `Mostra l'attività in tempo reale sulla tua pagina`,
      addStatus: 'Aggiungi attività',
      statusDisabledHint: 'Nascosto · disabilitato',
      followersTitle: 'Follower',
      followersCounter: 'Contatore follower',
      followersTooltip: 'Mostra il numero combinato di follower dei tuoi account social collegati',
    },
    text: {
      blockTitle: 'Testo',
      blockText: `Blocco di testo generico per scrivere qualsiasi cosa. Puoi formattare il testo con l'editor WYSIWYG`,
      blockShortText: 'Blocco di testo generico',
      title: 'Titolo',
      titleText: 'Personalizza la dimensione del titolo',
      orderOfElements: 'Ordine degli elementi',
      orderOfElementsTooltip: `Trascina il cursore per cambiare l'ordine degli elementi`,
      changeOrder: 'Cambia ordine',
      text: 'Testo',
      content: 'Contenuto',
      image: 'Immagine',
      button: 'Pulsante',
      addButtons: 'Aggiungi altri pulsanti',
      displayedContent: 'Contenuto visualizzato',
      displayedContentTooltip: 'Mostra o nascondi contenuto',
      buttonLayout: 'Layout dei pulsanti',
      buttonLayoutTooltip: 'Scegli disposizione verticale o orizzontale dei pulsanti',
    },
    timeline: {
      blockTitle: 'Timeline',
      blockText: 'Mostra una timeline verticale con eventi. Ogni evento può avere data/ora, titolo, descrizione e immagine opzionale',
      blockShortText: 'Mostra timeline degli eventi',
      editItem: 'Modifica evento',
      title: 'Titolo',
      titlePlaceholder: `Titolo dell'evento`,
      subtitle: 'Sottotitolo',
      subtitlePlaceholder: 'Ruolo o affiliazione (opzionale)',
      description: 'Descrizione',
      descriptionPlaceholder: `Descrizione dell'evento (opzionale)`,
      startTime: 'Ora di inizio',
      endTime: 'Ora di fine',
      startDate: 'Data di inizio',
      endDate: 'Data di fine',
      showEndDate: 'Mostra data di fine',
      showEndDateTooltip: 'Disattiva per eventi in corso (es. "lavoro qui dal 2023")',
      includeTime: 'Includi orario',
      includeTimeTooltip: `Se disattivato, verrà mostrata solo la data senza l'orario`,
      image: 'Immagine',
      imagePlaceholder: 'Carica avatar o icona',
      imageUploadFailed: `Impossibile caricare l'immagine. Usa I miei media o incolla il link.`,
      untitled: 'Senza titolo',
      listLayout: 'Layout elenco',
      lineColor: 'Colore linea',
    },
    trust: {
      blockTitle: 'Fiducia',
      blockShortText: 'Condividi le tue partnership',
      blockText: 'Riunisci tutte le tue collaborazioni in un unico posto.',
      titleText: 'Personalizza la dimensione del titolo',
      orderOfElements: 'Ordine degli elementi',
      orderOfElementsTooltip: `Trascina lo slider per cambiare l'ordine degli elementi`,
      changeOrder: 'Cambia ordine',
      text: 'Testo',
      content: 'Contenuto',
      image: 'Immagine',
      button: 'Pulsante',
      displayedContent: 'Contenuto visualizzato',
      displayedContentTooltip: 'Mostra o nascondi contenuto',
      enterTrustLink: `Inserisci l'URL del partner`,
      enterTrustLinkTooltip: `Incolla l'URL del partner`,
      enterPartnerName: 'Inserisci il nome del partner',
      enterPartnerUrl: 'https://www.yourPartner.com/',
      enterDescription: 'Inserisci descrizione (opzionale)',
      partnerLogo: 'Logo del partner',
      uploadPartnerLogo: 'Carica il logo del tuo partner',
    },
    link: {
      blockTitle: 'Link',
      blockText: 'Indirizza il traffico al tuo sito web, blog, negozio online o qualsiasi altra pagina web',
      blockShortText: 'Indirizza il traffico al sito web',
      addLink: 'Aggiungi link',
      addNewLink: 'Aggiungi nuovo link',
      restrictedTitle: 'I link {platform} sono una funzione PRO',
      restrictedText: `L'aggiunta di link {platform} è disponibile nel piano PRO. Esegui l'upgrade del tuo piano per aggiungere questo link alla tua pagina.`,
      upgradeToPro: 'Passa a PRO',
      showMore: 'Mostra altro',
      showLess: 'Mostra meno',
      viewArchive: 'Visualizza archivio',
      archivedLinks: 'Link archiviati',
      noArchivedLinks: `Mantieni l'admin dei link pulito e ordinato archiviando i link che non stai usando.`,
      archiveAllUnpublished: 'Archivia tutti i link non pubblicati',
      addFormExisting: 'Aggiungi dai link esistenti',
      addYourLink: 'Aggiungi il tuo link al gruppo',
      add: 'Aggiungi',
      otherTypes: 'Tipo di azione',
      link: 'Link',
      navigate: 'Naviga',
      navigateTo: 'Vai a',
      scrollBlock: 'Scorri a',
      copyText: 'Copia testo',
      navigatePage: 'Pagina',
      navigateProduct: 'Prodotto',
      navigateBlock: 'Blocco',
      modal: 'Modale',
      showModal: 'Mostra modale',
      modalBlock: 'Mostra blocco',
      modalItem: 'Mostra elemento',
      modalCustom: 'Personalizzato',
      document: 'Documento',
      privat24: 'Privat24',
      phone: 'Chiamata telefonica',
      viber: 'Apri Viber',
      skype: 'Apri Skype',
      email: 'Invia email',
      discount: 'Sconto',
      smartLink: 'Smart Link',
      mobileApp: 'Deep Link',
      enterURL: 'Inserisci URL',
      enterPrivat: 'Inserisci la tua carta Private Bank',
      enterPhone: 'Inserisci numero di telefono',
      enterViber: 'Inserisci numero Viber',
      enterSkype: 'Inserisci Skype',
      enterEmail: 'Inserisci email',
      enterTitle: 'Inserisci titolo',
      enterCopyText: 'Inserisci il testo da copiare',
      enterPromoCode: 'Inserisci codice promo',
      group: 'Crea gruppo',
      content: 'Contenuto',
      links: 'Link',
      heading: 'Intestazione',
      settings: 'Impostazioni',
      thumbnail: 'Miniatura',
      typeTooltip: '  Il clic aprirà questo link',
      title: 'Titolo',
      titleTooltip: 'Nome del tuo link',
      description: 'Descrizione',
      descriptionTooltip: 'Descrizione opzionale di caratteristiche, tipi, colore, taglie, ecc.',
      label: 'Etichetta',
      labelTooltip: 'Aggiungi nome etichetta',
      button: 'Pulsante',
      buttonTooltip: 'Aggiungi nome pulsante',
      buttonText: 'Testo del pulsante',
      buttonTextTooltip: 'Nome del tuo pulsante',
      buttonUrl: 'URL del pulsante',
      buttonUrlTooltip: `Inserisci l'URL del pulsante`,
      addLinkToGroup: 'Aggiungi link al gruppo',
      removeFromGroup: 'Rimuovi dal gruppo',
      deletePermanently: 'Elimina definitivamente',
      image: 'Immagine',
      buttonBg: 'Sfondo pulsante',
      postPreview: 'Anteprima post',
      separatorType: 'Tipo di separatore',
      separatorTypeTooltip: 'Aggiungi un tipo di separatore al tuo pulsante',
      section: 'Sezione',
      sectionTooltip: 'Sezione del link',
      descriptionSeparator: 'Descrizione',
      descriptionSeparatorTooltip: 'Descrizione opzionale della sezione',
      sectionText: 'Testo della sezione',
      linkInstant: 'Inoltro istantaneo del link',
      spotlight: 'Metti in evidenza il link',
      addEffect: 'Aggiungi un effetto speciale',
      countdown: 'Conto alla rovescia',
      countdownTimer: 'Timer conto alla rovescia',
      countdownText: 'Aggiungi un conto alla rovescia in tempo reale fino al momento in cui il tuo link diventa cliccabile',
      chooseDate: 'Scegli data',
      chooseDateTooltip: 'Scegli la data per il tuo link',
      chooseAction: 'Scegli azione',
      chooseActionTooltip: 'Scegli azione per il tuo link',
      addCountdown: 'Aggiungi conto alla rovescia per il link',
      scheduler: 'Programmazione',
      schedule: 'Programma',
      scheduleText: `Scegli una data e un'ora future per attivare il tuo link`,
      activateOn: 'Attiva il',
      activateOnTooltip: 'Scegli data',
      deactivateOn: 'Disattiva il',
      deactivateOnTooltip: 'Scegli data',
      addSchedule: 'Aggiungi programmazione per',
      scheduleError: 'La data di fine non può essere precedente alla data di inizio e la data di inizio non può essere nel passato.',
      scheduleErrorPast: 'La data di attivazione non può essere nel passato.',
      scheduleErrorPastDeactivate: 'La data di disattivazione non può essere nel passato.',
      scheduleErrorOrder: 'La data di disattivazione deve essere successiva alla data di attivazione.',
      activatesIn: 'Si attiva tra',
      deactivatesIn: 'Si disattiva tra',
      lock: 'Blocca',
      lockText: 'I visitatori possono accedere a questo link solo soddisfacendo uno dei criteri.',
      lockCode: 'Codice',
      lockCodeTitle: 'Codice per sbloccare questo link',
      lockCodeText: 'I visitatori devono inserire un codice di 4 cifre per sbloccare questo link',
      lockSubscribe: 'Iscriviti',
      lockSubscribeTitle: 'I visitatori devono iscriversi al tuo UniLink per sbloccare il link.',
      lockSubscribeText: 'Blocco configurato con successo.',
      lockPayment: 'Pagamento',
      lockPaymentText: 'Blocco configurato con successo.',
      price: 'Prezzo',
      priceTooltip: 'Aggiungi il prezzo del tuo prodotto',
      lockAge: 'Data di nascita (Età)',
      lockAgeTitle: 'Imposta età minima',
      lockAgeText: 'I visitatori devono superare una certa età per sbloccare il link con la loro data di nascita',
      lockAgeAlert: 'Blocco configurato con successo.',
      lockSensitive: 'Contenuto sensibile',
      lockSensitiveText: 'I visitatori devono confermare che questo link potrebbe contenere contenuti non adatti a tutti.',
      makeLink: 'Rendi il link a pagamento',
      addLock: 'Aggiungi blocco per link',
      save: 'Salva',
      clear: 'Cancella',
      buttonColor: 'Colore pulsante',
      labelColor: 'Colore etichetta',
      background: 'Sfondo',
      imageHeight: 'Altezza immagine',
      imageHeightTooltip: `Trascina il cursore per cambiare l'altezza dell'immagine`,
      buttonMinimum: 'Altezza minima',
      buttonMinimumTooltip: `Trascina il cursore per cambiare l'altezza del pulsante`,
      textPosition: 'Posizione testo',
      textPositionTooltip: 'Scegli la posizione verticale del testo',
      preview: 'anteprima',
      defaultDesign: 'Design predefinito',
      defaultDesignTooltip: 'Imposta design predefinito per i link',
      defaultDesignTitle: 'Nota che questo design verrà applicato a tutti i link.',
      defaultDesignText: 'Puoi modificare il design predefinito del link',
      changeDefault: 'Cambia predefinito',
      applyDefault: 'Applica predefinito',
      scheduled: 'Programmato',
      scheduledVisible: 'Il link programmato è ora visibile',
      scheduledHidden: 'Il link programmato è ora nascosto',
      linkClickable: 'Link cliccabile tra',
      linkDisable: 'Link disabilitato tra',
      lockedBy: 'Bloccato da',
      items: 'Elementi',
      doNotAnyLinks: 'Non hai ancora nessun link',
      sublinks: 'Sottolink',
      layout: 'Layout',
      layoutTooltip: 'Scegli il layout dei sottolink che preferisci',
      hideGroupLink: 'Nascondi link del gruppo',
      rules: 'Regole',
      rulesText: 'Modifica la visibilità di questo link in base a chi visita la tua pagina.',
      rulesEmpty: 'Nessuna condizione ancora. Aggiungi una condizione per controllare chi vede questo link.',
      rulesAddCondition: 'Aggiungi condizione',
      rulesActive: 'Regole di visibilità',
      rulesIf: 'Se',
      rulesThen: 'Allora',
      ruleTypeLocation: 'Posizione',
      ruleTypeDevice: 'Dispositivo',
      ruleTypeTime: 'Giorno e ora',
      ruleOperatorIs: 'è',
      ruleOperatorIsNot: 'non è',
      ruleActionHide: 'Nascondi link',
      ruleActionShow: 'Mostra link',
      ruleSelectLocations: 'Seleziona posizioni',
      ruleSearchLocations: 'Cerca paesi…',
      ruleFrom: 'Dalle',
      ruleTo: 'Alle',
      ruleAnyTime: 'Qualsiasi',
    },
    'data-collect': {
      blockTitle: 'Raccolta dati',
      blockText: 'Raccogli email o numeri di telefono dai tuoi visitatori',
      blockShortText: 'Raccogli email',
      maxSize: 'Puoi aggiungere massimo 3 canali',
      customTerms: 'T&C personalizzati',
      customTermsTooltip: 'Aggiungi T&C personalizzati al tuo modulo',
      termsConditions: 'Termini e Condizioni',
      text: 'Testo',
      subscribe: 'Iscriviti',
      title: 'Titolo',
      titleTooltip: 'Inserisci il titolo per i termini e condizioni',
      titleResultTooltip: 'Inserisci il titolo per il tuo invio',
      url: 'URL',
      urlTooltip: 'Inserisci URL',
      editItem: 'Modifica elemento',
      placeholder: 'Placeholder',
      placeholderTooltip: 'Inserisci il testo segnaposto',
      button: 'Pulsante',
      buttonTooltip: `Testo che invoglierà i visitatori a inserire l'email (10% di sconto, iscriviti ora, scarica il file ecc.)`,
      successMessage: 'Messaggio di successo',
      successMessageTooltip: 'Messaggio di successo dei tuoi iscritti',
      botURL: 'URL del bot (opzionale)',
      botURLTooltip: `Inserisci l'URL del tuo bot`,
      botToken: 'Token del bot',
      botTokenTooltip: 'Inserisci il token del tuo bot',
      rewards: 'Risposte',
      rewardsTooltip: 'Aggiungi risposte ai tuoi iscritti',
      addReward: 'Aggiungi risposta',
      thankYou: 'Messaggio di ringraziamento',
      email: {
        none: 'Nessuno',
        display: 'Mostra risposta immediatamente',
        send: 'Invia risposta via email',
        redirect: `Reindirizza all'URL`,
      },
      phone: {
        none: 'Nessuno',
        display: 'Mostra risposta immediatamente',
        send: 'Invia risposta al telefono',
        redirect: `Reindirizza all'URL`,
      },
      telegram: {
        none: 'Nessuno',
        display: 'Mostra risposta immediatamente',
        send: 'Invia risposta nel bot Telegram',
        redirect: `Reindirizza all'URL`,
      },
      whatsapp: {
        none: 'Nessuno',
        display: 'Mostra risposta immediatamente',
        send: 'Invia risposta nel bot WhatsApp',
        redirect: `Reindirizza all'URL`,
      },
      instagram: {
        none: 'Nessuno',
        display: 'Mostra risposta immediatamente',
        send: 'Invia risposta nel bot Instagram',
        redirect: `Reindirizza all'URL`,
      },
      messenger: {
        none: 'Nessuno',
        display: 'Mostra risposta immediatamente',
        send: 'Invia risposta nel bot Messenger',
        redirect: `Reindirizza all'URL`,
      },
      viber: {
        none: 'Nessuno',
        display: 'Mostra risposta immediatamente',
        send: 'Invia risposta nel bot Viber',
        redirect: `Reindirizza all'URL`,
      },
      connect: 'Connetti',
      toChangeReward: 'Per cambiare tipo di risposta devi rimuovere quello attuale',
      remove: 'Rimuovi',
      viewTypes: 'Visualizza tipi',
    },
    form: {
      blockTitle: 'Modulo',
      blockText: 'Ti permette di raccogliere informazioni e dati dal tuo pubblico',
      blockShortText: 'Raccogli informazioni',
      fields: 'Campi',
      fieldsTooltip: 'Aggiungi campi al modulo',
      addCustomField: 'Aggiungi campo personalizzato',
      addItem: 'Aggiungi elemento',
      editItem: 'Modifica elemento',
      type: 'Tipo',
      typeTooltip: 'Scegli il tipo di campo',
      string: 'Risposta breve',
      textarea: 'Risposta lunga',
      dropdown: 'Menu a tendina',
      radio: 'Scelta singola',
      checkbox: 'Casella di controllo',
      date: 'Data',
      time: 'Ora',
      country: 'Paese',
      file: 'Caricamento file',
      rating: 'Valutazione',
      submissionsClosed: 'Smetti di accettare invii',
      submissionsClosedTooltip: 'Al posto del modulo compare un breve avviso. Le risposte già ricevute restano.',
      closedTitle: 'Titolo di chiusura',
      closedText: 'Messaggio di chiusura',
      templates: {
        contact: 'Modulo di contatto',
        contactCaption: 'Una frase, i campi, un pulsante: il modulo che ci si aspetta',
        steps: 'A più passaggi',
        stepsCaption: 'Due domande per schermata con barra di avanzamento. Un modulo lungo smette di sembrarlo',
        upload: 'Caricamento file',
        uploadCaption: 'Prima l’area di caricamento — per grafiche, brief e documenti',
        schedule: 'Giorno e ora',
        scheduleCaption: 'Scegli un giorno e una fascia, poi lascia il nome',
        rating: 'Valutazione e feedback',
        ratingCaption: 'Stelle, qualche argomento da toccare, un campo commento',
        card: 'Classico',
        cardCaption: 'Il modulo semplice: campi incolonnati nella pagina, pulsante sotto',
        button: 'Pulsante con pop-up',
        buttonCaption: 'Un pulsante nella pagina; il modulo si apre in un pop-up',
      },
      fieldName: 'Nome del campo',
      fieldNameTooltip: 'Inserisci il nome del campo',
      name: 'Nome',
      placeholder: 'Segnaposto',
      placeholderTooltip: 'Inserisci il testo segnaposto',
      required: 'Obbligatorio',
      requiredTooltip: 'Spunta se il campo è obbligatorio',
      value: 'Valore',
      enterTitle: 'Inserisci il titolo',
      addValue: 'Aggiungi valore',
      delete: 'Elimina',
      update: 'Aggiorna',
      add: 'Aggiungi',
      confirmationPage: 'Azione di conferma',
      confirmationPageSubtitle: `Scegli l'azione risultante dopo l'invio del modulo`,
      successMessage: 'Messaggio di successo',
      successMessageTooltip: `Messaggio di successo dopo l'invio del modulo`,
      thankYou: 'Messaggio di ringraziamento',
      submit: 'Invia',
    },
    contact: {
      blockTitle: 'Contatti',
      blockText: 'I contatti permettono agli utenti di comunicare direttamente con te. Aggiungi telefono, email, messaggistica o posizione',
      blockShortText: 'Comunica con gli utenti',
      addNewContact: 'Aggiungi nuovo contatto',
      newContact: 'Nuovo contatto',
      friendlyName: 'Nome descrittivo',
    },
    faq: {
      blockTitle: 'FAQ',
      blockText: 'Domande frequenti — utilizzate per indicare un elenco di risposte alle tipiche domande che gli utenti potrebbero porre',
      blockShortText: 'Domande frequenti',
      addNewItem: 'Aggiungi nuovo elemento',
      editItem: 'Modifica elemento',
      title: 'Titolo',
      titleTooltip: 'Inserisci il titolo',
      description: 'Descrizione',
      descriptionTooltip: 'Inserisci la descrizione',
      update: 'Aggiorna',
      add: 'Aggiungi',
      howToFind: 'Come trovarci',
      view: 'Visualizza',
      viewTooltip: 'Scegli come vengono mostrate le voci FAQ',
      feed: 'Feed',
      slider: 'Slider',
      emptyTitle: 'Non hai ancora nessuna voce',
      emptyText: 'Aggiungi la tua prima domanda per riempire questo blocco.',
    },
    ama: {
      blockTitle: 'Chiedimi qualsiasi cosa',
      blockShortText: 'Rispondi alle domande dei fan',
      blockText: 'Permetti al tuo pubblico di fare domande e rispondi direttamente sulla tua pagina',
    },
    feature: {
      blockTitle: 'Funzionalità',
      blockText: 'Sezione di testo con immagine per spiegare ai tuoi utenti perché la tua attività è la migliore',
      blockShortText: 'Spiega ai tuoi utenti perché',
      title: 'Titolo',
      titleTooltip: `Modifica il titolo dell'elemento`,
      description: 'Descrizione',
      descriptionTooltip: `Modifica la descrizione dell'elemento`,
    },
    highlight: {
      blockTitle: 'In evidenza',
      blockText: 'Metti in evidenza i link più importanti con miniature (fino a 3)',
      blockShortText: 'Metti in evidenza i più importanti',
      title: 'Titolo',
      titleTooltip: `Modifica il titolo dell'elemento`,
      url: 'URL',
      urlTooltip: `Modifica l'URL dell'elemento`,
      modeLink: 'Link',
      modeStory: 'Storia',
      coverPhoto: 'Foto',
      coverIcon: 'Icona',
      templates: {
        scroll: 'Riga scorrevole',
        scrollCaption: 'Il blocco originale: copertine rotonde disposte su più righe, che scorrono oltre le tre',
        story: 'Storie',
        storyCaption: 'Copertine più grandi nell’anello sfumato, così si leggono come storie da toccare',
        square: 'Copertine quadrate',
        squareCaption: 'Copertine quadrate in una riga scorrevole: sembra uno scaffale, non una fila di storie',
        tall: 'Schede alte',
        tallCaption: 'Schede verticali con il nome sopra l’immagine. Ideale quando conta la copertina',
        icon: 'Copertine con icona',
        iconCaption: 'Una griglia di icone al posto delle foto, per quando non ci sono ancora immagini',
        grid: 'Griglia',
        gridCaption: 'Tutti gli highlight insieme su una griglia a quattro colonne, per un insieme troppo lungo',
      },
    },
    banner: {
      blockTitle: 'Banner',
      blockText: 'Immagine, video o il tuo ultimo prodotto in primo piano per farlo risaltare. Puoi aggiungere un pulsante CTA per guidare gli utenti verso la tua conversione',
      blockShortText: 'Immagine, video in primo piano',
      height: 'Altezza',
      heightTooltip: `Modifica l'altezza del banner`,
      badge: 'Etichetta',
      badgeTooltip: 'La riga piccola stampata sopra il titolo in questo modello',
      badgePlaceholder: 'Appena stampato',
      templates: {
        classic: 'Classico',
        classicCaption: `Il banner originale — il testo al centro dell'immagine, dimensionato dalle proporzioni`,
        coverTop: 'Copertina con sopratitolo',
        coverTopCaption: 'Una riga piccola sopra il titolo, tutto centrato. Ideale quando il banner dice chi sei',
        coverTitle: 'Solo titolo',
        coverTitleCaption: 'Una parola grande e spaziata, con una riga sotto. Nessun pulsante, nulla di più',
        coverLeft: 'Allineato a sinistra',
        coverLeftCaption: 'Il testo nell angolo in basso e due pulsanti affiancati, come apre una landing page',
        coverCenter: 'Pulsanti centrati',
        coverCenterCaption: 'Tutto centrato, i pulsanti impilati a pillola. Il più diretto dei sei',
        coverVideo: 'Copertina video',
        coverVideoCaption: 'Per un banner che riproduce un video — una pillola di stato, il suono e un pulsante',
        coverBadge: 'Etichetta e CTA',
        coverBadgeCaption: 'Una cornice più bassa: una pillola bianca con la novità, un titolo e un pulsante',
      },
    },
    slider: {
      blockTitle: 'Slider',
      blockText: 'Carosello di immagini che ti permette di mostrare i tuoi contenuti visivi e aggiungere diverse funzionalità',
      blockShortText: 'Carosello di immagini',
      image: 'Immagine',
      imageTooltip: 'Immagine della tua galleria',
      addText: 'Aggiungi testo',
      title: 'Titolo',
      titleTooltip: 'Titolo della tua slide',
      titleSize: 'Dimensione del titolo',
      titleSizeTooltip: 'Scegli la dimensione per una migliore leggibilità',
      description: 'Descrizione',
      descriptionTooltip: 'Descrizione della tua slide',
      textColor: 'Colore del testo',
      addButton: 'Aggiungi pulsante',
      url: 'URL',
      urlTooltip: 'URL della tua immagine',
      button: 'Pulsante',
      buttonTooltip: 'Titolo del tuo pulsante',
      buttonText: 'Testo del pulsante',
      buttonColor: 'Colore del pulsante',
      height: 'Altezza',
      heightTooltip: `Modifica l'altezza delle slide`,
      view: 'Vista',
      viewTooltip: 'Scegli la vista per lo slider',
      auto: 'Auto',
      square: 'Quadrato',
      rectangle: 'Rettangolo',
      single: 'Singolo',
      multi: 'Multiplo',
      templates: {
        multi: 'Multiplo',
        multiCaption: 'La striscia di card originale, la successiva sbuca dal bordo',
        single: 'Singolo',
        singleCaption: 'Lo slider originale, una alla volta, con i puntini sotto',
        showcase: 'Vitrina',
        showcaseCaption: 'La vetrina originale — un numero grande, un contatore e una striscia di miniature',
        full: 'A tutta pagina con puntini',
        fullCaption: `Un'immagine da bordo a bordo, i puntini come unico ornamento. Per foto che non servono didascalie`,
        peek: 'Sbuca la successiva',
        peekCaption: 'La slide successiva sbuca dal bordo, così il gesto è evidente prima di provarlo',
        caption: 'Slide con didascalia',
        captionCaption: 'La foto in una card, sotto il titolo e la descrizione della slide stessa',
        thumbs: 'Con miniature',
        thumbsCaption: 'Una striscia sotto la foto, per saltare in una serie lunga invece di scorrerla',
        counter: 'Contatore e frecce',
        counterCaption: 'Il conteggio in cifre e due frecce — per una serie che vale percorrere con calma',
        auto: 'Barre automatiche',
        autoCaption: 'Barre da storie: lo slider avanza da solo e dice quanto manca',
        compare: 'Prima e dopo',
        compareCaption: 'Le prime due slide sovrapposte, con una linea da trascinare. I loro titoli sono le etichette',
        video: 'Slide video',
        videoCaption: 'Per slide che sono file video — il suono che accende chi guarda, e il tempo trascorso',
        shop: 'Slide con prodotto',
        shopCaption: 'Titolo, descrizione e pulsante della slide si leggono come nome, prezzo e azione',
      },
    },
    gallery: {
      blockTitle: 'Galleria',
      blockText: 'Carosello di immagini che ti permette di mostrare i tuoi contenuti visivi',
      blockShortText: 'Carosello di immagini',
      image: 'Immagine',
      imageTooltip: `Immagine dell'elemento della galleria`,
      layout: 'Layout',
      layoutTooltip: 'Scegli il layout per la galleria',
      feed: 'Feed',
      slider: 'Slider',
    },
    blog: {
      blockTitle: 'Blog',
      blockText: 'Crea il blog dei tuoi post',
      blockShortText: 'Crea blog',
      writeYourStory: 'Scrivi la tua storia',
      shortDescription: 'Breve descrizione',
      shortDescriptionTooltip: 'Descrizione opzionale per il tuo blog',
      description: 'Descrizione',
    },
    map: {
      blockTitle: 'Mappa',
      blockText: 'Aggiungi Google Maps per aiutare gli utenti a raggiungere la tua attività locale',
      blockShortText: 'Aggiungi Google Maps',
      buttonText: 'Testo del pulsante',
      buttonTextTooltip: 'Il pulsante appare quando è selezionata la seconda vista',
      text: 'Testo',
      addAddress: 'Aggiungi un altro indirizzo',
      address: 'Indirizzo',
      addressTooltip: `Incolla l'indirizzo da Google Maps, ad esempio`,
      googleMap: 'Google Maps (codice embed)',
      googleMapTooltip: 'Incolla il codice embed da Google Maps',
      howToFind: 'Come trovare il codice embed',
      incorrectCode: 'Codice embed non corretto.',
      moreInfo: 'Maggiori informazioni',
      code: 'Codice',
      addressSettings: 'Impostazioni indirizzo',
      addressContent: 'Aggiungi URL, titolo e testo o icona del pulsante',
      title: 'Titolo',
      titleTooltip: 'Il nome del tuo indirizzo',
      url: 'URL',
      urlTooltip: `Incolla l'URL dell'indirizzo da Google Maps, ad esempio`,
      directionText: 'Testo indicazioni',
      directionTextTooltip: 'Testo della call to action per i tuoi utenti',
    },
    footer: {
      templates: {
        minimal: 'Minimale',
        minimalCaption: 'Il marchio, la riga social e la riga legale. Chiude la pagina senza un secondo menu',
        columns: 'Due colonne di link',
        columnsCaption: 'Link raggruppati sotto etichette, su due colonne. Per poche sezioni reali',
        accordion: 'Menu a fisarmonica',
        accordionCaption: 'Gruppi comprimibili su pannello scuro. Per più sezioni di quante ne stiano',
        subscribe: 'Piè con iscrizione',
        subscribeCaption: 'Campo email sopra i chip di navigazione. Per un piè che raccoglie indirizzi',
        contacts: 'Piè di contatto',
        contactsCaption: 'Telefono, email e indirizzo come righe toccabili, messaggeri sotto',
        shop: 'Grande piè del negozio',
        shopCaption: 'Promessa di spedizione, colonne di link, badge app e metodi di pagamento',
        cta: 'Invito all’azione',
        ctaCaption: 'Pannello pieno con titolo e due azioni. La chiusura della pagina',
        sticky: 'Piè con barra azioni',
        stickyCaption: 'Un piè normale e sotto chiamata, chat e il pulsante principale',
        locale: 'Lingua e valuta',
        localeCaption: 'Lingua, valuta e paese di spedizione sopra i link di aiuto del negozio',
      },
      defaults: {
        groups: [
          { title: 'Servizi', links: ['Design', 'Sviluppo', 'Branding'] },
          { title: 'Azienda', links: ['Chi siamo', 'Casi', 'Lavoro'] },
        ],
        subscribeTitle: 'Una lettera al mese',
        subscribeText: 'Casi, processi e un po’ di dietro le quinte. Niente spam.',
        subscribeButton: 'Iscriviti',
        ctaTitle: 'Raccontaci il tuo progetto',
        ctaText: 'Rispondiamo entro un’ora nei giorni lavorativi.',
        ctaButton: 'Scrivici',
        languages: [
          { code: 'it', label: 'It' },
          { code: 'en', label: 'Eng' },
          { code: 'pl', label: 'Pl' },
        ],
        currency: '€ Euro',
        country: 'Italia',
        contacts: [
          { icon: 'phone', value: '+39 02 1234567' },
          { icon: 'mail', value: 'hi@studio.it' },
          { icon: 'pin', value: 'Via Khoryva 22, Kyiv' },
        ],
      },
      blockTitle: 'Footer',
      blockText: 'Sezione di contenuti in fondo alla pagina. Puoi aggiungere informazioni di contatto, icone social e un modulo di iscrizione via email',
      blockShortText: 'Sezione dei contenuti in fondo',
      addBlock: 'Aggiungi blocco',
      blockType: 'Tipo di blocco',
      blockTypeTooltip: 'Scegli il tipo di blocco',
      addBlockTitle: 'Titolo del blocco',
      addBlockTitleTooltip: 'Scegli il titolo del blocco',
      faq: 'FAQ',
      'data-collect': 'Raccolta dati',
      contact: 'Contatti',
      pages: 'Pagine',
      payments: 'Pagamenti',
      social: 'Social',
      cancel: 'Annulla',
      add: 'Aggiungi',
      None: 'Nessuno',
      link: 'link',
      faqText: 'Puoi modificare le domande frequenti nel blocco FAQ. Puoi accedervi cliccando qui',
      socialText: 'Puoi modificare le icone social nel blocco Header. Puoi accedervi cliccando qui',
      dataCollectText: 'Puoi modificare la raccolta dati nel blocco Raccolta dati. Puoi accedervi cliccando qui',
      contactText: 'Puoi modificare i contatti nel blocco Contatti. Puoi accedervi cliccando qui',
      pagesText: 'Puoi aggiungere nuove pagine sul Sito web',
      paymentsText: 'Verranno visualizzati i metodi di pagamento',
      showOnAllpages: 'Mostra su tutte le pagine',
      footerText: 'Il Footer della Home page è attualmente abilitato.',
      editSocialIcons: 'Puoi modificare le icone social nella sezione Header. Puoi accedervi cliccando qui',
      editSubscribe: `Puoi modificare l'iscrizione nella sezione Iscriviti. Puoi accedervi cliccando qui`,
      editContacts: 'Puoi modificare i contatti nella sezione Contatti. Puoi accedervi cliccando qui',
      editFrequently: 'Puoi modificare le domande frequenti nella sezione FAQ. Puoi accedervi cliccando qui',
      text: 'Testo',
      image: 'Immagine',
      divider: 'Separatore',
      linkViewLabel: 'Layout',
      linkViewTooltip: 'Come sono disposti i link',
      linkViewSingle: 'Impilati',
      linkViewRow: 'In riga',
      linkItemsLabel: 'Link',
      linkItemsTooltip: 'Aggiungi fino a 5 link (es. Informativa sulla privacy, Termini)',
      linkLabelPlaceholder: 'Etichetta',
      linkUrlPlaceholder: 'URL',
      linkAddMore: '+ Aggiungi link',
      alignLabel: 'Allineamento',
      alignTooltip: 'Allineamento orizzontale',
      alignLeft: 'Sinistra',
      alignCenter: 'Centro',
      alignRight: 'Destra',
      imageLabel: 'Immagine',
      imageTooltip: `Carica un logo o un'immagine`,
      imageLinkLabel: 'Link (facoltativo)',
      imageLinkTooltip: `Rendi l'immagine cliccabile`,
      dividerLabel: 'Tipo di separatore',
      dividerTooltip: 'Una linea o uno spazio vuoto',
      dividerLine: 'Linea',
      dividerSpace: 'Spazio',
      picker: {
        subtitle: 'Scegli un elemento da aggiungere al tuo footer',
        configureSubtitle: 'Configuralo e aggiungilo al tuo footer',
        back: 'Indietro',
        saveButton: 'Salva',
        availableTitle: 'Disponibili da aggiungere',
        addedTitle: 'Già aggiunti',
        addedLabel: 'Aggiunto',
        addButton: 'Aggiungi blocco',
        linkTitle: 'Link',
        linkSub: 'Pulsanti verso qualsiasi URL',
        socialTitle: 'Social',
        socialSub: 'Icone per i tuoi profili social',
        textTitle: 'Testo',
        textSub: 'Un titolo o un paragrafo',
        pagesTitle: 'Pagine',
        pagesSub: 'Link a sotto-pagine annidate',
        paymentsTitle: 'Pagamenti',
        paymentsSub: 'Metodi di pagamento accettati',
        imageTitle: 'Immagine',
        imageSub: `Un logo o un'immagine`,
        dividerTitle: 'Separatore',
        dividerSub: 'Una linea o uno spazio',
        faqTitle: 'FAQ',
        faqSub: 'Domande frequenti',
        dataCollectTitle: 'Raccolta dati',
        dataCollectSub: 'Modulo di iscrizione email',
        contactTitle: 'Contatto',
        contactSub: 'Dettagli di contatto',
        importMode: 'Importa da blocco',
        manualMode: 'Aggiungi manualmente',
        noContactsToImport: 'Nessun contatto da importare — aggiungili manualmente.',
        noSocialsToImport: 'Nessuna icona social da importare — aggiungile manualmente.',
        manualItemsLabel: 'Elementi',
        manualItemsTooltip: 'Scegli un tipo e inserisci il suo valore.',
        contactValuePlaceholder: '@username / email / telefono',
        socialUrlPlaceholder: 'https://...',
        addMore: '+ Aggiungi altro',
      },
      contactDesign: {
        editSource: 'Modifica i contatti stessi nel blocco Contatto —',
        variantLabel: 'Stile',
        variantList: 'Elenco',
        variantButton: 'Pulsante',
        shapeLabel: 'Forma',
        shape_square: 'Quadrata',
        shape_rounded: 'Arrotondata',
        shape_pill: 'Pillola',
        widthLabel: 'Larghezza',
        widthFull: 'Intera',
        widthHalf: 'Metà',
        widthHalfStacked: 'Mezza colonna',
        borderLabel: 'Bordo',
        borderOn: 'Attivo',
        borderOff: 'Disattivo',
        borderColorLabel: 'Colore del bordo',
      },
      layout: 'Layout',
      splitImage: 'Immagine laterale',
    },
    'chat-ai': {
      blockTitle: 'Chat dal vivo',
      blockShortText: `Chatta con l'AI`,
      blockText: `Chatta con l'AI`,
      suggestionsTitle: 'Suggerimenti',
      suggestionsSubtitle: 'Prompt rapidi',
    },
    custom: {
      blockTitle: 'Personalizzato',
      blockShortText: 'Micro app basata su AI',
      blockText: `Descrivi una mini app interattiva e l'AI la genererà per te`,
    },
    shop: {
      blockTitle: 'Negozio',
      blockText: 'Aggiungi la lista dei tuoi prodotti',
      blockShortText: 'Aggiungi i tuoi prodotti',
      view: 'Visualizza',
      products: 'Prodotti',
      categories: 'Categorie',
      cardLayout: 'Layout scheda',
      cardLayoutTooltip: 'La vetrina mostra ogni prodotto come una scheda di vendita dettagliata, una per riga',
      standardCards: 'Standard',
      showcaseCards: 'Vetrina',
      featured: 'In evidenza',
      shoppingCart: 'Carrello',
      shoppingCartNote: 'Il pulsante del carrello appare quando un visitatore aggiunge un prodotto',
      cartIconDisabledHint: 'Attiva il carrello per utilizzare questa opzione',
    },
    digital: {
      blockTitle: 'Prodotti digitali',
      blockText: 'Vendi un download digitale: PDF, fogli di calcolo, modelli, contenuti esclusivi',
      blockShortText: 'Vendi un digitale',
    },
    podcast: {
      templates: {
        latest: 'Ultimo episodio',
        latestCaption: 'L’episodio più recente e un pulsante per avviarlo',
        player: 'Player',
        playerCaption: 'Barra, −15, +30 e controllo della velocità',
        list: 'Elenco episodi',
        listCaption: 'Play, numero, titolo e durata — il feed semplice',
        resume: 'Riprendi l’ascolto',
        resumeCaption: 'Dove si è fermato il visitatore, salvato nel suo browser',
        bestOf: 'I migliori',
        bestOfCaption: 'Tre episodi per iniziare, nel tuo ordine',
        cover: 'Copertina del programma',
        coverCaption: 'Copertina, di cosa parla e le app dove si trova',
        subscribe: 'Riga di iscrizione',
        subscribeCaption: 'Una riga e le directory — niente copertina né episodi',
        trailer: 'Trailer',
        trailerCaption: 'La risposta in due minuti a «fa per me?»',
        guest: 'Episodio con ospite',
        guestCaption: 'Un’intervista venduta da chi la fa',
        guests: 'Gli ospiti',
        guestsCaption: 'I volti passati dal programma, a griglia',
        hosts: 'I conduttori',
        hostsCaption: 'Chi fa il programma, dal campo autore degli episodi',
        chapters: 'Capitoli e note',
        chaptersCaption: 'Righe con i minutaggi; toccando, il player salta',
        transcript: 'Trascrizione',
        transcriptCaption: 'L’episodio scritto, ogni riga sposta l’ascolto',
        clip: 'Clip da condividere',
        clipCaption: 'Una frase in grande e un pulsante per condividere',
        video: 'Videopodcast',
        videoCaption: 'Il fermo immagine e la scelta tra guardare e ascoltare',
        seasons: 'Stagioni',
        seasonsCaption: 'I tuoi programmi come chip, sotto i loro episodi',
        topics: 'Filtro per tema',
        topicsCaption: 'Episodi per la categoria del loro programma',
        showCards: 'Card dei programmi',
        showCardsCaption: 'Ogni programma come card, scorrendo di lato',
        ask: 'Domanda degli ascoltatori',
        askCaption: 'Un invito, un esempio e dove arrivano le risposte',
        ratings: 'Valutazioni',
        ratingsCaption: 'Il tuo voto e una recensione da citare',
        support: 'Sostieni il programma',
        supportCaption: 'Cosa ottengono i sostenitori e dove si iscrivono',
        classic: 'Listen Now',
        classicCaption: 'Il blocco originale — il feed con la scheda Programmi',
        showcase: 'Vetrina',
        showcaseCaption: 'La vista editoriale: una card grande e una barra di copertine',
      },
      copy: {
        askTitle: 'Domanda degli ascoltatori',
        askHint: 'L’invito, una domanda di esempio e dove arrivano le risposte: un modulo, un indirizzo, una casella vocale.',
        ratingTitle: 'Valutazioni',
        ratingHint: 'Il tuo voto e una recensione da citare. Il blocco stampa quello che scrivi — non lo prende da Apple o Spotify.',
        supportTitle: 'Sostieni il programma',
        supportHint: 'Cosa ottengono i sostenitori e dove si iscrivono. Il pulsante porta dove già incassi.',
        title: 'Titolo',
        text: 'Testo',
        question: 'Domanda di esempio',
        url: 'Link del pulsante',
        buttonText: 'Testo del pulsante',
        voiceUrl: 'Link vocale',
        value: 'Voto',
        count: 'Da dove',
        quote: 'Recensione',
        author: 'Chi l’ha detto',
        tiers: 'Livelli',
        tierName: 'Nome',
        tierPerk: 'Cosa include',
        tierPrice: 'Prezzo',
        addTier: '+ Aggiungi livello',
        removeTier: 'Rimuovi livello',
      },
      blockTitle: 'Podcast',
      blockText: 'Promuovi i tuoi podcast',
      blockShortText: 'Promuovi i tuoi podcast',
    },
    'page-list': {
      blockTitle: 'Elenco pagine',
      blockText: 'Mostra un elenco delle tue pagine con titoli e descrizioni per una navigazione semplice.',
      blockShortText: 'Elenca le tue pagine.',
      description: 'Descrizione',
      addNewPageItem: 'Aggiungi link a pagina',
    },
    appointment: {
      blockTitle: 'Appuntamenti',
      blockText: 'Permetti ai visitatori di prenotare nel tuo calendario',
      blockShortText: 'Permetti la prenotazione',
    },
    service: {
      modal: {
        title: 'Aggiungi nuovo servizio',
        subtitle: "Inserisci l'essenziale — aggiungi il resto nella pagina del servizio",
        thumbnail: 'Miniatura (opzionale)',
        thumbnailTooltip: 'Carica una foto di copertina',
        label: 'Etichetta (opzionale)',
        labelTooltip: 'Metti in evidenza questo servizio con un badge',
        titleField: 'Titolo',
        titleTooltip: 'Aggiungi un titolo per il tuo servizio',
        titlePlaceholder: 'es. Servizio fotografico di famiglia — 1 ora',
        cancel: 'Annulla',
        submit: 'Aggiungi',
      },
      blockTitle: 'Servizi',
      blockText: 'Riceverai una notifica via email quando ti viene inviata una richiesta',
      blockShortText: `Ricevi un'email`,
    },
    requests: {
      blockTitle: 'Servizi',
      blockText: 'Riceverai una notifica via email quando ti viene inviata una richiesta',
      blockShortText: `Ricevi un'email`,
    },
    tips: {
      blockTitle: 'Mance',
      blockText: 'UniLink rende il supporto divertente e semplice. Con pochi tap, i tuoi fan possono effettuare il pagamento e lasciare un messaggio',
      blockShortText: 'Rende il supporto divertente',
    },
    tip: {
      blockTitle: 'Mance',
      blockText: 'UniLink rende il supporto divertente e semplice. Con pochi tap, i tuoi fan possono effettuare il pagamento e lasciare un messaggio',
      blockShortText: 'Rende il supporto divertente',
    },
    donation: {
      blockTitle: 'Donazioni',
      blockText: 'UniLink rende il supporto divertente e semplice. Con pochi tap, i tuoi fan possono effettuare il pagamento e lasciare un messaggio',
      blockShortText: 'Rende il supporto divertente',
    },
    course: {
      blockTitle: 'Corso o tutorial',
      blockText: 'Permetti ai visitatori di prenotare nel tuo calendario',
      blockShortText: 'Permetti la prenotazione',
    },
    event: {
      blockTitle: 'Eventi o biglietti',
      blockText: 'Permetti al pubblico di partecipare ai tuoi eventi',
      blockShortText: 'Permetti al pubblico',
    },
    menu: {
      blockTitle: 'Menu',
      blockText: 'Crea un menu unico con i prezzi',
      blockShortText: 'Crea un menu unico',
    },
    recipe: {
      blockTitle: 'Ricetta',
      blockText: 'Condividi una ricetta con ingredienti, passaggi e foto',
      blockShortText: 'Condividi una ricetta',
    },
    booking: {
      blockTitle: 'Prenotazioni',
      blockText: 'Permetti ai visitatori di prenotare i tuoi spazi',
      blockShortText: 'Permetti la prenotazione',
      name: 'Nome',
      nameCaption: 'Inserisci il nome dello spazio',
      description: 'Descrizione',
      descriptionCaption: 'Breve descrizione di questo spazio',
      rentalType: 'Tipo di affitto',
      rentalTypeCaption: 'Ad esempio: appartamento, auto, ufficio',
      duration: 'Durata',
      durationCaption: 'Ad esempio: al giorno, a settimana, al mese',
      price: 'Prezzo',
      priceCaption: 'Prezzo base per questo spazio',
      oldPrice: 'Prezzo precedente',
      oldPriceCaption: 'Prezzo precedente facoltativo',
      rating: 'Valutazione',
      ratingCaption: 'Valutazione media (facoltativa)',
      label: 'Etichetta',
      labelCaption: 'Badge breve come HOT o NEW',
      image: 'Immagine',
      imageCaption: `Carica un'immagine di copertina per questo spazio`,
      location: 'Posizione',
      locationCaption: 'Città, zona o indirizzo',
      capacity: 'Capienza (ospiti)',
      capacityCaption: 'Numero massimo di ospiti',
      rooms: 'Stanze e superficie',
      roomsCaption: 'Camere, bagni e superficie',
      bedrooms: 'Camere da letto',
      bathrooms: 'Bagni',
      areaSqM: 'Superficie (m²)',
      minStay: 'Soggiorno minimo (giorni)',
      minStayCaption: 'Numero minimo di giorni per la prenotazione',
      requiresDeposit: 'Richiede caparra',
      depositAmount: 'Importo caparra',
      depositAmountCaption: 'Caparra anticipata per confermare la prenotazione',
      noSmoking: 'Vietato fumare',
      noPets: 'Animali non ammessi',
      amenitiesWifi: 'Wi‑Fi',
      amenitiesParking: 'Parcheggio',
      amenitiesKitchen: 'Cucina',
      amenitiesHeating: 'Riscaldamento',
      amenitiesAC: 'Aria condizionata',
      amenitiesPool: 'Piscina',
      amenitiesSauna: 'Sauna',
      amenitiesRestrooms: 'Servizi igienici',
      validationNameRequired: 'Il nome è obbligatorio',
      validationPriceRequired: 'Il prezzo deve essere un numero non negativo',
      validationDepositRequired: `L'importo della caparra è obbligatorio quando la caparra è attiva`,
      validationCapacityNumber: 'La capienza deve essere un numero non negativo',
      validationOldPriceNumber: 'Il prezzo precedente deve essere un numero non negativo',
      brand: 'Marca',
      brandCaption: `Marca dell'auto, es. Tesla`,
      model: 'Modello',
      modelCaption: `Modello dell'auto, es. Model 3`,
      year: 'Anno',
      yearCaption: 'Anno di immatricolazione',
      color: 'Colore',
      colorCaption: 'Colore esterno, es. nero',
      fuelType: 'Tipo di carburante',
      fuelTypeCaption: 'Benzina, diesel, elettrico, ibrido ecc.',
      transmission: 'Cambio',
      transmissionCaption: 'Automatico o manuale',
      seatCount: 'Numero di posti',
      seatCountCaption: `Numero di posti nell'auto`,
      edit: 'Modifica elemento',
      add: 'Aggiungi elemento',
    },
    membership: {
      blockTitle: 'Abbonamento',
      blockText: 'Crea un abbonamento gratuito o a pagamento ai tuoi contenuti',
      blockShortText: 'Crea abbonamento',
    },
    pricing: {
      blockTitle: 'Prezzi',
      blockText: 'Crea un menu unico con i prezzi',
      blockShortText: 'Crea un menu unico',
      name: 'Nome',
      nameTooltip: 'Inserisci il nome del tuo prodotto',
      pricingPlanName: 'Nome del piano tariffario',
      pricingPlanNameTooltip: 'Inserisci il nome del tuo piano tariffario',
      description: 'Descrizione',
      descriptionTooltip: 'Inserisci la descrizione del tuo prodotto',
      pricingPlanDescriptionTooltip: 'Inserisci la descrizione del tuo piano tariffario',
      priceValue: 'Valore del prezzo',
      priceUnit: 'Unità di prezzo',
      label: 'Etichetta',
      labelTooltip: `Inserisci l'etichetta del tuo piano tariffario`,
      orderButtonText: `Testo del pulsante d'ordine`,
      orderButtonTextDescriptionTooltip: `Inserisci il testo del pulsante d'ordine del tuo piano tariffario`,
      orderButtonLink: `Link del pulsante d'ordine`,
      orderButtonLinkDescriptionTooltip: `Inserisci il link del pulsante d'ordine del tuo piano tariffario`,
      subtitle: 'Sottotitolo',
      subtitleTooltip: 'Inserisci il sottotitolo del tuo prodotto',
      price: 'Prezzo',
      priceTooltip: 'Inserisci il prezzo del tuo prodotto',
      pricingTiers: 'Fasce di prezzo',
      pricingTiersTooltip: 'Inserisci le fasce di prezzo del tuo prodotto',
      addPriceValue: 'Aggiungi altro prezzo',
      group: 'Gruppo',
      groupTooltip: 'Scegli il gruppo del tuo prodotto',
      image: 'Immagine',
      imageTooltip: `Carica un'immagine per il tuo prodotto`,
      unit: 'Unità di prezzo',
      unitTooltip: `Inserisci l'unità del tuo prezzo`,
      addUnitTitle: 'Unità di prezzo',
      addPriceUnitValue: 'Aggiungi altra unità di prezzo',
      addUnitButtonText: 'Salva',
      button: 'Pulsante',
      buttonTooltip: 'Aggiungi un pulsante per il tuo prodotto',
      buttonAddText: '+ Aggiungi pulsante',
      buttonModalTextField: 'Testo del pulsante',
      buttonModalTextFieldTooltip: 'Inserisci il testo del pulsante',
      buttonModalURLField: 'URL del pulsante',
      buttonModalURLFieldTooltip: `Inserisci l'URL del pulsante`,
      buttonModalTitle: 'Aggiungi pulsante',
      groups: {
        title: 'Gruppi',
        subtitle: 'Aggiungi, modifica ed elimina gruppi',
        groups: 'Gruppi',
        groupsTooltip: 'Aggiungi, modifica ed elimina gruppi',
        addNewGroup: 'Aggiungi nuovo gruppo',
        newGroup: 'Nuovo gruppo',
        titleGroup: 'Titolo',
        titleGroupTooltip: 'Inserisci il titolo del tuo gruppo',
        descriptionGroup: 'Descrizione',
        descriptionGroupTooltip: 'Inserisci la descrizione del tuo gruppo',
      },
    },
    menuBlock: {
      title: 'Menu',
      subtitle: 'Crea un menu con voci e prezzi',
      add: 'Aggiungi nuova voce',
      edit: 'Modifica voce',
      name: 'Nome',
      nameCaption: 'Inserisci il nome della voce',
      description: 'Descrizione',
      descriptionCaption: 'Inserisci una breve descrizione',
      ingredients: 'Ingredienti',
      ingredientsCaption: 'Elenca ingredienti o composizione',
      price: 'Prezzo',
      priceCaption: 'Inserisci il prezzo',
      weight: 'Peso (g)',
      weightCaption: 'Inserisci il peso in grammi',
      calories: 'Calorie (kcal)',
      caloriesCaption: 'Inserisci le calorie in kcal',
      label: 'Etichetta',
      labelCaption: `Inserisci il testo dell'etichetta`,
      labelColor: 'Colore etichetta',
      labelColorCaption: `Scegli un colore di sfondo per l'etichetta`,
      image: 'Immagine',
      imageCaption: `Carica un'immagine per il tuo articolo`,
      available: `Disponibile per l'ordinazione`,
      visible: 'Visibile sulla pagina',
    },
    nft: {
      blockTitle: 'NFT',
      blockText: 'Mostra un NFT dalla piattaforma OpenSea o dal tuo wallet personale',
      blockShortText: 'Mostra un NFT',
    },
    wallet: {
      wallet: 'Wallet',
      blockTitle: 'Wallet bancario/Crypto',
      blockText: 'Mostra la tua carta di credito o il wallet Bitcoin per facilitare agli utenti la copia e il trasferimento di fondi',
      blockShortText: 'Mostra i tuoi wallet',
      title: 'Titolo',
      titleTooltip: 'Titolo del tuo wallet',
      walletNumber: 'Numero wallet',
      walletNumberTooltip: 'Incolla il numero del tuo wallet',
      icon: 'Icona',
      iconTooltip: `Imposta un'icona per il tuo wallet`,
      card: 'Carta',
      bank: 'Banca',
      crypto: 'Crypto',
      transfer: 'Trasferimento',
      paymentLink: 'Link di pagamento',
      cardNumber: 'Numero carta',
      cardNumberTooltip: 'Incolla il numero della tua carta',
      cardHolder: 'Intestatario carta',
      cardHolderTooltip: `Inserisci l'intestatario della carta`,
      bankAccountDetails: 'Dettagli conto bancario',
      bankAccountDetailsTooltip: 'Inserisci i dettagli del tuo conto bancario',
      walletAddress: 'Indirizzo wallet',
      walletAddressTooltip: `Inserisci l'indirizzo del tuo wallet`,
      network: 'Network',
      networkTooltip: 'Inserisci il tuo network',
      publicKey: 'Chiave pubblica',
      publicKeyTooltip: 'Inserisci la tua chiave pubblica',
      providerName: 'Nome provider',
      providerNameTooltip: 'Inserisci il nome del tuo provider',
      link: 'Link',
      linkTooltip: 'Inserisci il tuo link',
      serviceName: 'Nome servizio',
      serviceNameTooltip: 'Inserisci il nome del tuo servizio',
      email: 'Email',
      emailTooltip: 'Inserisci la tua email',
      phone: 'Telefono',
      phoneTooltip: 'Inserisci il tuo telefono',
      username: 'Username',
      usernameTooltip: 'Inserisci il tuo username',
      fullName: 'Nome completo',
      fullNameTooltip: 'Inserisci il tuo nome completo',
      referenceNumber: 'Numero di riferimento',
      referenceNumberTooltip: 'Inserisci il tuo numero di riferimento',
      country: 'Paese',
      countryTooltip: 'Inserisci il tuo paese',
      transferProvider: 'Provider di trasferimento',
      transferProviderTooltip: 'Inserisci il tuo provider di trasferimento',
      cryptoCurrency: 'Criptovaluta',
      cryptoCurrencyTooltip: 'Inserisci la tua criptovaluta',
    },
    instagram: {
      blockTitle: 'Instagram',
      blockText: 'Metti in evidenza i tuoi migliori contenuti e video Instagram o vendi i tuoi prodotti con un feed Instagram acquistabile',
      blockShortText: 'I tuoi migliori contenuti Instagram',
      blockConnectTitle: 'Instagram non è connesso',
      blockConnectText: 'Sembra che i tuoi prodotti Instagram non siano ancora stati importati. Connetti subito il tuo account',
      blockConnectButton: 'Aggiungi Instagram',
      emptyList: 'Non hai ancora contenuti Instagram.',
      addInstagramUsername: 'Aggiungi nome utente Instagram',
      username: 'Nome utente',
      downloadTakes: 'Il download richiede fino a 2 minuti',
      displayPost: 'Mostra il post sul tuo sito web',
      view: 'Visualizza',
      redirect: 'Reindirizzamento URL',
      text: 'Testo e pulsante',
      actionType: 'Tipo di azione',
      url: 'URL',
      openInNewTab: 'Apri in una nuova scheda',
      delete: 'Elimina',
      cancel: 'Annulla',
      save: 'Salva',
      editMedia: 'Modifica contenuto',
      title: 'Titolo',
      automation: 'Automazione',
      automationText: 'Automatizza il tuo account con le funzionalità Autopilot',
      autopilot: 'Autopilot',
      autopilotTooltip: 'Carica un post con la didascalia di esempio e i tag/link dei tuoi prodotti verranno generati automaticamente',
      switchTitle: 'Rileva automaticamente titolo, prezzo, link',
      sampleCaption: 'Didascalia di esempio: #49.99 #BellAbito https://google.com',
      integrations: 'Integrazioni',
      integrationsText: 'Aggiungi Instagram al tuo sito web',
      connectInstagram: 'Connetti Instagram',
      connectInstagramText: 'Connetti il tuo account Instagram per mostrare i post o i reel che preferisci.',
      selectAccount: 'Seleziona account',
      connectNewInstagram: 'Connetti un nuovo account Instagram',
      continue: 'Continua',
      disconnectInstagram: 'Disconnetti Instagram',
      addTag: 'Aggiungi tag',
      tagClickHint: `Fai clic sull'immagine per posizionare il tag`,
      tagPositionSet: 'Posizione impostata. Compila i dettagli di seguito.',
      tagTypeLink: 'Link',
      tagTypeProduct: 'Prodotto',
      tagLabel: 'Etichetta',
      tagSelectProduct: 'Seleziona prodotto',
    },
    tiktok: {
      blockTitle: 'TikTok',
      blockText: 'Metti in evidenza il tuo miglior video TikTok o vendi i tuoi prodotti con un feed TikTok acquistabile',
      blockShortText: 'Il tuo miglior video TikTok',
      addTikTok: 'Aggiungi account TikTok',
      individualVideo: 'Video singolo',
      videoCollection: 'Raccolta video',
      add: 'Aggiungi',
      blockConnectTitle: 'TikTok non è connesso',
      blockConnectText: 'Sembra che i tuoi prodotti TikTok non siano ancora stati importati. Connetti subito il tuo account',
      blockConnectButton: 'Collega TikTok',
      enterUsername: 'Inserisci nome utente',
      enterVideo: 'Inserisci un URL di un video TikTok',
      emptyList: 'Non hai ancora contenuti TikTok.',
      editMedia: 'Modifica contenuti',
      addTikTokVideo: 'Aggiungi video TikTok',
      displayPost: 'Mostra il post sul tuo sito web',
      delete: 'Elimina',
      cancel: 'Annulla',
      save: 'Salva',
      integrations: 'Integrazioni',
      integrationsText: 'Aggiungi TikTok al tuo sito web',
      connectTikTok: 'Collega TikTok',
      disconnectTikTok: 'Disconnetti TikTok',
      individualText: `Non puoi collegare un account TikTok a questo tipo di blocco ('individuale').`,
      individualText2: 'Aggiungi invece un singolo video TikTok.',
    },
    youtube: {
      blockTitle: 'YouTube',
      blockText: 'Mostra un video o uno streaming YouTube sulla tua pagina. Tagga prodotti nel video YouTube',
      blockShortText: 'Mostra un video YouTube',
      enterYouTubeLink: 'Inserisci URL YouTube',
      enterYouTubeLinkTooltip: 'Incolla URL YouTube',
    },
    overview: {
      blockTitle: 'Panoramica',
      blockText: 'Mostra un video o uno streaming sulla tua pagina. Tagga prodotti nel video',
      blockShortText: 'Tagga prodotti nel video',
    },
    video: {
      blockTitle: 'Video',
      blockText: 'Mostra un video o uno streaming sulla tua pagina',
      blockShortText: 'Mostra un video',
    },
    short: {
      blockTitle: 'Shorts / Reels',
      blockText: 'Aggiungi video verticali brevi — Shorts, Reels, TikTok',
      blockShortText: 'Video verticali',
    },
    twitter: {
      blockTitle: 'X (Twitter)',
      blockText: 'Mostra i tuoi Tweet sulla tua pagina UniLink per aumentare il coinvolgimento',
      blockShortText: 'Mostra i tuoi Tweet',
      twitterURL: 'URL Twitter',
      twitterURLTooltip: 'Aggiungi URL da Twitter per generare il codice embed',
      enterTwitterURL: 'Inserisci un URL Twitter',
    },
    music: {
      templates: {
        nowPlaying: 'Player',
        nowPlayingCaption: 'Una card scura con copertina, barra di avanzamento e comandi: scorre i brani del blocco',
        compact: 'Player compatto',
        compactCaption: 'Lo stesso player a un terzo dell’altezza, per un brano che non è il protagonista',
        tracklist: 'Tracklist',
        tracklistCaption: 'Righe numerate con la durata e un pulsante play, come il retro di un disco',
        queue: 'Coda di ascolto',
        queueCaption: 'Cosa suona e cosa viene dopo: un piccolo player d’album con la sua coda',
        featured: 'Brano in evidenza',
        featuredCaption: 'La copertina a tutta card, il titolo sopra e un pulsante play',
        waveform: 'Forma d’onda',
        waveformCaption: 'Una registrazione disegnata come onda che si riempie mentre suona: per un demo o un mix',
        mix: 'DJ set',
        mixCaption: 'Una foto a tutto campo, la durata del set e la tracklist dietro un pulsante',
        release: 'Uscita con link',
        releaseCaption: 'Copertina, titolo e una riga per ogni servizio di streaming — la card smart-link',
        streaming: 'Link di streaming',
        streamingCaption: 'Solo i servizi, senza copertina: porta il visitatore sulla piattaforma che già usa',
        presave: 'Pre-salvataggio',
        presaveCaption: 'Un disco non ancora uscito e i tap che lo mettono in libreria il giorno dell’uscita',
        shelf: 'Scaffale album',
        shelfCaption: 'Ogni uscita come copertina, scorrimento laterale. Un tap apre i suoi link',
        playlistCard: 'Card playlist',
        playlistCardCaption: 'Un mosaico di cosa c’è nella playlist, la durata e un pulsante per ascoltarla',
        record: 'Compra il disco',
        recordCaption: 'La custodia, il prezzo e due pulsanti — comprarlo o ascoltarlo prima',
        classic: 'Schede',
        classicCaption: 'Il blocco originale: Brani, Playlist e Uscite a schede con le solite card',
        showcase: 'Vitrina',
        showcaseCaption: 'La vista editoriale — grandi card delle uscite e sotto una barra con il resto',
      },
      blockTitle: 'Musica',
      blockText: 'Incorpora un brano o una playlist Spotify, SoundCloud oppure carica il tuo file audio',
      blockShortText: 'Aggiungi la tua musica',
      brand: 'Brand',
      brandTooltip: 'Scegli il tipo per aggiungere la tua musica',
      url: 'URL',
      embed: 'Codice embed',
      custom: 'Personalizzato',
      musicUrl: 'URL musica',
      musicUrlTooltip: 'Inserisci URL della musica',
      embedCodeTitle: 'Codice embed',
      embedCodeTooltip: 'Incolla il codice embed del tuo brano dalla piattaforma musicale scelta',
      audioFile: 'File audio',
      uploadAudios: 'Qui puoi caricare solo file audio',
      title: 'Titolo',
      titleTooltip: 'Inserisci il titolo della tua musica',
      artist: 'Artista',
      artistTooltip: `Inserisci l'artista della tua musica`,
      audioFileTitle: 'File audio',
      audioFileTooltip: 'Nome del tuo file audio',
      coverImage: 'Immagine di copertina',
      coverImageTooltip: `Carica un'immagine per la tua musica`,
    },
    twitch: {
      blockTitle: 'Twitch',
      blockText: 'Incorpora un video o uno streaming Twitch sulla tua pagina',
      blockShortText: 'Incorpora video Twitch',
      twitchURL: 'URL Twitch',
      twitchURLTooltip: `Incolla l'URL del canale o il nome del canale`,
      twitchTV: 'twitch.tv/...',
      displayTwitch: 'Mostra il mio canale Twitch',
      displayChat: 'Mostra sia il mio canale Twitch che la chat',
    },
    splash: {
      blockTitle: 'Pop-up',
      blockText: 'Banner a schermo intero con testo e pulsante che appare prima del caricamento del sito per promuovere prodotti o eventi',
      blockShortText: 'Banner a schermo intero',
    },
    pageList: {
      templates: {
        classic: 'Elenco semplice',
        classicCaption: 'Il blocco originale: una pagina per riga con freccia. Bene fino a cinque pagine',
        described: 'Elenco con descrizioni',
        describedCaption: 'Righe numerate, ogni pagina con una riga che spiega dove porta',
        icons: 'Griglia di icone',
        iconsCaption: 'Due colonne con l’icona sopra il nome. Bene da sei pagine in su',
        covers: 'Schede con copertina',
        coversCaption: 'Un’immagine accanto a ogni pagina, per le sezioni da mostrare',
        groups: 'Sezioni raggruppate',
        groupsCaption: 'Una mappa del sito: pagine sotto le etichette di gruppo che imposti',
        headline: 'Righe grandi',
        headlineCaption: 'Righe sovradimensionate su un pannello pieno, per quattro o cinque mete',
        tiles: 'Riquadri con foto',
        tilesCaption: 'Riquadri foto due per riga; l’ultimo da solo occupa tutta la larghezza',
        tags: 'Tag',
        tagsCaption: 'Ogni pagina come pillola. La scelta compatta quando sono dieci o più',
        prevNext: 'Precedente e successiva',
        prevNextCaption: 'Le due pagine adiacenti, per il fondo di una pagina lunga',
      },
    },
    promo: {
      blockTitle: 'Barra promo',
      blockText: 'Evidenziatore che ti consente di mostrare promozioni',
      blockShortText: 'Metti in risalto le tue promozioni',
    },
    welcome: {
      blockTitle: 'Messaggio di benvenuto',
      blockText: 'Scrivi messaggi di benvenuto che invitano i visitatori a iniziare una chat. Compare in fondo alla pagina per dare il benvenuto e offrire assistenza',
      blockShortText: 'Scrivi messaggi di benvenuto',
    },
    review: {
      blockTitle: 'Recensioni',
      blockText: 'Le recensioni aiutano i clienti a saperne di più sul prodotto e a decidere se è quello giusto per loro',
      blockShortText: 'Le recensioni aiutano i clienti',
      name: 'Nome',
      nameTooltip: 'Inserisci il nome del recensore',
      comment: 'Commento',
      commentTooltip: 'Inserisci il commento del recensore',
      date: 'Data',
      dateTooltip: 'Inserisci la data del recensore',
      rate: 'Valutazione',
      rateTooltip: 'Imposta la valutazione della recensione',
      image: 'Immagine',
      imageTooltip: `Carica l'immagine del recensore`,
    },
    coupon: {
      blockTitle: 'Coupon',
      blockText: 'Un coupon online è un codice sconto o un numero che può essere riscattato su un sito web',
      blockShortText: 'Il coupon online si riferisce',
    },
    timer: {
      blockTitle: 'Countdown',
      blockText: `Un timer per il conto alla rovescia è un orologio virtuale su una pagina che effettua un conto alla rovescia da un certo numero o data per indicare l'inizio o la fine di un evento o di un'offerta`,
      blockShortText: 'Un timer per il conto alla rovescia',
    },
    outfit: {
      blockTitle: 'Outfit',
      blockText: 'Crea il tuo elenco di prodotti',
      blockShortText: 'Crea elenco prodotti',
    },
    spacer: {
      blockTitle: 'Spaziatore',
      blockText: 'Aggiungi dello spazio verticale vuoto alla tua pagina',
      blockShortText: 'Aggiungi dello spazio vuoto',
    },
    html: {
      blockTitle: 'Embed',
      blockText: `Puoi incollare il tuo codice HTML nella pagina UniLink. L'HTML è un linguaggio di markup standard per la creazione di pagine web. Consente iframe, sezioni, paragrafi e link.`,
      blockShortText: 'Incolla il tuo HTML',
      markupCode: 'Codice di markup',
      markupCodeTooltip: 'Incolla il codice di markup del tuo HTML',
      strippedWarning: 'Rimosso per sicurezza durante la visualizzazione:',
    },
    unlock: {
      blockTitle: 'Sblocca',
      blockText: 'Proteggi i contenuti con password, email, pagamento o regole personalizzate. Perfetto per contenuti esclusivi e accessi a pagamento.',
      blockShortText: 'Blocca contenuti.',
    },
    file: {
      blockTitle: 'File',
      blockText:
        'Questo blocco ti permette di caricare e condividere file come documenti, immagini o audio. I visitatori possono visualizzarli o scaricarli facilmente direttamente dalla tua pagina.',
      blockShortText: 'Carica e condividi i tuoi file.',
      addNewItem: 'Aggiungi nuovo file',
      editFile: 'Modifica file',
      fileName: 'Inserisci il nome del file',
      fileDescription: 'Descrizione del file (facoltativa)',
      coverImage: 'Immagine di copertina (facoltativa)',
      templates: {
        classic: 'Elenco classico',
        classicCaption: "Il blocco originale: una riga per file con icona, peso e badge d'accesso",
        list: 'Elenco file',
        listCaption: 'Righe con il formato su una targhetta e il pulsante di download a destra',
        single: 'Download singolo',
        singleCaption: 'Una scheda, un pulsante grande. Per il blocco che pubblica una sola cosa',
        cover: 'Anteprima copertina',
        coverCaption: 'La prima pagina come immagine, con testo e pulsante sotto',
        folders: 'Cartelle',
        foldersCaption: 'File raggruppati per tipo; ogni cartella mostra quanti e quanto pesano',
        formats: 'Formati',
        formatsCaption: 'Uno stesso materiale in tutti i formati, come chip da toccare',
        versions: 'Versioni',
        versionsCaption: 'Il file attuale incorniciato in alto, i precedenti raggiungibili sotto',
        gate: 'File in cambio di email',
        gateCaption: "Il download si apre dopo che il visitatore lascia un'email",
        transfer: 'Trasferimento pesante',
        transferCaption: 'Una scheda scura per consegne pesanti, con avviso sulle dimensioni',
      },
    },
    stat: {
      templates: {
        grid: 'Quattro numeri',
        gridCaption: 'Due per riga, ognuno con una didascalia che dice cosa conta',
        hero: 'Un numero grande',
        heroCaption: 'Una sola cifra che riempie il blocco, nel colore della pagina',
        row: 'Riga di tre',
        rowCaption: 'Tre numeri brevi su una riga, separati da filetti',
        change: 'Con variazione',
        changeCaption: 'Un numero e come si è mosso, dal campo extra di ogni dato',
        bars: 'Grafico a barre',
        barsCaption: 'Una colonna per dato, la più alta nel tuo colore accento',
        progress: 'Barre di avanzamento',
        progressCaption: 'Una ripartizione in barre piene: nome, numero, barra',
        photo: 'Con foto',
        photoCaption: 'L’immagine del titolo del blocco sopra una riga di numeri',
        live: 'Contatore live',
        liveCaption: 'Un numero con un punto pulsante accanto',
        source: 'Nota sulla fonte',
        sourceCaption: 'Due numeri e una riga che dice da dove vengono',
        trend: 'Andamento',
        trendCaption: 'I dati come linea nel tempo, il numero più recente in alto',
        share: 'Quote',
        shareCaption: 'Come si divide un totale, ad anello con legenda',
        ranked: 'Classifica',
        rankedCaption: 'Una top cinque numerata con una barra sotto ogni riga',
        feed: 'Feed',
        feedCaption: 'Il blocco originale — riquadri che vanno a capo su più righe',
        slider: 'Slider',
        sliderCaption: 'Gli stessi riquadri su una guida che il visitatore scorre',
      },
      blockTitle: 'Statistiche',
      blockText:
        'Questo blocco ti permette di mostrare informazioni chiave sulla tua pagina, come visualizzazioni, visitatori o coinvolgimento. Ti aiuta a monitorare il tuo pubblico e a capire come performa la tua pagina.',
      blockShortText: 'Aggiungi statistiche alla tua pagina.',
      addNewItem: 'Aggiungi nuova statistica',
      editItem: 'Modifica statistica',
      statName: 'Inserisci il nome della statistica',
      statValue: 'Inserisci il valore della statistica',
      statDescription: 'Inserisci la descrizione della statistica',
      statProgress: 'Barra di avanzamento, % (facoltativo)',
      statLabel: 'Variazione o fonte',
      statLabelTooltip: 'La pillola accanto al numero in «Con variazione» e «Andamento» («+18%», «−1,1»), o la riga sotto i numeri in «Nota sulla fonte»',
      matchScreenshot: 'Copia da uno screenshot',
      matchScreenshotRunning: 'Lettura del design…',
      matchScreenshotSkipped: 'Colore delle tessere e font sono rimasti invariati',
      compose: 'Progetta',
      composePlaceholder: 'Descrivi lo stile: «chiaro e moderno», «più deciso»',
      composeHint: 'Il colore arriva dalla palette; il contrasto del testo è garantito',
      composeDone: 'Design aggiornato',
      review: 'Verifica',
      reviewClean: 'Verificato: nulla da correggere',
      reviewFixed: 'Verificato e corretto',
      statItemFields: 'Seleziona i campi da mostrare.',
      columns: 'Colonne',
      subtitleColumns: 'Quante statistiche stanno in una riga',
      feed: 'Feed',
      slider: 'Slider',
      titleSize: 'Dimensione titolo',
      subtitleTitleSize: 'Puoi modificare la dimensione del titolo',
    },
    listing: {
      blockTitle: 'Annunci',
      blockText: 'Mostra annunci di immobili o articoli con immagini, dettagli e prezzi.',
      blockShortText: 'Aggiungi annunci alla tua pagina.',
    },
    rental: {
      blockTitle: 'Affitto',
      blockText: 'Elenca immobili o articoli in affitto con disponibilità e prezzi per periodo.',
      blockShortText: 'Aggiungi affitti alla tua pagina.',
    },
    'single-product': {
      blockTitle: 'Prodotto singolo',
      blockText: 'Metti in evidenza un singolo prodotto con immagine, descrizione e pulsante di acquisto.',
      blockShortText: 'Metti in evidenza un prodotto.',
    },
    team: {
      blockTitle: 'Team',
      blockText: 'Presenta i membri del tuo team con foto, nomi, ruoli e link social.',
      blockShortText: 'Mostra il tuo team.',
    },
    timetable: {
      blockTitle: 'Orario',
      blockText: 'Mostra un programma settimanale con lezioni, eventi o sessioni.',
      blockShortText: 'Aggiungi un programma settimanale.',
    },
    wall: {
      blockTitle: 'Bacheca',
      blockShortText: 'Raccogli messaggi dai visitatori',
      blockText: 'Mostra una bacheca pubblica dove i visitatori possono lasciare messaggi e interagire con i tuoi contenuti',
    },
    'live-stream': {
      blockTitle: 'Live Stream',
      blockShortText: 'Vai in diretta sulla tua pagina',
      blockText: 'Trasmetti in diretta al tuo pubblico — nativamente tramite la nostra piattaforma, o incorpora YouTube / Twitch',
    },
    workout: {
      blockTitle: 'Allenamento',
      blockShortText: 'Condividi e vendi allenamenti',
      blockText: 'Pubblica un allenamento strutturato — esercizi con serie, ripetizioni e video dimostrativi. Vendilo o condividilo gratuitamente',
      templates: {
        sessionCard: 'Scheda della sessione',
        sessionCardCaption: 'Copertina, nome e una riga di dettagli sopra un pulsante di avvio',
        exerciseList: 'Elenco esercizi',
        exerciseListCaption: 'Ogni esercizio con miniatura, serie e carico',
        setTracker: 'Conta serie',
        setTrackerCaption: 'Una riga per serie — fatta, in corso, da fare',
        restTimer: 'Timer di recupero',
        restTimerCaption: 'Un grande countdown tra le serie e cosa viene dopo',
        weekPlan: 'Piano settimanale',
        weekPlanCaption: 'I giorni della settimana, con oggi pronto a partire',
        videoExercise: 'Video esercizio',
        videoExerciseCaption: 'Un video verticale sulla tecnica con le indicazioni sotto',
        progress: 'Progressi',
        progressCaption: 'Le sessioni del mese a barre, più due totali',
        circuit: 'Circuito',
        circuitCaption: 'Round di lavoro e recupero, con l’esercizio in corso illuminato',
        sessionDone: 'Sessione conclusa',
        sessionDoneCaption: 'Cosa hai appena finito, la serie di giorni e uno spazio per annotare come è andata',
      },
      defaults: {
        mon: 'Lun',
        tue: 'Mar',
        wed: 'Mer',
        thu: 'Gio',
        fullBody: 'Tutto il corpo',
        legsAndCore: 'Gambe e core',
        upperBody: 'Parte alta',
        restDay: 'Riposo',
      },
    },
    videoFeedback: {
      blockTitle: 'Feedback video',
      blockShortText: 'Raccogli testimonianze video',
      blockText: 'Raccogli brevi testimonianze video e feedback dal tuo pubblico',
    },
    'premium-inbox': {
      blockTitle: 'Posta premium',
      blockShortText: 'Messaggi a pagamento dai fan',
      blockText: 'Permetti ai fan di inviarti messaggi e richieste a pagamento direttamente nella tua posta premium',
    },
    'order-form': {
      blockTitle: `Modulo d'ordine`,
      blockShortText: 'Raccogli ordini dalla tua pagina',
      blockText: `Raccogli ordini direttamente dalla tua pagina con un modulo d'ordine personalizzabile`,
    },
  },
  pinnedDock: {
    title: 'Blocchi fissati',
    label: 'FISSATO',
    expand: 'Espandi i blocchi fissati',
    collapse: 'Comprimi i blocchi fissati',
  },
  reviewButton: {
    title: 'Pulsante «Lascia una recensione»',
    desc: 'Mostra sotto le recensioni un pulsante che indirizza i visitatori dove possono lasciare una recensione.',
    buttonText: 'Testo del pulsante',
    link: 'Link',
    leaveReview: 'Lascia una recensione',
    googleHint: 'Lascia vuoto per usare la tua pagina delle recensioni Google.',
    design: 'Design del pulsante',
    background: 'Sfondo',
    textColor: 'Testo',
  },
  themeTokens: {
    title: 'Stile del tema',
    subtitle: 'Tipografia, angoli e spaziatura',
    typography: 'Tipografia',
    corners: 'Angoli',
    density: 'Densità',
  },
  headingDesign: {
    title: 'Intestazione',
    subtitle: 'Eredita il colore del testo del blocco',
    hint: 'Un colore non toccato segue quello del blocco. Impostandone uno, vale solo per quella parte.',
    titleColor: 'Titolo',
    descriptionColor: 'Descrizione',
    inherited: 'ereditato',
    reset: 'Reimposta',
    custom: 'personalizzati',
  },
  advancedDesign: {
    inherited: 'ereditato',
    reset: 'Reimposta',
    title: 'Avanzate',
    subtitle: 'Regola con precisione ogni parte',
    slot_title: 'Titolo',
    slot_description: 'Descrizione',
    slot_label: 'Sopra-titolo',
    fontSize: 'Dimensione carattere',
    fontWeight: 'Spessore',
    textTransform: 'Maiuscole/minuscole',
    textAlign: 'Allineamento',
    color: 'Colore',
  },
  layoutPicker: {
    title: 'Layout',
    tooltip: 'Scegli come disporre gli elementi',
    layout_list: 'Elenco',
    layout_grid: 'Griglia',
    layout_cards: 'Schede',
  },
  importDesign: {
    title: 'Importa design',
    subtitle: 'Ricrea un design da uno screenshot',
    upload: 'Carica uno screenshot',
    extracting: 'Analisi…',
    apply: 'Applica alla pagina',
    applying: 'Applicazione…',
    blocksCount: '+{n} blocchi',
    applied: 'Design applicato — {n} blocchi aggiunti',
  },
  adminUi: {
    podcastEnterShowTitle: 'Inserisci il titolo dello show',
    podcastMaximum: 'Massimo',
    podcastCharacters: 'caratteri',
    podcastShowTitleExists: 'Esiste già uno show con questo titolo',
    podcastEditShow: 'Modifica show',
    podcastNewShow: 'Nuovo show',
    podcastCover: 'Copertina',
    podcastTitle: 'Titolo',
    podcastShowTitlePlaceholder: 'Titolo dello show',
    podcastCategory: 'Categoria',
    podcastCategoryPlaceholder: 'es. True Crime',
    podcastDescription: 'Descrizione',
    podcastDescriptionPlaceholder: 'Di cosa parla questo show…',
    podcastSubscribeButtons: 'Pulsanti “Iscriviti”',
    podcastAddPlatform: 'Aggiungi piattaforma',
    podcastSave: 'Salva',
    podcastCreate: 'Crea',
    episodeOne: 'episodio',
    episodeFew: 'episodi',
    episodeMany: 'episodi',
    edit: 'Modifica',
    delete: 'elimina',
    addShow: 'Aggiungi show',
    importFromRss: 'Importa da RSS',
    importFromRssFeed: 'Importa da feed RSS',
    importFromRssHint: 'Incolla un link RSS del podcast — gli episodi verranno importati automaticamente in un nuovo show.',
    import: 'Importa',
    trackWordOne: 'traccia',
    trackWordFew: 'tracce',
    trackWordMany: 'tracce',
    albumLabel: 'Album',
    pause: 'Pausa',
    play: 'Riproduci',
    emptyTracks: 'Nessuna traccia in questo album',
    untitled: 'Senza titolo',
    show: 'Show',
    audioFileNotAttached: 'File audio non allegato',
    paypalConnectionTitle: 'Scegli il metodo di connessione PayPal',
    paypalConnectionSubtitle: 'Seleziona il metodo di connessione più comodo per te',
    paypalRecommendedBadge: 'Consigliato',
    paypalPartnerTitle: 'Tramite PayPal Partner',
    paypalPartnerFeatureQuickConnect: 'Connessione rapida con 1 clic',
    paypalPartnerFeatureAutoTokens: 'Aggiornamento automatico dei token',
    paypalPartnerFeatureMostSecure: 'Metodo più sicuro',
    paypalPartnerFeatureNoApiKeys: 'Nessuna necessità di copiare chiavi API',
    paypalPartnerButton: 'Connetti tramite Partner',
    paypalDirectTitle: 'Direttamente (credenziali API)',
    paypalDirectFeatureClientIdSecret: 'Richiede Client ID e Secret',
    paypalDirectFeatureManualSetup: 'Configurazione manuale',
    paypalDirectFeatureFullControl: `Controllo completo sull'API`,
    paypalDirectFeatureAdvancedUsers: 'Per utenti esperti',
    paypalDirectButton: 'Connetti direttamente',
    clientIdRequired: 'Il Client ID è un campo obbligatorio',
    clientSecretRequired: 'Il Client Secret è un campo obbligatorio',
    invalidPaypalCredentials: 'Credenziali PayPal non valide',
    connectPaypalDirectly: 'Connetti PayPal direttamente',
    paypalConnectedSuccessfully: 'PayPal connesso con successo!',
    yourPaypalClientId: 'Il tuo Client ID PayPal dalla Dashboard',
    yourPaypalClientSecret: 'Il tuo Client Secret PayPal dalla Dashboard',
    chooseOperatingMode: 'Scegli la modalità operativa',
    sandboxTest: 'Sandbox (Test)',
    liveProduction: 'Live (Produzione)',
    whereToFindCredentials: '💡 Dove trovare le credenziali?',
    goTo: 'Vai a',
    createOrSelectApp: 'Crea una nuova App o selezionane una esistente',
    copyClientIdAndSecret: 'Copia il Client ID e il Secret',
    cancel: 'Annulla',
    connected: 'Connesso!',
    connect: 'Connetti',
    monobankTokenTooltip: 'Token da Monobank Business Acquiring',
    monobankTokenPlaceholder: 'Inserisci il token Monobank',
    whereToGetToken: 'Dove ottenere il token?',
    statusChangedTo: 'Stato cambiato in',
    all: 'Tutti',
    loading: 'Caricamento...',
    noBookingsYet: 'Nessuna prenotazione ancora',
    noBookingsWithStatus: 'Nessuna prenotazione con questo stato',
    nightsAbbr: 'notti',
    uah: 'UAH',
    oneNightDeposit: 'Deposito di una notte',
    fullPrepayment: 'Pagamento anticipato completo',
    online: 'Online',
    confirm: 'Conferma',
    complete: 'Completa',
    restore: 'Ripristina',
    bookingCalendarBooked: 'Prenotato',
    bookingCalendarBlockedManually: 'Bloccato manualmente',
    bookingCalendarAvailable: 'Disponibile',
    bookingCalendarNoSettings: 'Nessuna impostazione',
    bookingCalendarSaveItemFirst: `Salva prima l'elemento`,
    bookingCalendarLoading: 'Caricamento...',
    bookingCalendarBlocked: 'Bloccato',
    bookingCalendarSelected: 'Selezionato',
    bookingCalendarSelectedDates: 'Date selezionate',
    bookingCalendarPricePerDay: 'Prezzo/giorno',
    bookingCalendarOpen: 'Apri',
    bookingCalendarBlock: 'Blocca',
    bookingCalendarCancel: 'Annulla',
    responseDeleted: 'Risposta eliminata',
    deleteAllConfirm: 'Eliminare tutte le risposte? Questa azione non può essere annullata.',
    allResponsesDeleted: 'Tutte le risposte eliminate',
    responseOne: 'risposta',
    responseFew: 'risposte',
    responseMany: 'risposte',
    deleteAll: 'Elimina tutto',
    allForms: 'Tutti i moduli',
    noResponsesYet: 'Nessuna risposta ancora',
    fieldName: 'Nome',
    fieldPhone: 'Telefono',
    fieldAddress: 'Indirizzo',
    fieldComment: 'Commento',
    customFields: 'Campi aggiuntivi',
    more: 'Altro',
    view: 'Visualizza',
    track: 'Traccia',
    showing: 'Visualizzati',
    of: 'di',
    ordersLower: 'ordini',
    ordersEmpty: 'Nessun record ancora',
    ordersCountLabel: 'record',
    ordersName: 'Nome',
    ordersPhone: 'Telefono',
    ordersLoading: 'Caricamento...',
    ordersComment: 'Commento',
    ordersPayment: 'Pagamento',
    ordersPrev: 'Precedente',
    ordersNext: 'Successivo',
    revokeAccessConfirm: `Revocare l'accesso?`,
    accessRevoked: 'Accesso revocato',
    activeGrants: 'concessioni attive',
    noActiveGrants: 'Nessuna concessione attiva',
    type: 'Tipo',
    grantedBy: 'Concesso da',
    started: 'Iniziato',
    until: 'Fino a',
    revoke: 'Revoca',
    deleted: 'Eliminato',
    subscribers: 'iscritti',
    noSubscribersYet: 'Nessun iscritto ancora',
    phone: 'Telefono',
    name: 'Nome',
    step: 'Passo',
    done: 'completato',
    stepFailedSingular: 'passo fallito',
    stepFailedPlural: 'passi falliti',
    done2: 'Fatto.',
    actionFailed: `Impossibile eseguire l'azione.`,
    starterCoffeeSite: 'Crea un sito per una caffetteria',
    starterFaq: 'Aggiungi un blocco FAQ con 5 domande',
    starterTranslate: `Traduci l'intero sito in inglese`,
    starterBrandColors: 'Scegli i colori adatti al mio brand',
    stopped: 'Interrotto.',
    scopeSite: 'Sito',
    scopePage: 'Pagina',
    followUpAddPhoto: `Aggiungi un'altra foto`,
    followUpAddQuestion: `Aggiungi un'altra domanda`,
    followUpAddPlan: 'Aggiungi un altro piano tariffario',
    followUpAddService: 'Aggiungi un altro servizio',
    followUpAddBlock: 'Aggiungi un altro blocco',
    followUpMakeBetter: 'Miglioralo ancora',
    followUpTweakColors: 'Adatta i colori al mio brand',
    followUpChangeColors: 'Cambia colori',
    followUpTranslateEnglish: 'Traduci in inglese',
    undoneDeletedPrefix: 'Annullato — rimossi',
    undoneOf: 'di',
    undoneCreatedBlocks: 'blocchi creati',
    planAnalyzing: 'Analisi della richiesta',
    planCheckingSite: 'Controllo dello stato del sito',
    planChoosingBlocks: 'Scelta dei blocchi',
    planPreparing: 'Preparazione del piano',
    hideDetails: 'Nascondi dettagli',
    details: 'Dettagli',
    emptyStateTitle: 'Come posso aiutarti?',
    emptyStateSubtitle: 'Descrivi cosa fare — o scegli un esempio qui sotto',
    undoing: 'Annullamento…',
    undo: 'Annulla',
    blockSingular: 'blocco',
    blockPlural: 'blocchi',
    usageCostTitle: 'Costo di questa richiesta',
    tokens: 'token',
    stop: 'Ferma',
    scopeSiteTitle: 'Modifiche su tutto il sito',
    scopePageTitle: 'Modifiche solo sulla pagina corrente',
    customDesign: 'Design personalizzato',
    appointmentEmbedTitle: 'URL di incorporamento',
    appointmentEmbedSubtitle: 'Incorpora Calendly come iframe in linea',
    appointmentEmbedCaption: 'URL Calendly',
    appointmentEmbedTooltip: 'Incolla l’URL del tuo evento Calendly (es. https://calendly.com/you/30min)',
    appointmentEmbedInvalid: 'Inserisci un URL Calendly valido (es. https://calendly.com/you/30min)',
  },
  ama: {
    questions: 'domande',
    all: 'Tutte',
    unanswered: 'Senza risposta',
    answered: 'Con risposta',
    loading: 'Caricamento...',
    noQuestions: 'Nessuna domanda ancora',
    anonymous: 'Anonimo',
    noName: 'Senza nome',
    yourAnswer: 'La tua risposta',
    edit: 'Modifica',
    delete: 'Elimina',
    cancel: 'Annulla',
    enterAnswer: 'Inserisci la tua risposta...',
    saveAnswer: 'Salva risposta',
    confirmDelete: 'Eliminare questa domanda?',
    answerSaved: 'Risposta salvata',
    deleted: 'Eliminato',
  },
  adsManager: {
    estimatedAudience: 'Dimensione stimata del pubblico',
    audienceTooLarge: 'Il tuo pubblico è molto ampio — valuta di restringerlo.',
    audienceTooNarrow: 'Il tuo pubblico è molto ristretto — valuta di ampliarlo.',
    audience: 'Pubblico',
    suggestedAudience: 'Usa il pubblico suggerito',
    suggestedAudienceHint: 'Targeting ampio, ideale per la copertura',
    buildYourOwn: 'Crea il tuo',
    buildYourOwnHint: 'Imposta età, genere e paesi',
    expectedViewers: `Visualizzazioni previste dell'annuncio`,
    totalBudget: 'Budget totale della campagna',
    duration: 'Durata',
    days: 'giorni',
    advancedSchedule: 'Programmazione avanzata',
    hideAdvanced: 'Nascondi programmazione avanzata',
    adPreview: 'Anteprima annuncio',
    sponsored: 'Sponsorizzato',
    seeMore: 'Vedi altro',
    learnMore: 'Scopri di più',
    yourPage: 'La tua pagina',
  },
  virtualBackgrounds: {
    title: 'Sfondi virtuali',
    canvasSize: 'Dimensione tela',
    fmtCall: 'Zoom · Teams · Meet',
    fmtStories: 'Storie · Reel',
    fmtSquare: 'Quadrato',
    fmtClassic: 'Classico',
    background: 'Sfondo',
    bg_color: 'Colore',
    bg_gradient: 'Gradiente',
    bg_photo: 'Foto',
    bg_pattern: 'Motivo',
    from: 'Da',
    to: 'A',
    angle: 'Angolo',
    ink: 'Inchiostro',
    paper: 'Carta',
    blur: 'Sfocatura',
    darken: 'Scurisci',
    presets: 'Preset',
    uploadImage: 'Carica immagine',
    removeImage: 'Rimuovi immagine',
    replace: 'Sostituisci',
    remove: 'Rimuovi',
    photoPlaceholder: `Carica un'immagine dal pannello`,
    overlay: 'Sovrapposizione',
    showName: 'Mostra nome',
    namePlaceholder: 'Il tuo nome',
    subtitlePlaceholder: 'Sottotitolo / handle',
    typeface: 'Carattere',
    textColour: 'Colore testo',
    nameSizeLabel: 'Dimensione nome',
    position: 'Posizione',
    showQr: 'Mostra codice QR',
    qrPlaceholder: 'https://link',
    style: 'Stile',
    qrCard: 'Scheda',
    qrBrand: 'Brand',
    qrLight: 'Chiaro',
    qrSolid: 'Pieno',
    qrSizeLabel: 'Dimensione QR',
    logo: 'Logo / avatar',
    uploadLogo: 'Carica logo (PNG)',
    logoSizeLabel: 'Dimensione logo',
    finishing: 'Rifinitura',
    vignette: 'Vignettatura',
    vignetteHint: 'Bordi scuri sfumati per profondità',
    shuffle: 'Mescola',
    reset: 'Reimposta',
    dragHint: 'Trascina il nome, il QR o il logo sulla tela per riposizionarli',
    preparing: 'Preparazione…',
    download: 'Scarica',
    sizeHint: 'Salvato come JPG 1920 × 1080',
  },
  emailSignatures: {
    signatures: 'Firme',
    signature: 'Firma',
    signatureName: 'Etichetta',
    signatureNamePlaceholder: 'Lavoro, Personale…',
    newSignature: 'Nuova firma',
    createSignature: 'Crea firma',
    emptyText: 'Crea una firma e ogni email che invii rimanderà alla tua pagina.',
    default: 'Predefinita',
    isDefault: 'Firma predefinita',
    makeDefault: 'Rendi predefinita',
    duplicate: 'Duplica',
    delete: 'Elimina',
    save: 'Salva',
    saving: 'Salvataggio…',
    saved: 'Firma salvata',
    fillFromCard: 'Compila dal biglietto da visita',
    noCard: 'Nessun biglietto da visita — compila i campi manualmente',
    extras: 'Extra',
    socialLinks: 'Social',
    logo: 'Logo aziendale',
    upload: 'Carica',
    uploading: 'Caricamento…',
    uploadFailed: 'Caricamento non riuscito',
    imageTooLarge: 'L’immagine deve essere sotto i {size} MB',
    remove: 'Rimuovi',
    ctaText: 'Testo del pulsante',
    ctaTextPlaceholder: 'Prenota una call',
    ctaUrl: 'Link del pulsante',
    banner: 'Banner',
    disclaimer: 'Disclaimer',
    disclaimerPlaceholder: 'Avviso di riservatezza, dati aziendali…',
    tracking: 'Tracciamento',
    copyLink: 'Copia link',
    linkCopied: 'Link copiato',
    renewLink: 'Rinnova link',
    renewing: 'Rinnovo…',
    linkRenewed: 'Link rinnovato',
    renewHint: 'Il rinnovo genera un nuovo link. Le firme già inviate smetteranno di funzionare — i contatori qui sotto restano.',
    statClicks: 'Clic sul link',
    statQrScans: 'Scansioni QR',
    statCtaClicks: 'Clic sul pulsante',
    title: 'Firme email',
    details: 'Dettagli',
    name: 'Nome',
    jobTitle: 'Ruolo',
    company: 'Azienda',
    email: 'Email',
    phone: 'Telefono',
    website: 'Sito web',
    style: 'Stile',
    styleModern: 'Moderno',
    styleClassic: 'Classico',
    styleMinimal: 'Minimal',
    styleBold: 'Bold',
    styleCard: 'Scheda',
    accent: `Colore d'accento`,
    showAvatar: 'Mostra foto',
    showQr: 'Mostra codice QR',
    preview: 'Anteprima',
    copySignature: 'Copia firma',
    copyHtml: 'Copia HTML',
    copied: 'Firma copiata',
    copiedHtml: 'HTML copiato',
    instructions: {
      gmail: 'Gmail: Impostazioni → Vedi tutte le impostazioni → Generali → Firma → Crea nuova, poi incolla (Ctrl/Cmd+V) e salva le modifiche.',
      outlook: 'Outlook: File → Opzioni → Posta → Firme → Nuova, poi incolla. Nuovo Outlook / web: Impostazioni → Posta → Scrivi e rispondi → incolla nella casella della firma.',
      apple: 'Apple Mail: Mail → Impostazioni → Firme → aggiungi una firma, poi incollala. Deseleziona “Usa sempre il carattere predefinito dei messaggi”.',
    },
  },
  storyEditor: {
    back: 'Indietro',
    general: 'Generale',
    text: 'Testo',
    cta: 'CTA',
    media: 'Media',
    items: 'Prodotti',
    addOns: 'Componenti',
    stickers: 'Sticker',
    layers: 'Livelli',
    save: 'Salva',
    delete: 'Elimina',
    addText: 'Aggiungi testo',
    addCta: 'Cliccami',
    unsavedChanges: 'Modifiche non salvate',
    leaveConfirm: 'Uscire senza salvare? Le modifiche andranno perse.',
    title: 'Titolo',
    enterTitle: 'Inserisci il titolo',
    duration: 'Durata',
    durationHint: 'Per quanto resta visibile la storia',
    kenBurns: 'Ken Burns (zoom lento)',
    content: 'Contenuto',
    enterContent: 'Inserisci il contenuto',
    url: 'URL',
    enterUrl: "Inserisci l'URL",
    fontSize: 'Dimensione testo',
    chooseFontSize: 'Scegli la dimensione',
    stylePreset: 'Stile',
    stylePresetHint: 'Applica uno stile predefinito',
    animation: 'Animazione',
    animationHint: 'Animazione di entrata',
    color: 'Colore',
    chooseColors: 'Scegli i colori',
    filter: 'Filtro',
    cropImage: 'Ritaglia immagine',
    nothingToAdd: 'Niente da aggiungere',
    noLayers: 'Nessun livello',
    bringForward: 'Porta avanti',
    sendBackward: 'Porta indietro',
    responses: 'Risposte',
    noResponses: 'Ancora nessuna risposta',
  },
  storyGroups: {
    stories: 'Storie',
    addStoryGroup: '+ Aggiungi gruppo',
    newStory: '+ Nuova storia',
    previewGroup: 'Anteprima gruppo',
    noStoriesYet: 'Ancora nessuna storia',
    editGroup: 'Modifica gruppo',
    duplicate: 'Duplica',
    delete: 'Elimina',
    preview: 'Anteprima',
    name: 'Nome',
    content: 'Contenuto',
    views: 'Visualizzazioni',
    behavior: 'Comportamento',
    live: 'Attiva',
    cover: 'Copertina',
    groupName: 'Nome',
    enterGroupName: 'Inserisci il nome del gruppo',
    save: 'Salva',
    behaviour: 'Comportamento',
    behaviourPermanent: 'Permanente',
    behaviourPermanentHint: 'Sempre disponibile nel widget',
    behaviourDaily: 'Giornaliero',
    behaviourDailyHint: 'Segnato come visto una volta al giorno',
    behaviourOnce: 'Una volta',
    behaviourOnceHint: 'Nascosto dopo la visualizzazione',
    widgets: 'Widget',
    widgetsHint: 'In quali widget appare questo gruppo',
    noWidgets: 'Ancora nessun widget',
  },
};
